/* StickerMint Studio Next — main builder script, moved out of the section so it is not limited to 256 KB.
   Generated from sections/stickermint-sticker-lab-v2.liquid by .claude/build-studio-next.py. Liquid values come from window.SMN_CONFIG. */
(function(){
  'use strict';
  const state = {
    canvas: null, originalImg: null, processedImg: null,
    bgMode: 'none', size: '2x2', sizeInches: 2, qty: 50,
    cutStyle: 'tight', cutContourPath: null, cutContourPoints: null,
    smoothLevel: 'balanced',
    finish: 'matte', shape: 'die-cut', adjusting: false, lockMode: false, shapePortrait: false,
    borderColor: '#ffffff'
  };
  window._sms = state;
  var _smsAssetBase = window.SMN_CONFIG.assetBase;
  const $ = s => document.querySelector(s);
  const $$ = s => document.querySelectorAll(s);
  var D={stg:$('#stickerStage'),prev:$('#previewArea'),atc:$('#btnATCBottom'),dl:$('#btnDownload'),bgs:$('#bgStatus'),aBar:$('#adjustBar'),aHint:$('#adjustHint'),dz:$('#dropzone'),ttb:$('#smsTextToolbar'),qb:$('#smsQuickBar')};
  function _vo(){return state.canvas?state.canvas.getObjects().filter(function(o){return!o._isCutline}):[]}
  var studioVariants = [];
  studioVariants = window.SMN_CONFIG.variants || [];
  var pricingConfig = {
    material_rates: { matte: 0.115, glossy: 0.115, holographic: 0.155 },
    qty_multipliers: [
      [2, 12], [4, 9], [10, 4.5], [50, 1.5],
      [100, 1], [200, 0.95], [300, 0.92], [500, 0.89],
      [1000, 0.88], [2000, 0.85], [5000, 0.82]
    ]
  };
  if (window.SMN_CONFIG.pricingJson) { try { pricingConfig = JSON.parse(window.SMN_CONFIG.pricingJson); } catch(e){} }
  function calculatePrice(sizeInches, finish, qty){
    if(sizeInches <= 0) return { total: 0, unit: 0, label: 'Quote' };
    var rate = pricingConfig.material_rates[finish] || pricingConfig.material_rates.matte;
    var basePrice = sizeInches * rate;
    var mult = 1;
    var tiers = pricingConfig.qty_multipliers;
    for(var i = tiers.length - 1; i >= 0; i--){
      if(qty >= tiers[i][0]){ mult = tiers[i][1]; break; }
    }
    var rawTotal = basePrice * qty * mult;
    var total = Math.floor(rawTotal);
    var unit = total / qty;
    return { total: total, unit: unit, label: null };
  }
  function getMainImage(){
    if(!state.canvas) return null;
    return state.canvas.getObjects('image').find(o=>o._isMainImage) || state.canvas.getObjects('image')[0] || null;
  }
  function getMainContent(){
    if(!state.canvas) return null;
    var img=getMainImage(); if(img) return img;
    return state.canvas.getObjects().find(function(o){return !o._isCutline;}) || null;
  }
  const customSizePanel = $('#smsCustomSize');
  const customW = $('#smsCustomW');
  const customH = $('#smsCustomH');
  function getCustomSizeInches(){
    var w = parseFloat(customW.value) || 0;
    var h = parseFloat(customH.value) || 0;
    if(state.shape==='die-cut'&&w>0&&h>0&&state.canvas){
      var _lb=getLipBounds();
      if(_lb&&_lb.width>0&&_lb.height>0){var _s=Math.min(w/_lb.width,h/_lb.height);return +(Math.max(_lb.width,_lb.height)*_s).toFixed(2);}
    }
    return Math.max(w, h);
  }
  function _mo(){var M=window._smsMOR;if(!M)return;M.bump(state,null,window._specS||null);M.refresh(state.sizeInches,state.qty);}
  $$('.sms-size-radio[name="sms-size"]').forEach(r => {
    r.addEventListener('change', () => {
      state.size = r.value;
      if(r.value === 'custom'){
        customSizePanel.style.display = '';
        state.sizeInches = getCustomSizeInches();
      } else {
        customSizePanel.style.display = 'none';
        state.sizeInches = parseFloat(r.dataset.inches) || 0;
      }
      _mo('size');
      updatePrice();
      if(state.canvas){ updateDimLabel(); checkImageDpi(); }
    });
  });
  function onCustomSizeChange(){
    state.sizeInches = getCustomSizeInches();
    _mo('size');
    updatePrice();
    if(state.canvas){ updateDimLabel(); checkImageDpi(); }
  }
  customW.addEventListener('input', onCustomSizeChange);
  customH.addEventListener('input', onCustomSizeChange);
  const slider = $('#qtySlider'), qtyVal = $('#qtyVal');
  slider.addEventListener('input', () => { state.qty = parseInt(slider.value); qtyVal.value = state.qty; _mo('qty'); updatePresets(); updatePrice(); });
  qtyVal.addEventListener('change', () => { var m=state.sizeInches>0&&state.sizeInches<8?50:10; state.qty = Math.max(m, Math.min(state.sizeInches>=8?10:10000, parseInt(qtyVal.value)||m)); qtyVal.value = state.qty; slider.value = Math.min(state.qty,500); _mo('qty'); updatePresets(); updatePrice(); });
  $$('.sms-qty-pre').forEach(b => {
    b.addEventListener('click', () => { if(b.classList.contains('sms-locked'))return; state.qty = parseInt(b.dataset.qty); qtyVal.value = state.qty; slider.value = state.qty; _mo('qty'); updatePresets(); updatePrice(); });
  });
  _mo();
  function updatePresets(){ $$('.sms-qty-pre').forEach(b => b.classList.toggle('active', parseInt(b.dataset.qty)===state.qty)); }
  var _lastPriceTotal = -1;
  function updatePrice(){
    var p = calculatePrice(state.sizeInches, state.finish, state.qty);
    if(p.label){
      $('#totalPrice').textContent=p.label; $('#totalPriceLg').textContent=p.label; $('#unitPrice').textContent='Custom size';
      var badge=$('#smsSaveBadge'); if(badge) badge.style.display='none';
      _lastPriceTotal = -1;
      return;
    }
    var newTotal = p.total;
    $('#totalPrice').textContent='$'+p.total.toFixed(2);
    $('#totalPriceLg').textContent='$'+p.total.toFixed(2);
    $('#unitPrice').textContent='$'+p.unit.toFixed(2)+' each';
    if(_lastPriceTotal !== newTotal && _lastPriceTotal >= 0){
      var el = $('#totalPriceLg');
      el.classList.remove('sms-price-bump');
      void el.offsetWidth;
      el.classList.add('sms-price-bump');
    }
    _lastPriceTotal = newTotal;
    var badge=$('#smsSaveBadge');
    if(badge){
      var singleP = calculatePrice(state.sizeInches, state.finish, 2);
      if(!singleP.label && singleP.unit > 0 && p.unit < singleP.unit){
        var pct = Math.round((1 - p.unit/singleP.unit)*100);
        if(pct >= 5){ badge.textContent='Save '+pct+'%'; badge.style.display='inline-block'; }
        else { badge.style.display='none'; }
      } else { badge.style.display='none'; }
    }
  }
  var blankEl=$('#blankShape');
  function updateBlankShape(){
    if(!blankEl) return;
    blankEl.setAttribute('data-shape', state.shape);
    if(state.shape==='rectangle'){
      blankEl.style.width='320px';blankEl.style.height='200px';
    } else if(state.shape==='oval'){
      blankEl.style.width='300px';blankEl.style.height='210px';
    } else {
      blankEl.style.width='280px';blankEl.style.height='280px';
    }
  }
  function showBlankShape(){
    if(blankEl){blankEl.classList.remove('hidden');updateBlankShape();}
    ['vinylTexture','vinylSpecular','holoOverlay','glossLayer','glossOverlay','edgeRim','stickerDepth'].forEach(function(id){
      var el=$('#'+id);if(el) el.style.opacity='0';
    });
    var rH=$('#rulerH'),rV=$('#rulerV');
    if(rH) rH.style.display='none';
    if(rV) rV.style.display='none';
  }
  function hideBlankShape(){
    if(blankEl) blankEl.classList.add('hidden');
    ['vinylTexture','vinylSpecular','holoOverlay','glossLayer','glossOverlay','edgeRim','stickerDepth'].forEach(function(id){
      var el=$('#'+id);if(el) el.style.opacity='';
    });
    var rH=$('#rulerH'),rV=$('#rulerV');
    if(rH) rH.style.display='';
    if(rV) rV.style.display='';
  }
  if(blankEl) blankEl.addEventListener('click',function(){ $('#fileInput').click(); });
  updateBlankShape();
  showBlankShape();
  $$('.sms-shape-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const newShape=btn.dataset.shape;
      const sameShape=(newShape===state.shape);
      $$('.sms-shape-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      state.shape = newShape;
      if(!sameShape) state.shapePortrait = false;
      updateBlankShape();
      if(!state.canvas) return;
      var _hasContent=state.canvas.getObjects().some(function(o){return !o._isCutline;});
      if(!_hasContent) return;
      if(sameShape && newShape!=='die-cut' && !state.adjusting){
        const img=getMainImage();
        if(img){ unlockImage(img); img.setCoords(); state.canvas.setActiveObject(img); state.canvas.renderAll(); enterAdjustMode(); }
        return;
      }
      applyShape();
    });
  });
  function getShapeDims(){
    const c=state.canvas; if(!c) return [0,0];
    const off=getCutOffset();
    const isMob=window.innerWidth<=768;
    const maxDim=Math.min(c.getWidth(),c.getHeight())*(isMob?0.72:0.65)-off*2;
    if(state.shape==='circle'||state.shape==='square') return [maxDim,maxDim];
    if(state.shape==='rectangle'||state.shape==='oval'){
      if(state.size==='custom'){
        const cw=parseFloat($('#smsCustomW').value)||3;
        const ch=parseFloat($('#smsCustomH').value)||2;
        if(cw>=ch){
          return [maxDim, maxDim*(ch/cw)];
        } else {
          return [maxDim*(cw/ch), maxDim];
        }
      }
      const w=maxDim, h=maxDim*0.667;
      return state.shapePortrait ? [h,w] : [w,h];
    }
    return [maxDim,maxDim];
  }
  function createShapeClip(shape, shapeW, shapeH, cx, cy){
    if(shape==='circle') return new fabric.Circle({radius:shapeW/2, left:cx, top:cy, originX:'center', originY:'center', absolutePositioned:true});
    if(shape==='square') return new fabric.Rect({width:shapeW, height:shapeH, left:cx, top:cy, originX:'center', originY:'center', absolutePositioned:true});
    if(shape==='rectangle'){
      var rr=Math.min(shapeW,shapeH)*0.04;
      return new fabric.Rect({width:shapeW, height:shapeH, rx:rr, ry:rr, left:cx, top:cy, originX:'center', originY:'center', absolutePositioned:true});
    }
    if(shape==='oval') return new fabric.Ellipse({rx:shapeW/2, ry:shapeH/2, left:cx, top:cy, originX:'center', originY:'center', absolutePositioned:true});
    if(shape==='rounded-square'){
      var rr=Math.min(shapeW,shapeH)*0.18;
      return new fabric.Rect({width:shapeW, height:shapeH, rx:rr, ry:rr, left:cx, top:cy, originX:'center', originY:'center', absolutePositioned:true});
    }
    return null;
  }
  function applyShape(){
    if(!state.canvas) return;
    const c=state.canvas;
    const img=getMainImage();
    const content=img||getMainContent();
    if(!content) return;
    if(img) img.visible=true;
    c.getObjects().filter(o=>o._isCutline).forEach(o=>c.remove(o));
    c.getObjects().forEach(function(o){ if(!o._isCutline) o.clipPath=null; });
    state.cutContourPath=null; state.cutContourPoints=null;
    if(state.shape==='die-cut'){
      exitAdjustMode();
      if(img) lockImage(img);
      rescaleForBorder();
      drawCutline();
      c.renderAll();
      updateDimLabel();
      return;
    }
    const [shapeW, shapeH]=getShapeDims();
    const cx=c.getWidth()/2, cy=c.getHeight()/2;
    if(img){
      const clip=createShapeClip(state.shape, shapeW, shapeH, cx, cy);
      if(!clip) return;
      img.clipPath=clip;
      c.getObjects().forEach(function(o){
        if(o!==img && !o._isCutline){
          o.clipPath=createShapeClip(state.shape, shapeW, shapeH, cx, cy);
        }
      });
      const el=img.getElement();
      const imgW=el.naturalWidth||el.width, imgH=el.naturalHeight||el.height;
      /* Contain-fit: scale image to fit INSIDE the shape (preserves borders).
         Using Math.min so the larger dimension matches the shape exactly. */
      /* Studio Next fix: fit the VISIBLE art (alpha bounds), not the whole file. Background-removed images keep
         transparent padding; fitting the file made the art shrink inside the shape (thick ring on shared links). */
      var _smnAlphaBox=function(e){
        if(e._smnAB)return e._smnAB;var r=[0,0,1,1];
        try{var w=e.naturalWidth||e.width,h=e.naturalHeight||e.height,k=Math.min(1,400/Math.max(w,h)),cw=Math.max(1,Math.round(w*k)),ch=Math.max(1,Math.round(h*k));
          var cv=document.createElement('canvas');cv.width=cw;cv.height=ch;var x=cv.getContext('2d');x.drawImage(e,0,0,cw,ch);
          var d=x.getImageData(0,0,cw,ch).data,x0=cw,y0=ch,x1=-1,y1=-1;
          for(var yy=0;yy<ch;yy++)for(var xx=0;xx<cw;xx++)if(d[(yy*cw+xx)*4+3]>16){if(xx<x0)x0=xx;if(xx>x1)x1=xx;if(yy<y0)y0=yy;if(yy>y1)y1=yy;}
          if(x1>=x0&&y1>=y0)r=[x0/cw,y0/ch,(x1+1)/cw,(y1+1)/ch];}catch(_e){}
        e._smnAB=r;return r;};
      var _ab=_smnAlphaBox(el),_vw=Math.max(1,imgW*(_ab[2]-_ab[0])),_vh=Math.max(1,imgH*(_ab[3]-_ab[1]));
      var _ang=(img.angle||0)*Math.PI/180,_sw=Math.round((img.angle||0)/90)%2!==0;
      const fitScale=_sw?Math.min(shapeW/_vh,shapeH/_vw):Math.min(shapeW/_vw,shapeH/_vh);
      img.setCoords();var _p0=img.getCenterPoint(),_s0=img.scaleX||fitScale;
      var _ofx=((_ab[0]+_ab[2])/2-0.5)*imgW*fitScale*(img.flipX?-1:1),_ofy=((_ab[1]+_ab[3])/2-0.5)*imgH*fitScale*(img.flipY?-1:1);
      var _rx=_ofx*Math.cos(_ang)-_ofy*Math.sin(_ang),_ry=_ofx*Math.sin(_ang)+_ofy*Math.cos(_ang);
      img.set({left:cx-_rx, top:cy-_ry, originX:'center', originY:'center', scaleX:fitScale, scaleY:fitScale, _isMainImage:true});
      var _smnOthers=c.getObjects().filter(function(o){return o!==img&&!o._isCutline&&!o._isCutEdge&&!o._isScissorIcon&&!o._isTemplateBg&&o.visible!==false;});
      if(_smnOthers.length){
        /* Studio Next fix: keep text/overlays where they were relative to the art */
        var _k=fitScale/_s0,_round=state.shape==='circle'||state.shape==='oval',_need=1;
        _smnOthers.forEach(function(o){o.setCoords();var p=o.getCenterPoint();o.set({scaleX:o.scaleX*_k,scaleY:o.scaleY*_k});o.setPositionByOrigin(new fabric.Point(cx+(p.x-_p0.x)*_k,cy+(p.y-_p0.y)*_k),'center','center');o.setCoords();
          var r=o.getBoundingRect(true,true);[[r.left,r.top],[r.left+r.width,r.top],[r.left,r.top+r.height],[r.left+r.width,r.top+r.height]].forEach(function(q){
            var dx=(q[0]-cx)/(shapeW/2),dy=(q[1]-cy)/(shapeH/2),d=_round?Math.sqrt(dx*dx+dy*dy):Math.max(Math.abs(dx),Math.abs(dy));_need=Math.max(_need,d/0.94);});});
        if(_need>1){var _f=1/_need;[img].concat(_smnOthers).forEach(function(o){var p=o.getCenterPoint();o.set({scaleX:o.scaleX*_f,scaleY:o.scaleY*_f});o.setPositionByOrigin(new fabric.Point(cx+(p.x-cx)*_f,cy+(p.y-cy)*_f),'center','center');o.setCoords();});}
      }
      unlockImage(img);
      drawCutlineForShape(shapeW, shapeH, cx, cy);
      img.setCoords();
      c.setActiveObject(img);
      c.renderAll();
      updateDimLabel();
      enterAdjustMode();
    } else {
      c.getObjects().forEach(function(o){
        if(!o._isCutline){
          o.clipPath=createShapeClip(state.shape, shapeW, shapeH, cx, cy);
        }
      });
      drawCutlineForShape(shapeW, shapeH, cx, cy);
      c.renderAll();
      updateDimLabel();
    }
  }
  function drawCutlineForShape(shapeW, shapeH, cx, cy){
    if(!state.canvas) return;
    const c=state.canvas;
    const img=getMainImage();
    const content=img||getMainContent();
    if(!content) return;
    c.getObjects().filter(o=>o._isCutline).forEach(o=>c.remove(o));
    state.cutContourPath=null; state.cutContourPoints=null;
    const offset=getCutOffset();
    const imgIdx=img?c.getObjects().indexOf(img):0;
    const isNone=state.cutStyle==='none';
    const shadowFill=isNone?'rgba(0,0,0,0)':'#fff';
    if(state.shape==='circle'){
      const r=shapeW/2+offset;
      const props={left:cx,top:cy,originX:'center',originY:'center',radius:r,selectable:false,evented:false,_isCutline:true};
      if(!isNone){
        c.insertAt(new fabric.Circle(Object.assign({},props,{fill:'#fff',stroke:'none',
          shadow:new fabric.Shadow({color:'rgba(0,0,0,0.25)',blur:6,offsetX:1,offsetY:2})})),imgIdx);
        c.insertAt(new fabric.Circle(Object.assign({},props,{fill:state.borderColor,stroke:'rgba(0,0,0,0.08)',strokeWidth:0.5,
          shadow:new fabric.Shadow({color:'rgba(0,0,0,0.15)',blur:2,offsetX:1,offsetY:1})})),imgIdx+1);
      }
      const pts=[]; for(let i=0;i<64;i++){const a=i/64*Math.PI*2;pts.push([cx+r*Math.cos(a),cy+r*Math.sin(a)]);}
      state.cutContourPoints=pts;
      c.insertAt(new fabric.Circle(Object.assign({},props,{fill:'transparent',stroke:'#FF0000',strokeWidth:1,_isCutEdge:true})),c.getObjects().length);
      if(isNone)addScissorIcon(c,pts);
    } else if(state.shape==='oval'){
      const rx=shapeW/2+offset, ry=shapeH/2+offset;
      const props={left:cx,top:cy,originX:'center',originY:'center',rx:rx,ry:ry,selectable:false,evented:false,_isCutline:true};
      if(!isNone){
        c.insertAt(new fabric.Ellipse(Object.assign({},props,{fill:'#fff',stroke:'none',
          shadow:new fabric.Shadow({color:'rgba(0,0,0,0.25)',blur:6,offsetX:1,offsetY:2})})),imgIdx);
        c.insertAt(new fabric.Ellipse(Object.assign({},props,{fill:state.borderColor,stroke:'rgba(0,0,0,0.08)',strokeWidth:0.5,
          shadow:new fabric.Shadow({color:'rgba(0,0,0,0.15)',blur:2,offsetX:1,offsetY:1})})),imgIdx+1);
      }
      const pts=[]; for(let i=0;i<64;i++){const a=i/64*Math.PI*2;pts.push([cx+rx*Math.cos(a),cy+ry*Math.sin(a)]);}
      state.cutContourPoints=pts;
      c.insertAt(new fabric.Ellipse(Object.assign({},props,{fill:'transparent',stroke:'#FF0000',strokeWidth:1,_isCutEdge:true})),c.getObjects().length);
      if(isNone)addScissorIcon(c,pts);
    } else {
      const w=shapeW+offset*2, h=shapeH+offset*2;
      const rr=isNone?0:(state.shape==='rounded-square'?Math.min(w,h)*0.18:Math.min(w,h)*0.04);
      const props={left:cx,top:cy,originX:'center',originY:'center',width:w,height:h,rx:rr,ry:rr,selectable:false,evented:false,_isCutline:true};
      if(!isNone){
        c.insertAt(new fabric.Rect(Object.assign({},props,{fill:'#fff',stroke:'none',
          shadow:new fabric.Shadow({color:'rgba(0,0,0,0.25)',blur:6,offsetX:1,offsetY:2})})),imgIdx);
        c.insertAt(new fabric.Rect(Object.assign({},props,{fill:state.borderColor,stroke:'rgba(0,0,0,0.08)',strokeWidth:0.5,
          shadow:new fabric.Shadow({color:'rgba(0,0,0,0.15)',blur:2,offsetX:1,offsetY:1})})),imgIdx+1);
      }
      const l=cx-w/2,t=cy-h/2,r2=cx+w/2,b2=cy+h/2;
      const pts=[];
      if(rr>0){
        const cp=8;
        for(let i=0;i<=cp;i++){const a=Math.PI+i/cp*Math.PI/2;pts.push([l+rr+rr*Math.cos(a),t+rr+rr*Math.sin(a)]);}
        for(let i=0;i<=cp;i++){const a=Math.PI*1.5+i/cp*Math.PI/2;pts.push([r2-rr+rr*Math.cos(a),t+rr+rr*Math.sin(a)]);}
        for(let i=0;i<=cp;i++){const a=i/cp*Math.PI/2;pts.push([r2-rr+rr*Math.cos(a),b2-rr+rr*Math.sin(a)]);}
        for(let i=0;i<=cp;i++){const a=Math.PI/2+i/cp*Math.PI/2;pts.push([l+rr+rr*Math.cos(a),b2-rr+rr*Math.sin(a)]);}
      } else {
        for(let ri=0;ri<=16;ri++) pts.push([l+ri*(w/16),t]);
        for(let ri=0;ri<=16;ri++) pts.push([r2,t+ri*(h/16)]);
        for(let ri=0;ri<=16;ri++) pts.push([r2-ri*(w/16),b2]);
        for(let ri=0;ri<=16;ri++) pts.push([l,b2-ri*(h/16)]);
      }
      state.cutContourPoints=pts;
      c.insertAt(new fabric.Rect(Object.assign({},props,{fill:'transparent',stroke:'#FF0000',strokeWidth:1,_isCutEdge:true})),c.getObjects().length);
      if(isNone)addScissorIcon(c,pts);
    }
    if(!_cutVis&&state.cutStyle!=='none')c.getObjects().forEach(function(o){if(o._isCutEdge)o.visible=false;});
    c.renderAll();
    positionOverlays();
    updateDimLabel();
  }
  function enterAdjustMode(){
    state.adjusting=true;setCutVis(true);
    const stage=D.stg;
    stage.style.transform='scale('+(typeof zoomLevel!=='undefined'?zoomLevel:defaultZoom)+') rotateX(0) rotateY(0)';
    D.aBar.classList.add('visible');
    $('#btnRotate90').style.display=(state.shape==='rectangle'||state.shape==='oval')?'':'none';
    D.aHint.classList.add('visible');
    setTimeout(()=>D.aHint.classList.remove('visible'),3000);
  }
  function addEditGlow(obj){if(obj && !obj._isCutline) obj.set({borderColor:'#2893F2',borderScaleFactor:2,borderDashArray:[6,4],cornerColor:'#2893F2',cornerStrokeColor:'#2893F2',hasBorders:true});}
  function removeEditGlow(obj){if(obj) obj.set({borderColor:'rgba(102,153,255,0.75)',borderScaleFactor:1,borderDashArray:null,cornerColor:'rgba(102,153,255,0.5)',cornerStrokeColor:'rgba(102,153,255,0.5)',hasBorders:false});}
  function _isSys(o){return o&&(o._isCutline||o._isCutEdge||o._isScissorIcon);}
  function _hitTest(e){if(!state.canvas)return null;var p=state.canvas.getPointer(e),objs=state.canvas.getObjects();for(var i=objs.length-1;i>=0;i--){var o=objs[i];if(!_isSys(o)&&o.containsPoint(p))return o;}return null;}
  function _unlockObj(o){_allLocked=false;var stg=D.stg;if(stg)stg.style.transform='scale('+(typeof zoomLevel!=='undefined'?zoomLevel:defaultZoom)+') rotateX(0) rotateY(0)';o.set({selectable:true,evented:true,hasControls:true,hasBorders:true,lockScalingX:false,lockScalingY:false,lockMovementX:false,lockMovementY:false,lockRotation:false});o.setControlsVisibility({tl:true,tr:true,bl:true,br:true,mtr:false,ml:false,mr:false,mt:false,mb:false});addEditGlow(o);o.setCoords();state.canvas.setActiveObject(o);state.canvas.renderAll();if(window._sl2ShowCtx)window._sl2ShowCtx(o);}
  /* Add `sms-interacting` body class during canvas drag/resize so CSS can
     pause expensive overlay rendering + transitions for a snappy feel. */
  function _setupPerfInteractionHooks(){
    if(!state.canvas||state.canvas._smsPerfHooked) return;
    state.canvas._smsPerfHooked=true;
    var _intTimer=null;
    function _onStart(){
      document.body.classList.add('sms-interacting');
      if(_intTimer){clearTimeout(_intTimer);_intTimer=null;}
    }
    function _onEnd(){
      if(_intTimer)clearTimeout(_intTimer);
      _intTimer=setTimeout(function(){document.body.classList.remove('sms-interacting');},120);
    }
    state.canvas.on('mouse:down',_onStart);
    state.canvas.on('mouse:up',_onEnd);
    state.canvas.on('object:moving',_onStart);
    state.canvas.on('object:scaling',_onStart);
    state.canvas.on('object:rotating',_onStart);
    state.canvas.on('object:modified',_onEnd);
    var uc=state.canvas.upperCanvasEl;
    if(uc){
      uc.addEventListener('touchstart',_onStart,{passive:true});
      uc.addEventListener('touchend',_onEnd,{passive:true});
      uc.addEventListener('touchcancel',_onEnd,{passive:true});
    }
  }
  function setupLockHandlers(){
    if(!state.canvas)return;
    _setupPerfInteractionHooks();
    state.canvas.on('mouse:down',function(opt){
      if(state.lockMode)return;
      if(opt.target&&!_isSys(opt.target))return;
      if(_hitTest(opt.e))return;
      if(state.adjusting)exitAdjustMode();else{lockAllObjects();if(window._sl2HideCtx)window._sl2HideCtx();}
    });
    state.canvas.upperCanvasEl.addEventListener('dblclick',function(e){
      if(state.lockMode)return;
      var ao=state.canvas.getActiveObject();
      if(ao&&!_isSys(ao))return;
      var hit=_hitTest(e);
      if(hit)_unlockObj(hit);
    });
  }
  var _allLocked=false;
  function lockAllObjects(){
    if(!state.canvas) return;
    _allLocked=true;
    state.canvas.getObjects().forEach(function(o){
      if(o._isCutline||o._isCutEdge||o._isScissorIcon) return;
      o.set({hasControls:false,hasBorders:false,selectable:false,evented:false,
        lockScalingX:true,lockScalingY:true,lockMovementX:true,lockMovementY:true,lockRotation:true,
        borderColor:'rgba(102,153,255,0.75)',borderScaleFactor:1,borderDashArray:null});
    });
    state.canvas.discardActiveObject();
    state.canvas.renderAll();
  }
  window._sl2LockAll=lockAllObjects;
  function exitAdjustMode(){
    state.adjusting=false;setCutVis(false);
    D.aBar.classList.remove('visible');
    D.aHint.classList.remove('visible');
    if(window._sl2HideCtx)window._sl2HideCtx();
    var _qb=D.qb;if(_qb)_qb.style.display='none';
    var _ttb=D.ttb;if(_ttb)_ttb.style.display='none';
    lockAllObjects();
  }
  $('#btnDoneAdjust').addEventListener('click', function(){
    if(state.lockMode) exitLockMode(); else exitAdjustMode();
    if(state.shape==='die-cut'){_drawingCutline=false;requestAnimationFrame(function(){try{drawCutline();}catch(e){console.error('[done-adjust]',e);}});}
    saveState();
  });
  function enterLockMode(){
    if(state.lockMode) return;
    state.lockMode=true;
    state.adjusting=true;setCutVis(true);
    var stage=D.stg;
    stage.style.transform='scale('+(typeof zoomLevel!=='undefined'?zoomLevel:defaultZoom)+') rotateX(0) rotateY(0)';
    $('#btnRotate90').style.display='none';
    D.aBar.classList.add('visible');
    D.aHint.classList.remove('visible');
  }
  function exitLockMode(){
    state.lockMode=false;
    state.adjusting=false;setCutVis(false);
    D.aBar.classList.remove('visible');
    D.aHint.classList.remove('visible');
    if(window._sl2HideCtx)window._sl2HideCtx();
    var tb=D.ttb;if(tb)tb.style.display='none';
    var qb=D.qb;if(qb)qb.style.display='none';
    lockAllObjects();
  }
  $('#btnRotate90').addEventListener('click', function(){
    if(!state.canvas) return;
    if(state.shape!=='rectangle' && state.shape!=='oval') return;
    state.shapePortrait=!state.shapePortrait;
    applyShape();
  });
  function setupDblClickAdjust(){
    if(!state.canvas) return;
    state.canvas.on('mouse:dblclick', function(){
      if(state.shape==='die-cut' || state.adjusting) return;
      const img=getMainImage(); if(!img) return;
      unlockImage(img);
      img.setCoords();
      state.canvas.setActiveObject(img);
      state.canvas.renderAll();
      enterAdjustMode();
    });
  }
  function _centerContent(){
    if(!state.canvas)return;
    var objs=_vo();
    if(!objs.length)return;
    var minL=Infinity,minT=Infinity,maxR=-Infinity,maxB=-Infinity;
    objs.forEach(function(o){var br=o.getBoundingRect();if(br.left<minL)minL=br.left;if(br.top<minT)minT=br.top;if(br.left+br.width>maxR)maxR=br.left+br.width;if(br.top+br.height>maxB)maxB=br.top+br.height;});
    var dx=(state.canvas.width-(maxR-minL))/2-minL,dy=(state.canvas.height-(maxB-minT))/2-minT;
    objs.forEach(function(o){o.set({left:o.left+dx,top:o.top+dy});o.setCoords();});
    state.canvas.renderAll();
  }
  function setupMobileGestures(){
    if(!state.canvas) return;
    var upperCanvas=state.canvas.upperCanvasEl;
    if(!upperCanvas) return;
    var lastDist=0,isPinching=false;
    function getTouchDist(t1,t2){var dx=t1.clientX-t2.clientX,dy=t1.clientY-t2.clientY;return Math.sqrt(dx*dx+dy*dy);}
    upperCanvas.addEventListener('touchstart',function(e){
      if(e.touches.length===2){
        e.preventDefault();isPinching=true;
        lastDist=getTouchDist(e.touches[0],e.touches[1]);
      }
    },{passive:false});
    upperCanvas.addEventListener('touchmove',function(e){
      if(e.touches.length===2 && isPinching){
        e.preventDefault();
        var newDist=getTouchDist(e.touches[0],e.touches[1]);
        if(lastDist>0){
          var ratio=newDist/lastDist;
          zoomLevel=Math.max(0.25,Math.min(3,zoomLevel*ratio));
          applyZoom();
        }
        lastDist=newDist;
      }
    },{passive:false});
    upperCanvas.addEventListener('touchend',function(e){
      if(e.touches.length<2&&isPinching){isPinching=false;}
      lastDist=0;
    },{passive:true});
    var _lpTimer=0;
    upperCanvas.addEventListener('touchstart',function(e){
      if(e.touches.length!==1||isPinching)return;
      var _lpX=e.touches[0].clientX,_lpY=e.touches[0].clientY;
      _lpTimer=setTimeout(function(){
        var cr=state.canvas.upperCanvasEl.getBoundingClientRect();
        var sx=state.canvas.width/cr.width,sy=state.canvas.height/cr.height;
        var cx=(_lpX-cr.left)*sx,cy=(_lpY-cr.top)*sy;
        var obj=null,objs=state.canvas.getObjects();
        for(var i=objs.length-1;i>=0;i--){
          var o=objs[i];if(_isSys(o))continue;
          var br=o.getBoundingRect();
          if(cx>=br.left&&cx<=br.left+br.width&&cy>=br.top&&cy<=br.top+br.height){obj=o;break;}
        }
        if(!obj)obj=getMainImage()||getMainContent();
        if(obj)_unlockObj(obj);
      },500);
    },{passive:true});
    upperCanvas.addEventListener('touchmove',function(){clearTimeout(_lpTimer);},{passive:true});
    upperCanvas.addEventListener('touchend',function(){clearTimeout(_lpTimer);},{passive:true});
  }
  $$('.sms-finish-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      $$('.sms-finish-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      state.finish = btn.dataset.finish;
      updatePrice();
      applyFinish();
    });
  });
  function applyFinish(){
    const stage = D.stg;
    const canvas = stage.querySelector('canvas');
    stage.classList.remove('finish-glossy','finish-holographic');
    const holo=$('#holoOverlay'), glossL=$('#glossLayer'), glossO=$('#glossOverlay');
    if(holo){ holo.style.opacity=''; holo.style.backgroundPosition=''; }
    if(glossL){ glossL.style.opacity=''; glossL.style.background=''; glossL.style.backgroundPosition=''; }
    if(glossO){ glossO.style.opacity=''; glossO.style.background=''; }
    if(canvas){ canvas.style.mixBlendMode=''; canvas.style.filter=''; }
    if(state.finish === 'glossy') stage.classList.add('finish-glossy');
    if(state.finish === 'holographic') stage.classList.add('finish-holographic');
    if(blankEl){
      blankEl.classList.remove('finish-glossy','finish-holographic');
      if(state.finish==='glossy') blankEl.classList.add('finish-glossy');
      if(state.finish==='holographic') blankEl.classList.add('finish-holographic');
    }
    if(blankEl && !blankEl.classList.contains('hidden')){
      ['holoOverlay','glossLayer','glossOverlay','vinylTexture','vinylSpecular','edgeRim','stickerDepth'].forEach(function(id){
        var el=$('#'+id);if(el) el.style.opacity='0';
      });
    }
  }
  $('#btnBrowse').addEventListener('click', e => { e.stopPropagation(); $('#fileInput').click(); });
  if($('#btnUploadNew')) $('#btnUploadNew').addEventListener('click', () => { $('#fileInput').click(); });
  if($('#btnChangeImg')) $('#btnChangeImg').addEventListener('click', () => { $('#fileInput').value=''; $('#fileInput').click(); });
  D.dz.addEventListener('click', e => { if(e.target.id!=='btnBrowse') $('#fileInput').click(); });
  $('#fileInput').addEventListener('change', e => { if(e.target.files[0]) loadImage(e.target.files[0]); });
  const dz = D.dz;
  dz.addEventListener('dragover', e => { e.preventDefault(); dz.classList.add('dragover'); });
  dz.addEventListener('dragleave', () => dz.classList.remove('dragover'));
  dz.addEventListener('drop', e => { e.preventDefault(); dz.classList.remove('dragover'); if(e.dataTransfer.files[0]) loadImage(e.dataTransfer.files[0]); });
  if(blankEl){
    blankEl.addEventListener('dragover',function(e){e.preventDefault();blankEl.style.borderColor='#00c9a7';blankEl.style.background='rgba(0,201,167,0.04)';});
    blankEl.addEventListener('dragleave',function(){blankEl.style.borderColor='';blankEl.style.background='';});
    blankEl.addEventListener('drop',function(e){e.preventDefault();blankEl.style.borderColor='';blankEl.style.background='';if(e.dataTransfer.files[0]) loadImage(e.dataTransfer.files[0]);});
  }
  function loadImage(file){
    if(!file.type.startsWith('image/'))return;
    if(file.size>25*1024*1024){alert('Max 25MB.');return;}
    showProgress('Loading...');
    var isSvg=file.type==='image/svg+xml'||file.name.endsWith('.svg');
    var reader=new FileReader();
    reader.onload=function(e){
      var img=new Image();
      img.onload=function(){
        var go=function(fi){
        state.originalImg=fi;state.processedImg=null;state.bgMode='none';
        $$('.sms-tool-icon[data-bg]').forEach(function(o){o.classList.remove('active');});
        $('.sms-tool-icon[data-bg="none"]').classList.add('active');
        D.bgs.textContent='';dz.style.display='none';hideBlankShape();
        D.prev.classList.add('visible');
        if($('#btnChangeImg'))$('#btnChangeImg').style.display='';
        initCanvas(fi);hideProgress();
        var stg=D.stg;if(stg){stg.classList.remove('sms-enter');void stg.offsetWidth;stg.classList.add('sms-enter');}
        D.atc.disabled=false;D.dl.disabled=false;D.dl.style.display='';$('#btnShareLink').disabled=false;
        $('#btnShareLink').style.display='';$('#btnStartFresh').style.display='';$('#btnStartFresh').disabled=false;
        $('#smsAutoSaveIndicator').style.display='';$('#smsZoomControls').style.display='flex';
        updateDeleteBtn();updateStartOverBtn();initShareSession();checkImageDpi();
        };if(isSvg&&window._rasterSvg){window._rasterSvg(img,go);}else{go(img);}
      };img.src=e.target.result;
    };reader.readAsDataURL(file);
  }
  $('#btnAddImage').addEventListener('click', ()=>{ $('#addImageInput').value=''; $('#addImageInput').click(); });
  $('#addImageInput').addEventListener('change', e=>{ if(e.target.files[0]) addImageToCanvas(e.target.files[0]); });
  function addImageToCanvas(file){
    if(!file.type.startsWith('image/')) return;
    if(file.size>25*1024*1024){ alert('Max 25MB.'); return; }
    if(!state.canvas){ loadImage(file); return; }
    showProgress('Adding image...');
    const reader=new FileReader();
    reader.onload=function(e){
      const img=new Image();
      img.onload=function(){
        const c=state.canvas;
        const cw=c.getWidth(), ch=c.getHeight();
        const maxDim=Math.min(cw,ch)*0.4;
        const s=Math.min(maxDim/img.width, maxDim/img.height, 1);
        const fImg=new fabric.Image(img,{
          left:cw/2, top:ch/2, originX:'center', originY:'center',
          scaleX:s, scaleY:s
        });
        unlockImage(fImg);
        c.add(fImg);
        c.setActiveObject(fImg);
        c.renderAll();
        if(state.shape==='die-cut') drawCutline();
        autoFitView();
        saveState();
        hideProgress();
        updateDeleteBtn(); updateStartOverBtn();
      };
      img.src=e.target.result;
    };
    reader.readAsDataURL(file);
  }
  function autoFitView(){
    if(!state.canvas) return;var c=state.canvas;
    var vo=_vo(); if(!vo.length) return;
    var area=document.querySelector('.sms-canvas-area');if(!area) return;
    var aW=area.clientWidth||window.innerWidth,aH=area.clientHeight||(window.innerHeight-140);
    var minL=Infinity,minT=Infinity,maxR=-Infinity,maxB=-Infinity;
    vo.forEach(function(o){o.setCoords();var br=o.getBoundingRect();minL=Math.min(minL,br.left);minT=Math.min(minT,br.top);maxR=Math.max(maxR,br.left+br.width);maxB=Math.max(maxB,br.top+br.height);});
    var tW=maxR-minL,tH=maxB-minT;if(tW<1||tH<1) return;
    var _mob=window.innerWidth<=768;
    var padLR=_mob?50:Math.max(60,Math.round(aW*0.18));
    var padTB=_mob?40:Math.max(50,Math.round(aH*0.15));
    var nW=Math.max(Math.round(tW+padLR*2),aW),nH=Math.max(Math.round(tH+padTB*2),Math.round(aH*0.7));
    var shX=Math.round(nW/2-(minL+maxR)/2),shY=Math.round(nH/2-(minT+maxB)/2);
    if(Math.abs(shX)<2&&Math.abs(shY)<2&&Math.abs(c.getWidth()-nW)<2&&Math.abs(c.getHeight()-nH)<2){
      if(!_cutVis&&state.cutStyle!=='none')c.getObjects().forEach(function(o){if(o._isCutEdge)o.visible=false;});
      c.renderAll();positionOverlays();updateDimLabel();
      var _tr0=_mob?0.90:0.70;
      var _iZ0=Math.min(_tr0*aW/tW,_tr0*aH/tH);
      /* Hard cap: canvas (image + padding) must fit fully in viewport,
         else tall images overflow. Take the smaller of "fill 80%" and "fit". */
      var _fit0=Math.min(aW/nW,aH/nH);
      defaultZoom=Math.min(Math.max(Math.min(_iZ0,_fit0),0.3),2.5);
      zoomLevel=defaultZoom;applyZoom();return;
    }
    var allObjs=c.getObjects();
    allObjs.forEach(function(o){o.set({left:o.left+shX,top:o.top+shY});o.setCoords();});
    if(state.cutContourPoints&&(shX||shY)) state.cutContourPoints=state.cutContourPoints.map(function(p){return[p[0]+shX,p[1]+shY];});
    if(state.cutContourPath&&(shX||shY)) state.cutContourPath=state.cutContourPath.replace(/(-?\d+\.?\d*)\s+(-?\d+\.?\d*)/g,function(m,x,y){return(parseFloat(x)+shX)+' '+(parseFloat(y)+shY);});
    c.setWidth(nW);c.setHeight(nH);
    var _stg=D.stg;if(_stg){_stg.style.width=nW+'px';_stg.style.height=nH+'px';}
    if(state.shape!=='die-cut'){var sd=getShapeDims();var ncx=nW/2,ncy=nH/2;allObjs.forEach(function(o){if(!o._isCutline)o.clipPath=createShapeClip(state.shape,sd[0],sd[1],ncx,ncy);});allObjs.filter(function(o){return o._isCutline;}).forEach(function(o){c.remove(o);});drawCutlineForShape(sd[0],sd[1],ncx,ncy);}
    if(!_cutVis&&state.cutStyle!=='none')c.getObjects().forEach(function(o){if(o._isCutEdge)o.visible=false;});
    /* Adaptive default zoom: sticker fills ~80% of canvas area on mobile,
       ~70% on desktop. Cap by canvas-fit so tall/wide images don't overflow.
       Scales naturally with monitor size. Bounded 30%-250%. */
    var _targetRatio=_mob?0.90:0.70;
    var _idealZoom=Math.min(_targetRatio*aW/tW,_targetRatio*aH/tH);
    var _fitZoom=Math.min(aW/nW,aH/nH);
    defaultZoom=Math.min(Math.max(Math.min(_idealZoom,_fitZoom),0.3),2.5);
    c.renderAll();positionOverlays();updateDimLabel();zoomLevel=defaultZoom;applyZoom();
  }
  var _cutVis=false;
  function setCutVis(v){_cutVis=v;if(!state.canvas)return;var forceOn=state.cutStyle==='none';state.canvas.getObjects().forEach(function(o){if(o._isCutEdge)o.visible=v||forceOn;});state.canvas.renderAll();}
  const history = { states:[], idx:-1, maxLen:30, recording:true };
  function saveState(){ if(!history.recording||!state.canvas) return; var c=state.canvas; const j=c.toJSON(['_isCutline','_isCutEdge','_isMainImage','_isTemplateBg']); var entry=JSON.stringify({c:j,cp:state.cutContourPoints||null,cs:state.cutContourPath||null,cw:c.getWidth(),ch:c.getHeight()}); history.states=history.states.slice(0,history.idx+1); history.states.push(entry); if(history.states.length>history.maxLen)history.states.shift(); history.idx=history.states.length-1; updateUndoRedoBtns(); }
  function undo(){ if(history.idx<=0||!state.canvas) return; history.idx--; loadCanvasState(history.states[history.idx]); }
  function redo(){ if(history.idx>=history.states.length-1||!state.canvas) return; history.idx++; loadCanvasState(history.states[history.idx]); }
  function loadCanvasState(j){ history.recording=false; var parsed=JSON.parse(j); var canvasJson=parsed.c||parsed; if(parsed.c){state.cutContourPoints=parsed.cp||null;state.cutContourPath=parsed.cs||null;} if(parsed.cw&&parsed.ch){state.canvas.setWidth(parsed.cw);state.canvas.setHeight(parsed.ch);var _stg=D.stg;if(_stg){_stg.style.width=parsed.cw+'px';_stg.style.height=parsed.ch+'px';}} state.canvas.loadFromJSON(canvasJson,()=>{ if(!_cutVis&&state.cutStyle!=='none')state.canvas.getObjects().forEach(function(o){if(o._isCutEdge)o.visible=false;}); state.canvas.getObjects('image').forEach(f=>{ if(state.shape==='die-cut'&&f._isMainImage) lockImage(f); else unlockImage(f); }); if(state.shape!=='die-cut'){var sd=getShapeDims();var cx=state.canvas.getWidth()/2,cy=state.canvas.getHeight()/2;var img=getMainImage();if(img){var el=img.getElement();var iw=el.naturalWidth||el.width,ih=el.naturalHeight||el.height;var cs=Math.max(sd[0]/iw,sd[1]/ih)*1.05;img.set({left:cx,top:cy,originX:'center',originY:'center',scaleX:cs,scaleY:cs});img.setCoords();}state.canvas.getObjects().filter(function(o){return o._isCutline;}).forEach(function(o){state.canvas.remove(o);});state.canvas.getObjects().forEach(function(o){if(!o._isCutline){o.clipPath=createShapeClip(state.shape,sd[0],sd[1],cx,cy);}});drawCutlineForShape(sd[0],sd[1],cx,cy);} state.canvas.renderAll(); positionOverlays(); updateDimLabel(); history.recording=true; updateUndoRedoBtns(); }); }
  function updateUndoRedoBtns(){ const u=$('#btnUndo'),r=$('#btnRedo'); if(history.idx>0){u.classList.remove('disabled');u.disabled=false;}else{u.classList.add('disabled');u.disabled=true;} if(history.idx<history.states.length-1){r.classList.remove('disabled');r.disabled=false;}else{r.classList.add('disabled');r.disabled=true;} }
  var SMN_BORDER_MM={tight:1.6,medium:2.8,loose:4.4};
  /* canvas px per printed inch of the die-cut art (content box, before the border is added) */
  function _smnPxPerIn(){
    var c=state.canvas;if(!c||state.shape!=='die-cut')return 0;
    var os=_vo().filter(function(o){return !o._isCutEdge&&!o._isScissorIcon&&!o._isTemplateBg&&o.visible!==false;});
    if(!os.length)return 0;
    var x0=1e9,y0=1e9,x1=-1e9,y1=-1e9;
    os.forEach(function(o){var r=o.getBoundingRect();x0=Math.min(x0,r.left);y0=Math.min(y0,r.top);x1=Math.max(x1,r.left+r.width);y1=Math.max(y1,r.top+r.height);});
    var b=(SMN_BORDER_MM[state.cutStyle]||0)/25.4,sz=state.sizeInches||2;
    return Math.max(x1-x0,y1-y0)/Math.max(0.25,sz-2*b);
  }
  function _smnEdgeTextPx(){var p=_smnPxPerIn();return p?Math.max(1.5,0.5/25.4*p):3;}
  function getCutOffset(){
    if(state.cutStyle==='none')return -1;
    var legacy=state.cutStyle==='tight'?8:state.cutStyle==='medium'?14:22,mm=SMN_BORDER_MM[state.cutStyle],p=_smnPxPerIn();
    return (mm&&p)?Math.max(2,mm/25.4*p):legacy;
  }
  window._smnCutOffset=getCutOffset;
  function getSmoothMultiplier(){ return state.smoothLevel==='sharp'?0.3:state.smoothLevel==='smooth'?1.0:state.smoothLevel==='max'?1.6:0.6; }
  function rescaleForBorder(){
    if(!state.canvas) return;
    const img=getMainImage(); if(!img) return;
    if(_vo().length>1) return;
    const el=img.getElement(); if(!el) return;
    const c=state.canvas, off=getCutOffset();
    const absOff=Math.abs(off);
    const avail=off<0 ? 0.8 : 0.8;
    const s=Math.min((c.width*avail-absOff*2)/el.width,(c.height*avail-absOff*2)/el.height,1);
    img.set({
      scaleX:s, scaleY:s,
      left:c.width/2, top:c.height/2,
      originX:'center', originY:'center'
    });
    img.setCoords(); c.renderAll();
  }
  function lockImage(f){ f.set({hasControls:false,hasBorders:false,lockScalingX:true,lockScalingY:true,lockMovementX:true,lockMovementY:true,lockRotation:true,selectable:false,evented:false,borderColor:'#2893F2',borderScaleFactor:1.5}); f.setControlsVisibility({mtr:false,tl:false,tr:false,bl:false,br:false,ml:false,mr:false,mt:false,mb:false}); }
  function makeArrowRender(angle){
    return function(ctx,left,top,styleOverride,fabricObj){
      ctx.save(); ctx.translate(left,top); ctx.rotate(angle*Math.PI/180);
      ctx.beginPath(); ctx.arc(0,0,12,0,Math.PI*2);
      ctx.fillStyle='#fff'; ctx.shadowColor='rgba(0,0,0,0.25)'; ctx.shadowBlur=8; ctx.shadowOffsetY=2;
      ctx.fill(); ctx.shadowBlur=0; ctx.shadowOffsetY=0;
      ctx.strokeStyle='#00c9a7'; ctx.lineWidth=2.5; ctx.stroke();
      ctx.strokeStyle='#00c9a7'; ctx.lineWidth=1.8; ctx.lineCap='round'; ctx.lineJoin='round';
      ctx.beginPath();
      ctx.moveTo(-4.5,0); ctx.lineTo(4.5,0);
      ctx.moveTo(2,-2.5); ctx.lineTo(4.5,0); ctx.lineTo(2,2.5);
      ctx.moveTo(-2,-2.5); ctx.lineTo(-4.5,0); ctx.lineTo(-2,2.5);
      ctx.stroke(); ctx.restore();
    };
  }
  function renderMoveIcon(ctx,left,top){
    ctx.save(); ctx.translate(left,top);
    ctx.beginPath(); ctx.arc(0,0,14,0,Math.PI*2);
    ctx.fillStyle='#fff'; ctx.shadowColor='rgba(0,0,0,0.25)'; ctx.shadowBlur=8; ctx.shadowOffsetY=2;
    ctx.fill(); ctx.shadowBlur=0; ctx.shadowOffsetY=0;
    ctx.strokeStyle='#00c9a7'; ctx.lineWidth=2.5; ctx.stroke();
    ctx.strokeStyle='#00c9a7'; ctx.lineWidth=1.6; ctx.lineCap='round'; ctx.lineJoin='round';
    const a=5;
    ctx.beginPath();
    ctx.moveTo(-a,0); ctx.lineTo(a,0);
    ctx.moveTo(a-2,-2); ctx.lineTo(a,0); ctx.lineTo(a-2,2);
    ctx.moveTo(-a+2,-2); ctx.lineTo(-a,0); ctx.lineTo(-a+2,2);
    ctx.moveTo(0,-a); ctx.lineTo(0,a);
    ctx.moveTo(-2,a-2); ctx.lineTo(0,a); ctx.lineTo(2,a-2);
    ctx.moveTo(-2,-a+2); ctx.lineTo(0,-a); ctx.lineTo(2,-a+2);
    ctx.stroke(); ctx.restore();
  }
  function unlockImage(f){
    f.set({hasControls:true,hasBorders:true,lockScalingX:false,lockScalingY:false,
      lockMovementX:false,lockMovementY:false,lockRotation:true,selectable:true,evented:true,
      borderColor:'rgba(0,201,167,0.6)',borderDashArray:[5,3],borderScaleFactor:2,
      cornerSize:24,cornerStyle:'circle',cornerColor:'#fff',cornerStrokeColor:'#00c9a7',
      transparentCorners:false,lockUniScaling:true,padding:0});
    f.setControlsVisibility({mtr:false,ml:false,mr:false,mt:false,mb:false,tl:true,tr:true,bl:true,br:true});
    var angles={tl:-45,tr:45,bl:135,br:-135};
    Object.keys(angles).forEach(function(k){
      if(f.controls[k]) f.controls[k].render=makeArrowRender(angles[k]);
    });
  }
  function getSelectedSize(){
    const v=state.size;
    if(v==='custom'){
      const cw=parseFloat(customW.value)||2, ch=parseFloat(customH.value)||2;
      return [cw,ch];
    }
    const m=v.match(/(\d+)/), d=m?parseInt(m[1]):2;
    if(state.shape==='circle'||state.shape==='square') return [d,d];
    if(state.shape==='rectangle'||state.shape==='oval'){
      const w=d, h=+(d*0.667).toFixed(1);
      return state.shapePortrait ? [h,w] : [w,h];
    }
    if(!state.originalImg) return[d,d];
    const w=state.originalImg.naturalWidth||state.originalImg.width, h=state.originalImg.naturalHeight||state.originalImg.height, a=w/h;
    return a>=1?[d,+(d/a).toFixed(1)]:[+(d*a).toFixed(1),d];
  }
  function getLipBounds(){
    if(!state.canvas) return null;
    const c=state.canvas;
    if(state.shape==='die-cut'&&state.cutContourPath&&(state.cutContourPath.match(/M /g)||[]).length>1){
      var _nums=(state.cutContourPath.match(/-?\d+(?:\.\d+)?/g)||[]).map(Number),_a=1e9,_b=1e9,_c=-1e9,_d=-1e9;
      for(var _i=0;_i+1<_nums.length;_i+=2){_a=Math.min(_a,_nums[_i]);_c=Math.max(_c,_nums[_i]);_b=Math.min(_b,_nums[_i+1]);_d=Math.max(_d,_nums[_i+1]);}
      if(_c>_a&&_d>_b) return {left:_a, top:_b, width:_c-_a, height:_d-_b};
    }
    if(state.cutContourPoints && state.cutContourPoints.length>=3){
      let minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
      state.cutContourPoints.forEach(function(p){
        if(p[0]<minX) minX=p[0]; if(p[0]>maxX) maxX=p[0];
        if(p[1]<minY) minY=p[1]; if(p[1]>maxY) maxY=p[1];
      });
      return {left:minX, top:minY, width:maxX-minX, height:maxY-minY};
    }
    const cutlines=c.getObjects().filter(function(o){return o._isCutline;});
    if(cutlines.length){
      const lip=cutlines[cutlines.length-1];
      if(lip.type==='rect'){
        var lx=lip.left, ly=lip.top;
        if(lip.originX==='center') lx-=lip.width*lip.scaleX/2;
        if(lip.originY==='center') ly-=lip.height*lip.scaleY/2;
        return {left:lx, top:ly, width:lip.width*lip.scaleX, height:lip.height*lip.scaleY};
      }
      if(lip.type==='circle'){
        var r=lip.radius*lip.scaleX;
        return {left:lip.left-r, top:lip.top-r, width:r*2, height:r*2};
      }
      if(lip.type==='ellipse'){
        var rx=lip.rx*lip.scaleX, ry=lip.ry*lip.scaleY;
        return {left:lip.left-rx, top:lip.top-ry, width:rx*2, height:ry*2};
      }
    }
    const img=getMainImage()||getMainContent();
    if(img) return img.getBoundingRect();
    return null;
  }
  function updateDimLabel(){
    const v=state.size;
    var d;
    if(v==='custom'){
      d=state.sizeInches||2;
    } else {
      const m=v.match(/(\d+)/); d=m?parseInt(m[1]):2;
    }
    const off=getCutOffset();
    if(!state.canvas || (!getMainImage() && !getMainContent())){
      const[iw,ih]=getSelectedSize();
      $('#rulerHLabel').textContent=iw+'"'; $('#rulerVLabel').textContent=ih+'"';
      var rHn=$('#rulerH'), rVn=$('#rulerV');
      if(rHn){ rHn.style.left=''; rHn.style.width=''; rHn.style.top=''; rHn.style.bottom=''; }
      if(rVn){ rVn.style.top=''; rVn.style.height=''; rVn.style.left=''; rVn.style.right=''; }
      return;
    }
    const img=getMainImage()||getMainContent();
    if(!img){ return; }
    const imgBounds=img.getBoundingRect();
    if(v==='custom' && state.shape==='die-cut'){
      var lipBndsDC=getLipBounds();
      if(lipBndsDC){
        var dcAspect=lipBndsDC.width/lipBndsDC.height;
        var dcW,dcH;
        if(dcAspect>=1){dcW=d;dcH=+(d/dcAspect).toFixed(1);}
        else{dcH=d;dcW=+(d*dcAspect).toFixed(1);}
        $('#rulerHLabel').textContent=dcW+'"';
        $('#rulerVLabel').textContent=dcH+'"';
      } else {
        var cw2=parseFloat($('#smsCustomW').value)||2, ch2=parseFloat($('#smsCustomH').value)||2;
        $('#rulerHLabel').textContent=cw2+'"';$('#rulerVLabel').textContent=ch2+'"';
      }
    } else if(v==='custom'){
      var cw=parseFloat($('#smsCustomW').value)||2, ch=parseFloat($('#smsCustomH').value)||2;
      $('#rulerHLabel').textContent=cw+'"';
      $('#rulerVLabel').textContent=ch+'"';
    } else {
      const lipBnds=getLipBounds();
      if(!lipBnds){
        const[iw,ih]=getSelectedSize();
        $('#rulerHLabel').textContent=iw+'"'; $('#rulerVLabel').textContent=ih+'"';
      } else {
        const lipAspect=lipBnds.width/lipBnds.height;
        var totalW, totalH;
        if(lipAspect>=1){
          totalW=d; totalH=+(d/lipAspect).toFixed(1);
        } else {
          totalH=d; totalW=+(d*lipAspect).toFixed(1);
        }
        $('#rulerHLabel').textContent=totalW+'"';
        $('#rulerVLabel').textContent=totalH+'"';
      }
    }
    var finalBounds=getLipBounds();
    const rH=$('#rulerH'), rV=$('#rulerV');
    if(!finalBounds){
      var fb=_vo();
      if(fb.length){
        var fL=Infinity,fT=Infinity,fR=-Infinity,fB=-Infinity;
        fb.forEach(function(o){o.setCoords();var br=o.getBoundingRect();fL=Math.min(fL,br.left);fT=Math.min(fT,br.top);fR=Math.max(fR,br.left+br.width);fB=Math.max(fB,br.top+br.height);});
        finalBounds={left:fL,top:fT,width:fR-fL,height:fB-fT};
      }
    }
    if(!finalBounds){ rH.style.display='none'; rV.style.display='none'; return; }
    rH.style.display=''; rV.style.display='';
    const gap=8;
    rH.style.left=finalBounds.left+'px';
    rH.style.width=finalBounds.width+'px';
    rH.style.top=(finalBounds.top+finalBounds.height+gap)+'px';
    rH.style.bottom='auto';
    rV.style.top=finalBounds.top+'px';
    rV.style.height=finalBounds.height+'px';
    rV.style.left=(finalBounds.left+finalBounds.width+gap)+'px';
    rV.style.right='auto';
  }
  function initBlankCanvas(){
    if(state.canvas) return;
    hideBlankShape();
    var vt=$('#vinylTexture'), vs=$('#vinylSpecular');
    if(vt) vt.style.opacity='0';
    if(vs) vs.style.opacity='0';
    D.prev.classList.add('visible');
    var area=$('.sms-canvas-area');
    var isMobile=window.innerWidth<=768;
    var aW=area.clientWidth, aH=area.clientHeight;
    var canvasW,canvasH;
    if(isMobile){canvasW=Math.min(aW,window.innerWidth);canvasH=Math.max(aH-70,Math.round(canvasW*1.1));}
    else {canvasW=Math.round(aW*0.96);canvasH=Math.round(aH*0.96);}
    var ce=$('#mainCanvas');ce.width=canvasW;ce.height=canvasH;
    fabric.devicePixelRatio=Math.max(window.devicePixelRatio||1,3);
    state.canvas=new fabric.Canvas('mainCanvas',{
      width:canvasW,height:canvasH,backgroundColor:'transparent',selection:false,uniformScaling:true,enableRetinaScaling:true
    });
    state.canvas.on('object:modified',function(){if(state.shape==='die-cut'){drawCutline();} saveState();});
    state.canvas.on('text:editing:exited',function(){if(state.shape==='die-cut')requestAnimationFrame(function(){try{drawCutline();}catch(e){console.error('[text-edit]',e);}});saveState();});
    var _liveCutT=null;
    /* 800ms: drawCutline blocks 400-1000ms on image+text, so only run once the user stops. */
    function _scheduleLiveCut(){clearTimeout(_liveCutT);_liveCutT=setTimeout(function(){if(state.shape==='die-cut'){_drawingCutline=false;state.skipAutoFit=true;try{drawCutline();}catch(e){console.error('[live-cut]',e);}state.skipAutoFit=false;}},800);}
    state.canvas.on('object:scaling',_scheduleLiveCut);
    state.canvas.on('object:moving',function(){clearTimeout(_liveCutT);});
    state.canvas.on('object:rotating',_scheduleLiveCut);
    state.canvas.on('text:changed',_scheduleLiveCut);
    state.canvas.on('object:moving',function(e){
      var obj=e.target, cw=state.canvas.getWidth(), ch=state.canvas.getHeight();
      var br=obj.getBoundingRect();
      var minVisible=Math.min(br.width,br.height)*0.5;
      if(br.left+br.width<minVisible) obj.set('left',obj.left+(minVisible-br.left-br.width));
      if(br.top+br.height<minVisible) obj.set('top',obj.top+(minVisible-br.top-br.height));
      if(br.left>cw-minVisible) obj.set('left',obj.left-(br.left-cw+minVisible));
      if(br.top>ch-minVisible) obj.set('top',obj.top-(br.top-ch+minVisible));
      _scheduleLiveCut();
    });
    $('#smsZoomControls').style.display='flex';
    D.atc.disabled=false;D.dl.disabled=false;D.dl.style.display='';$('#btnShareLink').disabled=false;$('#btnShareLink').style.display='';$('#btnStartFresh').style.display='';$('#btnStartFresh').disabled=false;$('#smsAutoSaveIndicator').style.display='';
    updateDeleteBtn();updateStartOverBtn();
    setupTextToolbar();
    setupLockHandlers();
    setupDblClickAdjust();
    setupMobileGestures();
    history.states=[]; history.idx=-1;
  }
  function initCanvas(imgEl){
    const area=$('.sms-canvas-area');
    const isMobile=window.innerWidth<=768;
    const aW=area.clientWidth;
    const aH=area.clientHeight;
    var canvasW, canvasH;
    if(isMobile){
      canvasW=Math.min(aW, window.innerWidth);
      var headerH = document.querySelector('#shopify-section-header');
      var hdrH = headerH ? headerH.getBoundingClientRect().height : 60;
      var tbH = 70;
      canvasH = Math.round(window.innerHeight - hdrH - tbH);
    } else {
      canvasW=Math.round(aW*0.96);
      canvasH=Math.round(aH*0.96);
    }
    if(state.canvas) state.canvas.dispose();
    _tbSetupDone=false;
    const ce=$('#mainCanvas');
    ce.width=canvasW; ce.height=canvasH;
    fabric.devicePixelRatio = Math.max(window.devicePixelRatio || 1, 3);
    state.canvas=new fabric.Canvas('mainCanvas',{
      width:canvasW, height:canvasH, backgroundColor:'transparent', selection:false, uniformScaling:true, enableRetinaScaling:true
    });
    if(isMobile){ area.style.minHeight=canvasH+'px'; }
    const off=getCutOffset();
    const fitPct=isMobile?0.74:0.7;
    const fitDim=Math.min(canvasW,canvasH);
    const s=Math.min((fitDim*fitPct-off*2)/imgEl.width,(fitDim*fitPct-off*2)/imgEl.height,1);
    const fImg=new fabric.Image(imgEl,{left:canvasW/2,top:canvasH/2,originX:'center',originY:'center',scaleX:s,scaleY:s,_isMainImage:true});
    lockImage(fImg);
    state.canvas.add(fImg); state.canvas.setActiveObject(fImg); state.canvas.renderAll();
    state.canvas.on('object:modified',function(){ if(state.shape==='die-cut'){drawCutline();} saveState(); });
    /* When user finishes editing IText (clicks away or hits Esc), retrace cutline so the
       outline reflects the new text dimensions. Deferred to next frame to avoid UI freeze. */
    state.canvas.on('text:editing:exited',function(){if(state.shape==='die-cut')requestAnimationFrame(function(){try{drawCutline();}catch(e){console.error('[text-edit]',e);}});saveState();});
    setupLockHandlers();
    setupTextToolbar();
    history.states=[]; history.idx=-1;
    setupDblClickAdjust();
    setupMobileGestures();
    if(state.shape==='die-cut'){ drawCutline(); }
    else { applyShape(); }
    updateDimLabel(); saveState();
  }
  var _tbSetupDone=false;
  function setupTextToolbar(){
    if(_tbSetupDone||!state.canvas) return;
    _tbSetupDone=true;
    var tb=D.ttb;if(!tb)return;
    var tbFont=$('#smsTbFont'),tbSize=$('#smsTbSize'),tbColor=$('#smsTbColor');
    var tbBold=$('#smsTbBold'),tbItalic=$('#smsTbItalic');
    var tbStroke=$('#smsTbStroke'),tbStrokeColor=$('#smsTbStrokeColor');
    var tbSwatches=$('#smsTbSwatches');
    var tbGradients=$('#smsTbGradients');
    tbFont.innerHTML=_smsFonts.map(function(f){return '<option value="'+f+'" style="font-family:\''+f+'\'">'+f+'</option>';}).join('');
    function updateSwatchHighlight(color, gradName){
      if(!tbSwatches) return;
      tbSwatches.querySelectorAll('span[data-c]').forEach(function(s){
        var sc=s.getAttribute('data-c');
        if(color && sc.toLowerCase()===color.toLowerCase()){
          s.style.transform='scale(1.25)';s.style.borderColor='#00c9a7';
        } else {
          s.style.transform='';s.style.borderColor=sc==='#000000'?'#666':sc==='#ffffff'?'#555':'transparent';
        }
      });
      if(tbGradients){tbGradients.querySelectorAll('span[data-grad]').forEach(function(s){
        if(gradName && s.getAttribute('data-grad')===gradName){
          s.style.transform='scale(1.25)';s.style.borderColor='#00c9a7';
        } else {
          s.style.transform='';s.style.borderColor='transparent';
        }
      });}
    }
    function showTb(obj){
      if(!obj||obj.type!=='i-text')return hideTb();
      tbFont.value=obj.fontFamily||'Impact';
      tbSize.value=Math.round(obj.fontSize||36);
      var fill=obj.fill;
      if(fill && typeof fill==='object' && fill.colorStops){
        updateSwatchHighlight(null, null);
      } else {
        var fillColor=fill||'#000000';
        tbColor.value=fillColor;
        updateSwatchHighlight(fillColor);
      }
      if(tbBold){
        var isBold=obj.fontWeight==='bold'||obj.fontWeight>=700;
        tbBold.style.background=isBold?'#00c9a7':'#2a2a3e';
      }
      if(tbItalic){
        var isItalic=obj.fontStyle==='italic';
        tbItalic.style.background=isItalic?'#00c9a7':'#2a2a3e';
      }
      if(tbStroke){
        var hasStroke=obj.stroke&&obj.strokeWidth>0;
        tbStroke.style.background=hasStroke?'#00c9a7':'#2a2a3e';
        tbStroke.style.textShadow=hasStroke?'-1px -1px 0 '+(obj.stroke||'#fff')+',1px -1px 0 '+(obj.stroke||'#fff')+',-1px 1px 0 '+(obj.stroke||'#fff')+',1px 1px 0 '+(obj.stroke||'#fff'):'none';
        if(tbStrokeColor){tbStrokeColor.style.display=hasStroke?'block':'none';tbStrokeColor.value=obj.stroke||'#ffffff';}
      }
      tb.style.display='flex';
    }
    function hideTb(){tb.style.display='none';}
    state.canvas.on('selection:created',function(e){if(_allLocked){state.canvas.discardActiveObject();return;}var o=e.selected&&e.selected[0];addEditGlow(o);setCutVis(true);state.adjusting=true;D.aBar.classList.add('visible');showTb(o);if(state.shape==='die-cut'&&o&&o._isMainImage)enterLockMode();_showQb(o);if(window._sl2ShowCtx)window._sl2ShowCtx(o);});
    state.canvas.on('selection:updated',function(e){if(_allLocked){state.canvas.discardActiveObject();return;}var o=e.selected&&e.selected[0];var prev=e.deselected&&e.deselected[0];removeEditGlow(prev);addEditGlow(o);setCutVis(true);showTb(o);if(state.shape==='die-cut'&&o&&o._isMainImage)enterLockMode();_showQb(o);if(window._sl2ShowCtx)window._sl2ShowCtx(o);});
    state.canvas.on('selection:cleared',function(){
      hideTb();_hideQb();if(window._sl2HideCtx)window._sl2HideCtx();
      var objs=state.canvas.getObjects();
      objs.forEach(function(o){if(o.type==='i-text'&&o.isEditing)o.exitEditing();});
      state.canvas.renderAll();
    });
    state.canvas.on('object:moving',function(){_posQb();});
    state.canvas.on('object:scaling',function(){_posQb();});
    var qb=D.qb;
    function _showQb(obj){
      if(!obj||obj._isCutline||obj._isScissorIcon)return _hideQb();
      if(window._sl2ShowCtx) window._sl2ShowCtx(obj);
    }
    function _hideQb(){qb.style.display='none';if(window._sl2HideCtx) window._sl2HideCtx();}
    window._sl2EditText=function(){var ao=state.canvas&&state.canvas.getActiveObject();if(ao&&ao.type==='i-text'){ao.enterEditing();ao.selectAll();}};
    function _posQb(){
      var obj=state.canvas.getActiveObject();
      if(!obj||!qb||qb.style.display==='none')return;
      var br=obj.getBoundingRect();
      var stage=D.stg;
      var sr=stage?stage.getBoundingClientRect():{left:0,top:0};
      var pr=D.prev?D.prev.getBoundingClientRect():{left:0,top:0};
      var topPos=br.top+sr.top-pr.top-42;
      if(topPos<4) topPos=br.top+br.height+sr.top-pr.top+8;
      qb.style.top=topPos+'px';
      qb.style.left=(br.left+br.width/2+sr.left-pr.left)+'px';
      qb.style.transform='translateX(-50%)';
    }
    $('#smsQbDupe').addEventListener('click',function(){
      var obj=state.canvas.getActiveObject();if(!obj)return;
      obj.clone(function(cloned){
        cloned.set({left:obj.left+20,top:obj.top+20});
        if(obj.clipPath) cloned.clipPath=obj.clipPath;
        state.canvas.add(cloned);state.canvas.setActiveObject(cloned);state.canvas.renderAll();
        _redrawAfterEdit();saveState();updateDeleteBtn();updateStartOverBtn();
      });
    });
    $('#smsQbRotate').addEventListener('click',function(){
      var obj=state.canvas.getActiveObject();if(!obj)return;
      obj.rotate((obj.angle||0)+90);state.canvas.renderAll();_redrawAfterEdit();saveState();
    });
    $('#smsQbFlip').addEventListener('click',function(){
      var obj=state.canvas.getActiveObject();if(!obj)return;
      obj.set('flipX',!obj.flipX);state.canvas.renderAll();_redrawAfterEdit();saveState();
    });
    $('#smsQbFront').addEventListener('click',function(){
      var obj=state.canvas.getActiveObject();if(!obj)return;
      obj.bringToFront();state.canvas.renderAll();saveState();
    });
    $('#smsQbDel').addEventListener('click',function(){
      var obj=state.canvas.getActiveObject();if(!obj)return;
      state.canvas.remove(obj);state.canvas.discardActiveObject();state.canvas.renderAll();
      _redrawAfterEdit();positionOverlays();saveState();updateDeleteBtn();updateStartOverBtn();
    });
    tbFont.addEventListener('change',function(){
      var o=state.canvas.getActiveObject();
      if(o&&o.type==='i-text'){
        var fn=tbFont.value;
        o.set('fontFamily',fn);o.dirty=true;state.canvas.renderAll();
        document.fonts.load('72px "'+fn+'"').then(function(){return document.fonts.ready;}).then(function(){
          setTimeout(function(){
            o.dirty=true;o.objectCaching=false;o.initDimensions();o.setCoords();o.objectCaching=true;
            if(state.shape==='die-cut') drawCutline();
            state.canvas.setActiveObject(o);state.canvas.renderAll();saveState();
          },100);
        });
      }
    });
    var _sizeTimer=null;
    tbSize.addEventListener('input',function(){
      var o=state.canvas.getActiveObject();
      if(o&&o.type==='i-text'){
        o.set('fontSize',parseInt(tbSize.value)||36);o.initDimensions();o.setCoords();state.canvas.renderAll();
        clearTimeout(_sizeTimer);
        _sizeTimer=setTimeout(function(){if(state.shape==='die-cut')drawCutline();saveState();},600);
      }
    });
    var _colorTimer=null;
    tbColor.addEventListener('input',function(){
      var o=state.canvas.getActiveObject();
      if(o&&o.type==='i-text'){o.set('fill',tbColor.value);o.dirty=true;state.canvas.renderAll();updateSwatchHighlight(tbColor.value);clearTimeout(_colorTimer);_colorTimer=setTimeout(saveState,300);}
    });
    if(tbSwatches){
      tbSwatches.addEventListener('click',function(e){
        var swatch=e.target.closest('span[data-c]');
        if(swatch){
          var c=swatch.getAttribute('data-c');
          var o=state.canvas.getActiveObject();
          if(o&&o.type==='i-text'){o.set('fill',c);tbColor.value=c;state.canvas.renderAll();updateSwatchHighlight(c);saveState();}
        }
      });
    }
    if(tbGradients){
      tbGradients.addEventListener('click',function(e){
        var grad=e.target.closest('span[data-grad]');
        if(!grad) return;
        var o=state.canvas.getActiveObject();
        if(!o||o.type!=='i-text') return;
        var stops=[];
        for(var i=0;i<10;i++){
          var gc=grad.getAttribute('data-g'+i);
          if(!gc) break;
          stops.push(gc);
        }
        if(stops.length<2) return;
        var colorStops=stops.map(function(c,idx){return{offset:idx/(stops.length-1),color:c};});
        o.set('fill',new fabric.Gradient({
          type:'linear',
          coords:{x1:0,y1:0,x2:o.width,y2:0},
          colorStops:colorStops
        }));
        o.dirty=true;
        state.canvas.renderAll();
        updateSwatchHighlight(null,grad.getAttribute('data-grad'));
        saveState();
      });
    }
    if(tbBold){
      tbBold.addEventListener('click',function(){
        var o=state.canvas.getActiveObject();if(!o||o.type!=='i-text') return;
        var isBold=o.fontWeight==='bold'||o.fontWeight>=700;
        o.set('fontWeight',isBold?'normal':'bold');o.dirty=true;o.initDimensions();o.setCoords();
        tbBold.style.background=isBold?'#2a2a3e':'#00c9a7';
        state.canvas.renderAll();if(state.shape==='die-cut') drawCutline();saveState();
      });
    }
    if(tbItalic){
      tbItalic.addEventListener('click',function(){
        var o=state.canvas.getActiveObject();if(!o||o.type!=='i-text') return;
        var isItalic=o.fontStyle==='italic';
        o.set('fontStyle',isItalic?'normal':'italic');o.dirty=true;o.initDimensions();o.setCoords();
        tbItalic.style.background=isItalic?'#2a2a3e':'#00c9a7';
        state.canvas.renderAll();if(state.shape==='die-cut') drawCutline();saveState();
      });
    }
    if(tbStroke){
      tbStroke.addEventListener('click',function(){
        var o=state.canvas.getActiveObject();if(!o||o.type!=='i-text') return;
        var hasStroke=o.stroke&&o.strokeWidth>0;
        if(hasStroke){
          o.set({stroke:null,strokeWidth:0});tbStroke.style.background='#2a2a3e';tbStroke.style.textShadow='none';
          if(tbStrokeColor) tbStrokeColor.style.display='none';
        } else {
          var sc=tbStrokeColor?tbStrokeColor.value:'#ffffff';
          o.set({stroke:sc,strokeWidth:2});tbStroke.style.background='#00c9a7';
          tbStroke.style.textShadow='-1px -1px 0 '+sc+',1px -1px 0 '+sc+',-1px 1px 0 '+sc+',1px 1px 0 '+sc;
          if(tbStrokeColor) tbStrokeColor.style.display='block';
        }
        o.dirty=true;state.canvas.renderAll();if(state.shape==='die-cut') drawCutline();saveState();
      });
    }
    var _strokeCTimer=null;
    if(tbStrokeColor){
      tbStrokeColor.addEventListener('input',function(){
        var o=state.canvas.getActiveObject();if(!o||o.type!=='i-text') return;
        if(o.strokeWidth>0){o.set('stroke',tbStrokeColor.value);o.dirty=true;state.canvas.renderAll();clearTimeout(_strokeCTimer);_strokeCTimer=setTimeout(saveState,300);}
      });
    }
  }
  function _redrawAfterEdit(){ if(state.shape==='die-cut'){drawCutline();}else{var d=getShapeDims(),c=state.canvas,cx=c.getWidth()/2,cy=c.getHeight()/2;c.getObjects().filter(function(o){return o._isCutline;}).forEach(function(o){c.remove(o);});drawCutlineForShape(d[0],d[1],cx,cy);if(!_cutVis&&state.cutStyle!=='none')c.getObjects().forEach(function(o){if(o._isCutEdge)o.visible=false;});c.renderAll();} }
  $('#btnRotate').addEventListener('click', ()=>{ if(!state.canvas)return; const o=state.canvas.getActiveObject()||getMainContent(); if(o&&!o._isCutline){o.rotate((o.angle||0)+90);state.canvas.renderAll();_redrawAfterEdit();saveState();} });
  $('#btnFlip').addEventListener('click', ()=>{ if(!state.canvas)return; const o=state.canvas.getActiveObject()||getMainContent(); if(o&&!o._isCutline){o.set('flipX',!o.flipX);state.canvas.renderAll();_redrawAfterEdit();saveState();} });
  $('#btnUndo').addEventListener('click', undo);
  $('#btnRedo').addEventListener('click', redo);
  function doDeleteSelected(){
    if(!state.canvas) return;
    const active=state.canvas.getActiveObject();
    if(!active) return;
    if(active.isEditing) return;
    var c=state.canvas;
    state.canvas.remove(active);
    state.canvas.discardActiveObject();
    var _remaining=_vo();
    if(!_remaining.length){ doStartOver(); return; }
    if(state.shape!=='die-cut'){var sd=getShapeDims();var cx=c.getWidth()/2,cy=c.getHeight()/2;drawCutlineForShape(sd[0],sd[1],cx,cy);}
    else{drawCutline();}
    saveState();
    updateDeleteBtn(); updateStartOverBtn();
  }
  $('#btnDelete').addEventListener('click', doDeleteSelected);
  document.addEventListener('keydown', function(e){
    if(!state.canvas) return;
    var tag=document.activeElement&&document.activeElement.tagName;
    if(tag==='INPUT'||tag==='TEXTAREA'||tag==='SELECT') return;
    if(e.key==='Delete'||e.key==='Backspace'){
      var act=state.canvas.getActiveObject();
      if(act && act.isEditing) return;
      if(act){ e.preventDefault(); doDeleteSelected(); }
    }
  });
  $('#btnStartOver').addEventListener('click', doStartOver);
  function doStartOver(){
    if(state.canvas){ state.canvas.clear(); state.canvas.dispose(); state.canvas=null; }
    _tbSetupDone=false; _drawingCutline=false;
    state.originalImg=null; state.processedImg=null; state.bgMode='none';
    state.cutContourPath=null; state.cutContourPoints=null;
    state.size='2x2'; state.sizeInches=2; state.finish='matte'; state.shape='die-cut';
    state.shapePortrait=false; state.adjusting=false; state.lockMode=false; state.borderColor='#ffffff';
    state.qty=50; state.cutStyle='tight'; state.smoothLevel='balanced';
    history.states=[]; history.idx=-1;
    $$('.sms-tool-icon[data-bg]').forEach(o=>o.classList.remove('active'));
    if($('.sms-tool-icon[data-bg="none"]')) $('.sms-tool-icon[data-bg="none"]').classList.add('active');
    D.bgs.textContent='';
    $$('.sms-size-radio[name="sms-size"]').forEach(function(r){r.checked=(r.value==='2x2');});
    if($('#smsCustomSize')) $('#smsCustomSize').style.display='none';
    if($('#smsCustomW')) $('#smsCustomW').value='3';
    if($('#smsCustomH')) $('#smsCustomH').value='3';
    $$('.sms-shape-btn').forEach(function(b){b.classList.toggle('active',b.dataset.shape==='die-cut');});
    $$('.sms-finish-btn').forEach(function(b){b.classList.toggle('active',b.dataset.finish==='matte');});
    $$('.sms-border-color-btn').forEach(function(b){b.classList.toggle('active',b.dataset.bcolor==='#ffffff');b.style.borderColor='';});
    var qSlider=$('#qtySlider');if(qSlider)qSlider.value=50;
    var qVal=$('#qtyVal');if(qVal)qVal.value=50;
    $$('.sms-qty-pre').forEach(function(b){b.classList.toggle('active',parseInt(b.dataset.qty)===50);});
    $$('.sms-tool-icon[data-cut]').forEach(function(b){b.classList.toggle('active',b.dataset.cut==='tight');});
    var stage=D.stg;
    if(stage){stage.classList.remove('finish-glossy','finish-holographic');}
    if(blankEl){blankEl.classList.remove('finish-glossy','finish-holographic');}
    var canvasContainer=stage?stage.querySelector('.canvas-container'):null;
    if(canvasContainer) canvasContainer.style.display='none';
    if(typeof zoomLevel!=='undefined') zoomLevel=defaultZoom;
    if(stage) stage.style.transform='';
    var tb=D.ttb;if(tb)tb.style.display='none';
    var qb=D.qb;if(qb)qb.style.display='none';
    D.aBar.classList.remove('visible');
    D.aHint.classList.remove('visible');
    var ss=$('#stageShadow');if(ss){ss.style.clipPath='';ss.style.opacity='';}
    ['glossLayer','holoOverlay','glossOverlay','vinylTexture','vinylSpecular','edgeRim','stickerDepth'].forEach(function(id){
      var el=$('#'+id); if(el){el.style.clipPath='';el.style.opacity='';el.style.background='';el.style.backgroundPosition='';}
    });
    showBlankShape();
    $('#rulerHLabel').textContent='2"';
    $('#rulerVLabel').textContent='2"';
    var rH=$('#rulerH'), rV=$('#rulerV');
    if(rH){ rH.style.left=''; rH.style.width=''; rH.style.top=''; rH.style.bottom=''; }
    if(rV){ rV.style.top=''; rV.style.height=''; rV.style.left=''; rV.style.right=''; }
    D.atc.disabled=true;
    D.dl.disabled=true;
    D.dl.style.display='none';
    $('#btnShareLink').disabled=true;
    $('#btnShareLink').style.display='none';
    $('#smsAutoSaveIndicator').style.display='none';
    _shareSessionId=null;
    $('#smsZoomControls').style.display='none';
    updatePrice();
    _mo();
    updateDeleteBtn(); updateStartOverBtn(); updateUndoRedoBtns();
  }
  function _hasCanvasContent(){
    return _vo().length>0;
  }
  function updateDeleteBtn(){
    const btn=$('#btnDelete');
    if(!_hasCanvasContent()){ btn.classList.add('disabled'); }
    else { btn.classList.remove('disabled'); }
  }
  function updateStartOverBtn(){
    const btn=$('#btnStartOver');
    if(!_hasCanvasContent()){ btn.classList.add('disabled'); }
    else { btn.classList.remove('disabled'); }
  }
  $$('.sms-tool-icon[data-cut]').forEach(opt=>{
    if(opt.dataset.cut==='tight') opt.classList.add('active');
    opt.addEventListener('click',()=>{
      $$('.sms-tool-icon[data-cut]').forEach(o=>o.classList.remove('active'));
      opt.classList.add('active'); state.cutStyle=opt.dataset.cut;
      _withCutlineLoading(function(){
        if(state.shape==='die-cut'){ drawCutline(); } else { applyShape(); }
        updateDimLabel(); saveState();
      });
    });
  });
  /* Show a top loading bar during heavy cutline recomputation, then defer
     the work via double-rAF so the browser paints the indicator first. */
  function _withCutlineLoading(fn){
    document.body.classList.add('sms-cutline-computing');
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        try{fn();}catch(e){console.error(e);}
        document.body.classList.remove('sms-cutline-computing');
      });
    });
  }
  $$('.sms-tool-icon[data-detail]').forEach(opt=>{
    opt.addEventListener('click',()=>{
      $$('.sms-tool-icon[data-detail]').forEach(o=>o.classList.remove('active'));
      opt.classList.add('active'); state.smoothLevel=opt.dataset.detail;
      _withCutlineLoading(function(){
        if(state.shape==='die-cut'){ drawCutline(); } else { applyShape(); }
        saveState();
      });
    });
  });
  var _tplPixelBounds=null;
  var _drawingCutline=false;
  function _saveOverlayPositions(canvas, baseImg){
    var saved = [];
    if(!baseImg) return saved;
    var bx = baseImg.left, by = baseImg.top, bsx = baseImg.scaleX, bsy = baseImg.scaleY;
    var bw = baseImg.width * bsx, bh = baseImg.height * bsy;
    canvas.getObjects().forEach(function(o){
      if(o._isCutline || o._isScissorIcon || o === baseImg) return;
      saved.push({
        obj: o,
        relLeft: bw > 0 ? (o.left - bx) / bw : 0,
        relTop: bh > 0 ? (o.top - by) / bh : 0,
        relScaleX: bsx > 0 ? o.scaleX / bsx : 1,
        relScaleY: bsy > 0 ? o.scaleY / bsy : 1
      });
    });
    return saved;
  }
  function _restoreOverlayPositions(saved, baseImg){
    if(!baseImg || !saved.length) return;
    var bx = baseImg.left, by = baseImg.top, bsx = baseImg.scaleX, bsy = baseImg.scaleY;
    var bw = baseImg.width * bsx, bh = baseImg.height * bsy;
    saved.forEach(function(s){
      s.obj.set({
        left: bx + s.relLeft * bw,
        top: by + s.relTop * bh,
        scaleX: s.relScaleX * bsx,
        scaleY: s.relScaleY * bsy
      });
      s.obj.setCoords();
    });
  }
  function drawCutline(){
    if(!state.canvas||_drawingCutline) return;
    _drawingCutline=true;
    setTimeout(function(){_drawingCutline=false;},2000);
    const c=state.canvas;
    state.adjusting=true;
    var stage=D.stg;
    if(stage) stage.style.transform='scale('+(typeof zoomLevel!=='undefined'?zoomLevel:defaultZoom)+') rotateX(0) rotateY(0)';
    _tplPixelBounds=null;
    var _savedPositions = _saveOverlayPositions(c, getMainImage());
    c.getObjects().filter(o=>o._isCutline).forEach(o=>c.remove(o));
    const img=getMainImage();
    if(!img){
      var contentObjs=_vo();
      if(!contentObjs.length){_drawingCutline=false;if(!state.lockMode)state.adjusting=false;return;}
      contentObjs.forEach(function(o){o.setCoords();});
      c.discardActiveObject();
      var offset2=getCutOffset(), isNone2=state.cutStyle==='none';
      if(isNone2&&contentObjs.every(function(o){return o.type==='i-text';}))offset2=_smnEdgeTextPx();
      var contentIdx=0;
      /* For pure-text canvases, use _sl2GetTextHaloContour with reduced dilation
         (6 vs default 18). Halo function handles canvas-expansion + multi-trace +
         Clipper offset correctly. The 18px default over-inflates for pure-text
         (cutline too thick). 6px dilation just bridges adjacent letter gaps. */
      var _textOnly=contentObjs.length>0&&contentObjs.every(function(o){return o.type==='i-text';});
      var cResult=null;
      if(_textOnly&&window._sl2GetTextHaloContour){
        cResult=window._sl2GetTextHaloContour(c,offset2,
          {dilateMask:dilateMask,smoothMask:smoothMask,mooreTrace:mooreTrace,rdpR:rdpR,ptsToSmoothSvg:ptsToSmoothSvg},
          {dilation:6,closeRadius:30});
      }
      if(!cResult) cResult=getContourFromTemplateElements(c,offset2);
      if(cResult){
        /* Process ALL traced contours, not just the first — long text like "AVA BRAMDEO"
           with wide gaps may trace as multiple disconnected polygons. Previously only
           the first contour's bezier-smoothed path was rendered, dropping later words. */
        var _allOP=cResult.allOffsetPts||[cResult.offsetPts];
        var _csSvgParts=[],_csPtsArr=[];
        for(var _ci=0;_ci<_allOP.length;_ci++){
          var _csPtsI=rdpR(_allOP[_ci],0.5);
          if(window._sl2StraightenRuns)_csPtsI=window._sl2StraightenRuns(_csPtsI,0.7);
          if(_csPtsI.length<3) continue;
          var _csSvgI=(window._sl2MidSvg&&window._sl2MidSvg(_csPtsI))||null;
          if(!_csSvgI){_csSvgI='M '+_csPtsI[0][0]+' '+_csPtsI[0][1];for(var _li=1;_li<_csPtsI.length;_li++)_csSvgI+=' L '+_csPtsI[_li][0]+' '+_csPtsI[_li][1];_csSvgI+=' Z';}
          _csSvgParts.push(_csSvgI);
          _csPtsArr.push(_csPtsI);
        }
        var _csPts=_csPtsArr[0]||cResult.offsetPts;
        var _csSvg=_csSvgParts.length?_csSvgParts.join(' '):cResult.offsetSvg;
        state.cutContourPath=_csSvg;state.cutContourPoints=window._sl2DenseSamp?window._sl2DenseSamp(_csPts,8):cResult.offsetPts;
        if(!isNone2){
          c.insertAt(new fabric.Path(_csSvg,{fill:'#ffffff',stroke:'none',strokeWidth:0,
            selectable:false,evented:false,_isCutline:true,
            shadow:new fabric.Shadow({color:'rgba(0,0,0,0.25)',blur:6,offsetX:1,offsetY:2})}),contentIdx);
          c.insertAt(new fabric.Path(_csSvg,{fill:state.borderColor,stroke:'rgba(0,0,0,0.10)',
            strokeWidth:1,strokeLineJoin:'round',selectable:false,evented:false,_isCutline:true,
            shadow:new fabric.Shadow({color:'rgba(0,0,0,0.22)',blur:4,offsetX:1,offsetY:2})}),contentIdx+1);
        }
        c.insertAt(new fabric.Path(_csSvg,{fill:'transparent',stroke:'#FF0000',strokeWidth:1,strokeLineJoin:'round',
          selectable:false,evented:false,_isCutline:true,_isCutEdge:true}),c.getObjects().length);
        if(isNone2)addScissorIcon(c,_csPts);
        c.discardActiveObject();c.renderAll();positionOverlays();updateDimLabel();autoFitView();_drawingCutline=false;if(!state.lockMode)state.adjusting=false;
        return;
      }
      var minL=Infinity,minT=Infinity,maxR=-Infinity,maxB=-Infinity;
      contentObjs.forEach(function(o){var br=o.getBoundingRect();minL=Math.min(minL,br.left);minT=Math.min(minT,br.top);maxR=Math.max(maxR,br.left+br.width);maxB=Math.max(maxB,br.top+br.height);});
      var bW=maxR-minL,bH=maxB-minT,bCx=minL+bW/2,bCy=minT+bH/2;
      var rr2=Math.min(bW,bH)*0.015;
      if(!isNone2){
        var baseP={left:bCx,top:bCy,originX:'center',originY:'center',width:bW+offset2*2,height:bH+offset2*2,
          rx:rr2+offset2*.15,ry:rr2+offset2*.15,selectable:false,evented:false,_isCutline:true};
        c.insertAt(new fabric.Rect(Object.assign({},baseP,{fill:'#fff',stroke:'none',
          shadow:new fabric.Shadow({color:'rgba(0,0,0,0.25)',blur:6,offsetX:1,offsetY:2})})),contentIdx);
        c.insertAt(new fabric.Rect(Object.assign({},baseP,{fill:state.borderColor,stroke:'rgba(0,0,0,0.08)',strokeWidth:0.5,
          shadow:new fabric.Shadow({color:'rgba(0,0,0,0.15)',blur:2,offsetX:1,offsetY:1})})),contentIdx+1);
      }
      var hw2=(bW+offset2*2)/2,hh2=(bH+offset2*2)/2,cr2=Math.min(rr2+offset2*0.15,hw2,hh2);
      var pts2=[],an2=8,en2=8;
      for(var ri=0;ri<=en2;ri++) pts2.push([bCx-hw2+cr2+ri*((hw2*2-cr2*2)/en2),bCy-hh2]);
      for(var ri=1;ri<=an2;ri++){var a=-Math.PI/2+ri*(Math.PI/2)/an2;pts2.push([bCx+hw2-cr2+Math.cos(a)*cr2,bCy-hh2+cr2+Math.sin(a)*cr2]);}
      for(var ri=1;ri<=en2;ri++) pts2.push([bCx+hw2,bCy-hh2+cr2+ri*((hh2*2-cr2*2)/en2)]);
      for(var ri=1;ri<=an2;ri++){var a=ri*(Math.PI/2)/an2;pts2.push([bCx+hw2-cr2+Math.cos(a)*cr2,bCy+hh2-cr2+Math.sin(a)*cr2]);}
      for(var ri=1;ri<=en2;ri++) pts2.push([bCx+hw2-cr2-ri*((hw2*2-cr2*2)/en2),bCy+hh2]);
      for(var ri=1;ri<=an2;ri++){var a=Math.PI/2+ri*(Math.PI/2)/an2;pts2.push([bCx-hw2+cr2+Math.cos(a)*cr2,bCy+hh2-cr2+Math.sin(a)*cr2]);}
      for(var ri=1;ri<=en2;ri++) pts2.push([bCx-hw2,bCy+hh2-cr2-ri*((hh2*2-cr2*2)/en2)]);
      for(var ri=1;ri<=an2;ri++){var a=Math.PI+ri*(Math.PI/2)/an2;pts2.push([bCx-hw2+cr2+Math.cos(a)*cr2,bCy-hh2+cr2+Math.sin(a)*cr2]);}
      state.cutContourPoints=pts2;state.cutContourPath=null;
      c.insertAt(new fabric.Rect({left:bCx,top:bCy,originX:'center',originY:'center',width:bW+offset2*2,height:bH+offset2*2,
        rx:0,ry:0,fill:'transparent',stroke:'#FF0000',strokeWidth:1,
        selectable:false,evented:false,_isCutline:true,_isCutEdge:true}),c.getObjects().length);
      if(isNone2)addScissorIcon(c,pts2);
      c.discardActiveObject();c.renderAll();positionOverlays();updateDimLabel();autoFitView();_drawingCutline=false;if(!state.lockMode)state.adjusting=false;
      return;
    }
    img.setCoords(); c.renderAll();
    const offset=getCutOffset();
    const overlayEls=c.getObjects().filter(function(o){return !o._isMainImage&&!o._isCutline;});
    const hasOverlays=overlayEls.length>0;
    const isTemplateDieCut=img._isTemplateBg&&hasOverlays;
    if(isTemplateDieCut) img.visible=false;
    else if(img._isTemplateBg) img.visible=true;
    var result;
    if(isTemplateDieCut) result=getContourFromTemplateElements(c,offset,true);
    else if(hasOverlays){
      var imgR=getContourAndOffset(img,offset);
      /* Use low dilation (6px) so text border thickness matches the image border
         (both at +offsetPx canvas units). Keep closeRadius=30 to bridge word gaps. */
      var textHalo=getTextHaloContour(c,state.cutStyle==='none'?Math.max(offset,_smnEdgeTextPx()):offset,{dilation:6,closeRadius:30});
      var CS=5000,allContours=[];
      if(imgR&&imgR.offsetPts) allContours.push(imgR.offsetPts);
      if(textHalo){(textHalo.allOffsetPts||[textHalo.offsetPts]).forEach(function(p){if(p&&p.length>2)allContours.push(p);});}
      overlayEls.forEach(function(o){
        if(o.visible===false||o.type==='i-text') return;
        o.setCoords();
        var oC=o.type==='image'?getContourAndOffset(o,offset):getVecContour(o,offset);
        if(oC&&oC.offsetPts)allContours.push(oC.offsetPts);
      });
      if(allContours.length>1){
        var allMinL=Infinity,allMinT=Infinity,allMaxR=-Infinity,allMaxB=-Infinity;
        allContours.forEach(function(pts){
          pts.forEach(function(p){
            allMinL=Math.min(allMinL,p[0]);allMinT=Math.min(allMinT,p[1]);
            allMaxR=Math.max(allMaxR,p[0]);allMaxB=Math.max(allMaxB,p[1]);
          });
        });
        var toC=function(pts){return pts.map(function(p){return{X:Math.round(p[0]*CS),Y:Math.round(p[1]*CS)};});};
        var cl=new ClipperLib.Clipper();
        cl.AddPath(toC(allContours[0]),ClipperLib.PolyType.ptSubject,true);
        for(var ci=1;ci<allContours.length;ci++) cl.AddPath(toC(allContours[ci]),ClipperLib.PolyType.ptClip,true);
        var sl=new ClipperLib.Paths();
        cl.Execute(ClipperLib.ClipType.ctUnion,sl,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
        /* Round sharp corners ~20px via Clipper open (offset out then in with jtRound) */
        var _rR=25*CS;if(sl.length){var _co1=new ClipperLib.ClipperOffset();_co1.ArcTolerance=0.001*CS;for(var _ri=0;_ri<sl.length;_ri++)_co1.AddPath(sl[_ri],ClipperLib.JoinType.jtRound,ClipperLib.EndType.etClosedPolygon);var _s1=new ClipperLib.Paths();_co1.Execute(_s1,_rR);if(_s1.length){var _co2=new ClipperLib.ClipperOffset();_co2.ArcTolerance=0.001*CS;for(var _ri=0;_ri<_s1.length;_ri++)_co2.AddPath(_s1[_ri],ClipperLib.JoinType.jtRound,ClipperLib.EndType.etClosedPolygon);var _s2=new ClipperLib.Paths();_co2.Execute(_s2,-_rR);if(_s2.length)sl=_s2;}}
        if(sl.length===1){
          sl[0]=ClipperLib.Clipper.CleanPolygon(sl[0],0.08*CS);
          var uRaw=sl[0].map(function(p){return[p.X/CS,p.Y/CS];});
          /* Flatten Clipper jitter so mid-bezier doesn't turn text baselines into waves. */
          var uSimp=rdpR(uRaw,0.5);
          if(window._sl2StraightenRuns)uSimp=window._sl2StraightenRuns(uSimp,0.7);
          if(window._sl2FlattenAxialRuns)uSimp=window._sl2FlattenAxialRuns(uSimp,0.35);
          var uSvg=(window._sl2MidSvg&&uSimp.length>=3)?window._sl2MidSvg(uSimp):null;
          if(!uSvg){uSvg='M '+uSimp[0][0]+' '+uSimp[0][1];for(var ui=1;ui<uSimp.length;ui++) uSvg+=' L '+uSimp[ui][0]+' '+uSimp[ui][1];uSvg+=' Z';}
          result={offsetSvg:uSvg,offsetPts:uSimp};
        } else if(sl.length>1){
          var mSvg='',mPts=[];
          for(var si=0;si<sl.length;si++){
            sl[si]=ClipperLib.Clipper.CleanPolygon(sl[si],0.08*CS);
            if(sl[si].length<3) continue;
            var polyArea=Math.abs(ClipperLib.Clipper.Area(sl[si]));
            if(polyArea<500*CS*CS) continue;
            var sRaw=sl[si].map(function(p){return[p.X/CS,p.Y/CS];});
            /* Same three-stage flattening as the single-polygon branch. */
            var sSimp=rdpR(sRaw,0.5);
            if(window._sl2StraightenRuns)sSimp=window._sl2StraightenRuns(sSimp,0.7);
            if(window._sl2FlattenAxialRuns)sSimp=window._sl2FlattenAxialRuns(sSimp,0.35);
            var sSegSvg=(window._sl2MidSvg&&sSimp.length>=3)?window._sl2MidSvg(sSimp):null;
            if(!sSegSvg){sSegSvg='M '+sSimp[0][0]+' '+sSimp[0][1];for(var qi=1;qi<sSimp.length;qi++) sSegSvg+=' L '+sSimp[qi][0]+' '+sSimp[qi][1];sSegSvg+=' Z';}
            mSvg+=sSegSvg+' ';
            mPts=mPts.concat(sSimp);
          }
          result={offsetSvg:mSvg.trim(),offsetPts:mPts};
        }
      } else result=imgR||textHalo;
    }else{
      result=getContourAndOffset(img,offset);
    }
    const imgIdx=hasOverlays?0:c.getObjects().indexOf(img);
    const isNone=state.cutStyle==='none';
    if(isNone){
      if(result && result.offsetSvg && result.offsetPts && result.offsetPts.length>=4){
        state.cutContourPath=result.offsetSvg; state.cutContourPoints=result.offsetPts;
        const pinkPath=new fabric.Path(result.offsetSvg,{
          fill:'transparent',stroke:'#FF0000',strokeWidth:1,strokeLineJoin:'round',
          selectable:false,evented:false,_isCutline:true,_isCutEdge:true
        });
        c.insertAt(pinkPath, c.getObjects().length);
        addScissorIcon(c, result.offsetPts);
      } else {
        const b=isTemplateDieCut?(_tplPixelBounds||getTemplateElementsBounds(c)||img.getBoundingRect()):img.getBoundingRect();
        const bx=b.left+b.width/2, by=b.top+b.height/2;
        const absOff=Math.abs(offset);
        const dw=b.width-absOff*2, dh=b.height-absOff*2;
        const pinkDash=new fabric.Rect({
          left:bx,top:by,originX:'center',originY:'center',
          width:dw,height:dh,rx:0,ry:0,
          fill:'transparent',stroke:'#FF0000',strokeWidth:1,
          selectable:false,evented:false,_isCutline:true,_isCutEdge:true
        });
        c.insertAt(pinkDash, c.getObjects().length);
        var hl=dw/2,hh=dh/2;
        var rPts=[];
        for(var ri=0;ri<=16;ri++) rPts.push([bx-hl+ri*(dw/16),by-hh]);
        for(var ri=0;ri<=16;ri++) rPts.push([bx+hl,by-hh+ri*(dh/16)]);
        for(var ri=0;ri<=16;ri++) rPts.push([bx+hl-ri*(dw/16),by+hh]);
        for(var ri=0;ri<=16;ri++) rPts.push([bx-hl,by+hh-ri*(dh/16)]);
        state.cutContourPoints=rPts; state.cutContourPath=null;
        addScissorIcon(c,rPts);
      }
    } else if(result){
      /* Use the SVG path generated directly by getContourAndOffset — no
         additional smoothing/straightening (which warps curves around S, etc). */
      var _midSvg=result.offsetSvg;
      state.cutContourPath=_midSvg;state.cutContourPoints=result.offsetPts;
      c.insertAt(new fabric.Path(_midSvg,{fill:'#fff',stroke:'none',strokeWidth:0,selectable:false,evented:false,_isCutline:true}),imgIdx);
      c.insertAt(new fabric.Path(_midSvg,{fill:state.borderColor,stroke:'rgba(0,0,0,0.06)',strokeWidth:0.5,strokeLineJoin:'round',selectable:false,evented:false,_isCutline:true}),imgIdx+1);
      c.insertAt(new fabric.Path(_midSvg,{fill:'transparent',stroke:'#FF0000',strokeWidth:1,strokeLineJoin:'round',selectable:false,evented:false,_isCutline:true,_isCutEdge:true}),c.getObjects().length);
    } else {
      var b0f=isTemplateDieCut?(_tplPixelBounds||getTemplateElementsBounds(c)||img.getBoundingRect()):img.getBoundingRect();
      var b={left:b0f.left,top:b0f.top,width:b0f.width,height:b0f.height};
      var _fbRr=Math.min(b.width,b.height)*0.015;
      {
        var cx2=b.left+b.width/2,cy2=b.top+b.height/2;
        var baseProps={left:cx2,top:cy2,originX:'center',originY:'center',
          width:b.width+offset*2,height:b.height+offset*2,
          rx:_fbRr+offset*.15,ry:_fbRr+offset*.15,selectable:false,evented:false,_isCutline:true};
        c.insertAt(new fabric.Rect(Object.assign({},baseProps,{fill:'#ffffff',stroke:'none',strokeWidth:0,shadow:new fabric.Shadow({color:'rgba(0,0,0,0.25)',blur:6,offsetX:1,offsetY:2})})),imgIdx);
        c.insertAt(new fabric.Rect(Object.assign({},baseProps,{fill:state.borderColor,stroke:'rgba(0,0,0,0.08)',strokeWidth:0.5,shadow:new fabric.Shadow({color:'rgba(0,0,0,0.15)',blur:2,offsetX:1,offsetY:1})})),imgIdx+1);
        var hw=(b.width+offset*2)/2,hh=(b.height+offset*2)/2;
        var cr=Math.min(_fbRr+offset*0.15,hw,hh);
        var rPts=[],arcN=8,edgeN=8;
        for(var ri=0;ri<=edgeN;ri++) rPts.push([cx2-hw+cr+ri*((hw*2-cr*2)/edgeN),cy2-hh]);
        for(var ri=1;ri<=arcN;ri++){var a=-Math.PI/2+ri*(Math.PI/2)/arcN;rPts.push([cx2+hw-cr+Math.cos(a)*cr,cy2-hh+cr+Math.sin(a)*cr]);}
        for(var ri=1;ri<=edgeN;ri++) rPts.push([cx2+hw,cy2-hh+cr+ri*((hh*2-cr*2)/edgeN)]);
        for(var ri=1;ri<=arcN;ri++){var a=ri*(Math.PI/2)/arcN;rPts.push([cx2+hw-cr+Math.cos(a)*cr,cy2+hh-cr+Math.sin(a)*cr]);}
        for(var ri=1;ri<=edgeN;ri++) rPts.push([cx2+hw-cr-ri*((hw*2-cr*2)/edgeN),cy2+hh]);
        for(var ri=1;ri<=arcN;ri++){var a=Math.PI/2+ri*(Math.PI/2)/arcN;rPts.push([cx2-hw+cr+Math.cos(a)*cr,cy2+hh-cr+Math.sin(a)*cr]);}
        for(var ri=1;ri<=edgeN;ri++) rPts.push([cx2-hw,cy2+hh-cr-ri*((hh*2-cr*2)/edgeN)]);
        for(var ri=1;ri<=arcN;ri++){var a=Math.PI+ri*(Math.PI/2)/arcN;rPts.push([cx2-hw+cr+Math.cos(a)*cr,cy2-hh+cr+Math.sin(a)*cr]);}
        state.cutContourPoints=rPts;state.cutContourPath=null;
        c.insertAt(new fabric.Rect(Object.assign({},baseProps,{fill:'transparent',stroke:'#FF0000',strokeWidth:1,_isCutEdge:true,shadow:null})),c.getObjects().length);
      }
    }
    c.discardActiveObject();
    var _fCtx=(c.lowerCanvasEl||c.getElement()).getContext('2d');
    _fCtx.globalCompositeOperation='source-over';
    _fCtx.globalAlpha=1;
    if(_fCtx.filter!==undefined)_fCtx.filter='none';
    if(_savedPositions && _savedPositions.length) _restoreOverlayPositions(_savedPositions, getMainImage());
    c.renderAll();
    void c.getElement().offsetHeight;
    positionOverlays();
    updateDimLabel();
    _drawingCutline=false;
    if(!state.lockMode)state.adjusting=false;
    if(!state.skipAutoFit) autoFitView();
    window._sl2CheckHint&&_sl2CheckHint();
  }
  function addScissorIcon(c,pts){if(!pts||pts.length<4)return;var i=Math.round(pts.length*0.06),px=pts[i][0],py=pts[i][1],pv=pts[(i-1+pts.length)%pts.length],nx=pts[(i+1)%pts.length],ag=Math.atan2(nx[1]-pv[1],nx[0]-pv[0])*180/Math.PI;c.insertAt(new fabric.Path('M3.5 1C2.1 1 1 2.1 1 3.5 1 4.9 2.1 6 3.5 6 4.2 6 4.8 5.7 5.2 5.2L8 8 5.2 10.8C4.8 10.3 4.2 10 3.5 10 2.1 10 1 11.1 1 12.5 1 13.9 2.1 15 3.5 15 4.9 15 6 13.9 6 12.5 6 12 5.8 11.5 5.5 11.1L8 8.7 14 14.5 15 13.5 6.5 4.9C6.5 4.9 5.8 4.5 6 4.5 6 3.1 4.9 1 3.5 1ZM3.5 2.5C4.1 2.5 4.5 2.9 4.5 3.5 4.5 4.1 4.1 4.5 3.5 4.5 2.9 4.5 2.5 4.1 2.5 3.5 2.5 2.9 2.9 2.5 3.5 2.5ZM3.5 11.5C4.1 11.5 4.5 11.9 4.5 12.5 4.5 13.1 4.1 13.5 3.5 13.5 2.9 13.5 2.5 13.1 2.5 12.5 2.5 11.9 2.9 11.5 3.5 11.5ZM10 7.3L15 2.5 14 1.5 9.3 6.5 10 7.3Z',{left:px,top:py,originX:'center',originY:'center',scaleX:1.3,scaleY:1.3,angle:ag,fill:'#FF00FF',stroke:'#fff',strokeWidth:0.8,selectable:false,evented:false,_isCutline:true,_isCutEdge:true,shadow:new fabric.Shadow({color:'rgba(0,0,0,0.5)',blur:3,offsetX:0,offsetY:1})}),c.getObjects().length);}
  function positionOverlays(){
    if(!state.canvas) return;
    const c=state.canvas;
    const cw=c.getWidth(), ch=c.getHeight();
    let clip;
    if(state.cutContourPath){
      clip="path('"+state.cutContourPath+"')";
    } else if(state.cutContourPoints && state.cutContourPoints.length>=3){
      const pts=state.cutContourPoints;
      const polyPts=pts.map(p=>{
        const px=(p[0]/cw*100).toFixed(2)+'% '+(p[1]/ch*100).toFixed(2)+'%';
        return px;
      });
      clip='polygon('+polyPts.join(',')+')';
    } else {
      const cutlines=c.getObjects().filter(o=>o._isCutline);
      if(!cutlines.length) return;
      const lip=cutlines[cutlines.length-1];
      const b=lip.getBoundingRect();
      const top=b.top, right=cw-b.left-b.width, bottom=ch-b.top-b.height, left=b.left;
      const rr=Math.min(b.width,b.height)*0.06;
      clip='inset('+top+'px '+right+'px '+bottom+'px '+left+'px round '+rr+'px)';
    }
    const els=['glossLayer','holoOverlay','glossOverlay','vinylTexture','vinylSpecular','edgeRim'];
    els.forEach(id=>{
      const el=$('#'+id);
      if(!el) return;
      el.style.webkitClipPath=clip;
      el.style.clipPath=clip;
    });
  }
  function getTemplateElementsBounds(canvas){
    var els=canvas.getObjects().filter(function(o){return !o._isMainImage&&!o._isCutline;});
    if(!els.length) return null;
    var minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
    els.forEach(function(el){
      el.setCoords();var br=el.getBoundingRect();
      minX=Math.min(minX,br.left);minY=Math.min(minY,br.top);
      maxX=Math.max(maxX,br.left+br.width);maxY=Math.max(maxY,br.top+br.height);
    });
    return {left:minX,top:minY,width:maxX-minX,height:maxY-minY};
  }
  function getContourFromTemplateElements(canvas,offsetPx,hideMainImage){
    var _gctRestore=null;
    try{
      var elements=hideMainImage!==false?canvas.getObjects().filter(function(o){return !o._isMainImage&&!o._isCutline;}):canvas.getObjects().filter(function(o){return !o._isCutline;});
      if(!elements.length) return null;
      var cw=canvas.getWidth(),ch=canvas.getHeight();
      elements.forEach(function(o){o.setCoords();});
      var allMinL=Infinity,allMinT=Infinity,allMaxR=-Infinity,allMaxB=-Infinity;
      elements.forEach(function(o){
        var br=o.getBoundingRect();
        allMinL=Math.min(allMinL,br.left);allMinT=Math.min(allMinT,br.top);
        allMaxR=Math.max(allMaxR,br.left+br.width);allMaxB=Math.max(allMaxB,br.top+br.height);
      });
      var contentW=allMaxR-allMinL,contentH=allMaxB-allMinT;
      var extraM=Math.max(contentW,contentH)*0.15;
      allMinL-=extraM;allMinT-=extraM;allMaxR+=extraM;allMaxB+=extraM;
      contentW=allMaxR-allMinL;contentH=allMaxB-allMinT;
      /* Pad must cover the full closing radius (offsetPx + ~60% smoothR) plus
         a safety buffer for font-metric inaccuracy at glyph edges. Impact and
         similar display fonts often render past getBoundingRect by a few px. */
      var pad=Math.max(offsetPx*2+40,80);
      /* CRITICAL: expand fabric canvas dimensions if content + pad exceeds it.
         Previously we scaled-down content to fit existing canvas; that clipped
         the rightmost glyphs because i-text bbox != rendered pixel extent.
         Mirrors the canvas-expansion pattern in _sl2GetTextHaloContour. */
      var eL=Math.max(0,Math.ceil(pad-allMinL));
      var eT=Math.max(0,Math.ceil(pad-allMinT));
      var eW=Math.max(cw,Math.ceil(allMaxR+pad+eL));
      var eH=Math.max(ch,Math.ceil(allMaxB+pad+eT));
      var ex=eL>0||eT>0||eW>cw||eH>ch;
      var origVT=canvas.viewportTransform?canvas.viewportTransform.slice():null;
      if(ex){
        elements.forEach(function(o){o.set({left:o.left+eL,top:o.top+eT});o.setCoords();});
        canvas.setWidth(eW);canvas.setHeight(eH);
        if(origVT) canvas.viewportTransform=[1,0,0,1,0,0];
        _gctRestore=function(){
          elements.forEach(function(o){o.set({left:o.left-eL,top:o.top-eT});o.setCoords();});
          canvas.setWidth(cw);canvas.setHeight(ch);
          if(origVT) canvas.viewportTransform=origVT;
        };
      }
      var srcEl=canvas.getElement();
      var sw=srcEl.width,sh=srcEl.height,dpr=sw/(ex?eW:cw);
      var tc=document.createElement('canvas');tc.width=sw;tc.height=sh;
      var ctx=tc.getContext('2d');
      var prevActive=canvas.getActiveObject();
      canvas.discardActiveObject();
      var allObjs=canvas.getObjects();
      var visState=allObjs.map(function(o){return o.visible!==false;});
      var cacheState=elements.map(function(o){return o.objectCaching;});
      elements.forEach(function(o){o.objectCaching=false;o.dirty=true;});
      allObjs.forEach(function(o){if(o._isCutline) o.visible=false; else if(hideMainImage!==false&&o._isMainImage) o.visible=false;});
      var origBg=canvas.backgroundColor;
      canvas.backgroundColor='transparent';
      canvas.renderAll();
      ctx.drawImage(srcEl,0,0);
      elements.forEach(function(o,i){o.objectCaching=cacheState[i]!==false;});
      allObjs.forEach(function(o,i){o.visible=visState[i];});
      if(prevActive) canvas.setActiveObject(prevActive);
      canvas.backgroundColor=origBg;
      /* Restore canvas dimensions and object positions BEFORE returning. */
      if(_gctRestore){_gctRestore();_gctRestore=null;}
      canvas.renderAll();
      var data=ctx.getImageData(0,0,sw,sh).data;
      var mask=new Uint8Array(sw*sh);
      var pxMinX=sw,pxMinY=sh,pxMaxX=0,pxMaxY=0;
      /* Cutcontour-matched alpha threshold of 128 */
      for(var py=0;py<sh;py++){
        for(var px=0;px<sw;px++){
          var idx=py*sw+px;
          if(data[idx*4+3]>128){
            mask[idx]=1;
            if(px<pxMinX) pxMinX=px;if(px>pxMaxX) pxMaxX=px;
            if(py<pxMinY) pxMinY=py;if(py>pxMaxY) pxMaxY=py;
          }
        }
      }
      if(pxMaxX<=pxMinX||pxMaxY<=pxMinY) return null;
      /* Translate from expanded-canvas pixel coords back to original canvas coords:
         divide by dpr to get expanded-canvas coords, then subtract shift (eL,eT). */
      var _bL=pxMinX/dpr-(ex?eL:0),_bT=pxMinY/dpr-(ex?eT:0),_bW=(pxMaxX-pxMinX)/dpr,_bH=(pxMaxY-pxMinY)/dpr;
      _tplPixelBounds={left:_bL,top:_bT,width:_bW,height:_bH};
      _fillHoles(mask,sw,sh);
      /* Cutcontour-style template contour: same algorithm as single PNG path.
         No Clipper, no rdpSimplify, no smoothPoints, no Bezier. Just morphological
         closing + mooreTrace + raw M+L line segments. */
      var R=Math.max(1,Math.round(offsetPx*dpr));
      var smoothR=Math.ceil(R*((typeof getSmoothMultiplier==='function')?getSmoothMultiplier():0.6));
      function _ccDilate(m,radius,w){
        var h=m.length/w,bMap=new Uint8Array(m.length);
        var aR=Math.ceil(Math.abs(radius)),offs=[];
        for(var dy=-aR;dy<=aR;dy++)for(var dx=-aR;dx<=aR;dx++)if(dy*dy+dx*dx<=aR*aR)offs.push(dy+dx*w);
        for(var x=0;x<w;x++){var st=0;for(var y=0;y<h;y++){var idx=x+y*w,p=m[idx]?1:0;if(p!==st){var adj=st===0?0:-w;for(var i=0;i<offs.length;i++){var t=idx+offs[i]+adj;if(t>=0&&t<bMap.length)bMap[t]=1;}}st=p;}}
        for(var y=0;y<h;y++){var st=0;for(var x=0;x<w;x++){var idx=x+y*w,p=m[idx]?1:0;if(p!==st){var adj=st===0?0:-1;for(var i=0;i<offs.length;i++){var t=idx+offs[i]+adj;if(t>=0&&t<bMap.length)bMap[t]=1;}}st=p;}}
        var fill=radius<0?0:1;
        for(var i=0;i<bMap.length;i++)if(bMap[i])m[i]=fill;
        return m;
      }
      var dil=new Uint8Array(mask);
      _ccDilate(dil,R+smoothR,sw);
      _fillHoles(dil,sw,sh);
      if(smoothR>0){
        var inv=new Uint8Array(sw*sh);
        for(var ii=0;ii<sw*sh;ii++)inv[ii]=dil[ii]?0:1;
        _ccDilate(inv,smoothR,sw);
        for(var ii=0;ii<sw*sh;ii++)dil[ii]=inv[ii]?0:1;
      }
      var tM=new Uint8Array(dil);
      var allTraced=[];
      for(var cp=0;cp<20;cp++){
        var rw=mooreTrace(tM,sw,sh);
        if(!rw.length)break;
        if(rw.length>=4)allTraced.push(rw);
        var b0=rw[0][1]*sw+rw[0][0];
        if(b0>=0&&b0<sw*sh){var fq=[b0];tM[b0]=0;while(fq.length){var fi=fq.pop(),fx=fi%sw,fy=(fi-fx)/sw;for(var dy=-1;dy<=1;dy++)for(var dx=-1;dx<=1;dx++){var nx=fx+dx,ny=fy+dy;if(nx>=0&&nx<sw&&ny>=0&&ny<sh){var ni=ny*sw+nx;if(tM[ni]){tM[ni]=0;fq.push(ni);}}}}}
      }
      if(!allTraced.length)return null;
      var aS=[],aP=[];
      for(var pi=0;pi<allTraced.length;pi++){
        var lp=allTraced[pi].map(function(p){
          /* Subtract expanded-canvas shift to land in original canvas coords. */
          return[p[0]/dpr-(ex?eL:0),p[1]/dpr-(ex?eT:0)];
        });
        if(lp.length<4)continue;
        /* Flatten pixel stair-steps before mid-bezier (raw mask trace, so looser than image+text's 0.5/0.7). */
        var lpSm=rdpR(lp,2.0);
        if(window._sl2StraightenRuns)lpSm=window._sl2StraightenRuns(lpSm,1.5);
        if(window._sl2FlattenAxialRuns)lpSm=window._sl2FlattenAxialRuns(lpSm,0.35);
        var d=(window._sl2MidSvg&&lpSm.length>=3)?window._sl2MidSvg(lpSm):null;
        if(!d){d='M '+lpSm[0][0]+' '+lpSm[0][1];for(var li=1;li<lpSm.length;li++)d+=' L '+lpSm[li][0]+' '+lpSm[li][1];d+=' Z';}
        aS.push(d);aP.push(lpSm);
      }
      if(!aS.length)return null;
      return {offsetSvg:aS.join(' '),offsetPts:aP[0],allOffsetPts:aP};
    }catch(e){if(_gctRestore){try{_gctRestore();}catch(_){}}return null;}
  }
  function _gaussBlur(s,w,h,sig){var r=Math.ceil(sig*3),ks=r*2+1,k=[],sm=0;for(var i=0;i<ks;i++){var d=i-r;k[i]=Math.exp(-d*d/(2*sig*sig));sm+=k[i];}for(var i=0;i<ks;i++)k[i]/=sm;var t=new Float32Array(w*h);for(var y=0;y<h;y++)for(var x=0;x<w;x++){var v=0;for(var i=0;i<ks;i++){var sx=x+i-r;if(sx<0)sx=0;if(sx>=w)sx=w-1;v+=s[y*w+sx]*k[i];}t[y*w+x]=v;}var dst=new Float32Array(w*h);for(var y=0;y<h;y++)for(var x=0;x<w;x++){var v=0;for(var i=0;i<ks;i++){var sy=y+i-r;if(sy<0)sy=0;if(sy>=h)sy=h-1;v+=t[sy*w+x]*k[i];}dst[y*w+x]=v;}return dst;}
  function _fillHoles(m,w,h){var bg=new Uint8Array(w*h),q=[],qi=0;for(var x=0;x<w;x++){if(!m[x]){bg[x]=1;q.push(x);}var bi=(h-1)*w+x;if(!m[bi]){bg[bi]=1;q.push(bi);}}for(var y=1;y<h-1;y++){if(!m[y*w]){bg[y*w]=1;q.push(y*w);}var ri=y*w+w-1;if(!m[ri]){bg[ri]=1;q.push(ri);}}while(qi<q.length){var idx=q[qi++],ix=idx%w,iy=(idx-ix)/w;for(var dy=-1;dy<=1;dy++)for(var dx=-1;dx<=1;dx++){var nx=ix+dx,ny=iy+dy;if(nx>=0&&nx<w&&ny>=0&&ny<h){var ni=ny*w+nx;if(!m[ni]&&!bg[ni]){bg[ni]=1;q.push(ni);}}}}for(var i=0;i<w*h;i++)if(!m[i]&&!bg[i])m[i]=1;}
  /* Studio Next fix: render an image object the way it is shown (rotated/flipped) into a
     canvas the size of its bounding box, so the contour is traced from what the customer sees. */
  function _smnOriented(o,src){
    var b=o.getBoundingRect(),vz=(o.canvas&&o.canvas.viewportTransform)?o.canvas.viewportTransform[0]:1;
    var nw=src.naturalWidth||src.width,dW=o.width*o.scaleX*vz,dH=o.height*o.scaleY*vz;
    var k=Math.min(nw/Math.max(1,dW),2400/Math.max(1,b.width,b.height));
    var cv=document.createElement('canvas');cv.width=Math.max(1,Math.ceil(b.width*k));cv.height=Math.max(1,Math.ceil(b.height*k));
    var x=cv.getContext('2d');x.imageSmoothingQuality='high';x.translate(cv.width/2,cv.height/2);
    x.rotate((o.angle||0)*Math.PI/180);x.scale(o.flipX?-1:1,o.flipY?-1:1);x.drawImage(src,-dW*k/2,-dH*k/2,dW*k,dH*k);
    return cv;
  }
  function getContourAndOffset(fabricImg,offsetPx){
    try{
      var _srcEl=fabricImg.getElement(); if(!_srcEl) return null;
      const el=(((fabricImg.angle||0)%360)||fabricImg.flipX||fabricImg.flipY)?_smnOriented(fabricImg,_srcEl):_srcEl;
      const oW=el.naturalWidth||el.width,oH=el.naturalHeight||el.height;
      /* Cap source res at ~3x displayed size; high-res clipart shown small made R huge and froze the UI. */
      const _bForMax=fabricImg.getBoundingRect();
      const _maxRel=Math.max(_bForMax.width,_bForMax.height)*3;
      const maxD=Math.min(2400,Math.max(400,_maxRel));
      const sd=Math.min(maxD/oW,maxD/oH,1),sw=Math.round(oW*sd),sh=Math.round(oH*sd);
      /* Cache the decoded image pixel data per image element to avoid
         re-decoding + reading on every cutline recompute (30-50% speedup). */
      var data;
      if(el._smsImgDataCache&&el._smsImgDataCache.sw===sw&&el._smsImgDataCache.sh===sh){
        data=el._smsImgDataCache.data;
      } else {
        const tc=document.createElement('canvas'); tc.width=sw; tc.height=sh;
        const ctx=tc.getContext('2d'); ctx.drawImage(el,0,0,sw,sh);
        data=ctx.getImageData(0,0,sw,sh).data;
        try{el._smsImgDataCache={sw:sw,sh:sh,data:data};}catch(_e){}
      }
      let tp=0; for(let i=0;i<sw*sh;i++) if(data[i*4+3]<240) tp++;
      if(tp<10){
        const b=fabricImg.getBoundingRect(),cr=Math.min(b.width,b.height)*0.015;
        const rP=_mkRRPts(b.left,b.top,b.width,b.height,cr);
        const CS2=5000,clP=rP.map(p=>({X:Math.round(p[0]*CS2),Y:Math.round(p[1]*CS2)}));
        const co2=new ClipperLib.ClipperOffset();co2.ArcTolerance=0.05*CS2;
        co2.AddPath(clP,ClipperLib.JoinType.jtRound,ClipperLib.EndType.etClosedPolygon);
        const sl2=new ClipperLib.Paths();co2.Execute(sl2,offsetPx*CS2);
        if(!sl2.length){const s2=ptsToSmoothSvg(rP);return s2?{offsetSvg:s2,offsetPts:rP}:null;}
        const oR2=sl2[0].map(p=>[p.X/CS2,p.Y/CS2]);var oS2=rdpR(oR2,0.05);
        return {offsetSvg:ptsToSmoothSvg(oS2),offsetPts:oS2};
      }
      const b=fabricImg.getBoundingRect(), sX=b.width/sw, sY=b.height/sh;
      var sbR=state.cutStyle==='tight'?0.025:state.cutStyle==='medium'?0.05:state.cutStyle==='loose'?0.075:0;
      /* R in source px; R*sX must equal offsetPx, so divide by displayed width (not a fixed 700). */
      var _refW=Math.max(1,b.width);
      var dilR=sbR>0?Math.max(1,Math.round(sw*sbR)):Math.max(1,Math.round(Math.abs(offsetPx)*sw/_refW));
      var _padR=Math.max(1,Math.round(Math.abs(offsetPx)*sw/_refW));
      var _padTotal=Math.ceil(_padR*1.8)+15;
      var pad=Math.max(_padTotal,Math.ceil(sw*0.08),dilR+6), pw=sw+pad*2, ph=sh+pad*2;
      var pc=document.createElement('canvas');pc.width=pw;pc.height=ph;
      var pcx=pc.getContext('2d');pcx.drawImage(el,pad,pad,sw,sh);
      var pData=pcx.getImageData(0,0,pw,ph).data;
      var alphaF=new Float32Array(pw*ph);for(var ai=0;ai<pw*ph;ai++) alphaF[ai]=pData[ai*4+3];
      var blurA=_gaussBlur(alphaF,pw,ph,1.5);
      var mask=new Uint8Array(pw*ph);
      /* Threshold the BLURRED alpha (not raw) — anti-aliases boundary pixels
         so morphological closing operates on a smoother starting boundary.
         Result: silkier cutline at the source. */
      for(var i=0;i<pw*ph;i++) mask[i]=blurA[i]>128?1:0;
      _fillHoles(mask,pw,ph);
      /* R uses the same _refW (= b.width) as _padR so the final cutline lands
         at exactly offsetPx canvas units outside the silhouette. */
      var R=Math.max(1,Math.round(Math.abs(offsetPx)*sw/_refW));
      /* Cutcontour's orn_dilateImageMap verbatim — true circular kernel,
         state=false initial, 2-pass scan. */
      function _ccDilate(m,radius,w){
        var h=m.length/w,bMap=new Uint8Array(m.length);
        var aR=Math.ceil(Math.abs(radius)),offs=[];
        for(var dy=-aR;dy<=aR;dy++)for(var dx=-aR;dx<=aR;dx++)if(dy*dy+dx*dx<=aR*aR)offs.push(dy+dx*w);
        for(var x=0;x<w;x++){var st=0;for(var y=0;y<h;y++){var idx=x+y*w,p=m[idx]?1:0;if(p!==st){var adj=st===0?0:-w;for(var i=0;i<offs.length;i++){var t=idx+offs[i]+adj;if(t>=0&&t<bMap.length)bMap[t]=1;}}st=p;}}
        for(var y=0;y<h;y++){var st=0;for(var x=0;x<w;x++){var idx=x+y*w,p=m[idx]?1:0;if(p!==st){var adj=st===0?0:-1;for(var i=0;i<offs.length;i++){var t=idx+offs[i]+adj;if(t>=0&&t<bMap.length)bMap[t]=1;}}st=p;}}
        var fill=radius<0?0:1;
        for(var i=0;i<bMap.length;i++)if(bMap[i])m[i]=fill;
        return m;
      }
      /* Cutcontour's orn_dilateSmoothImageMap: morphological closing.
         smoothR=ceil(R*0.5) — stronger smoothing for cleaner curves. */
      var smoothR=Math.ceil(R*((typeof getSmoothMultiplier==='function')?getSmoothMultiplier():0.6));
      var dil=new Uint8Array(mask);
      _ccDilate(dil,R+smoothR,pw);
      _fillHoles(dil,pw,ph);
      if(smoothR>0){
        var inv=new Uint8Array(pw*ph);
        for(var ii=0;ii<pw*ph;ii++)inv[ii]=dil[ii]?0:1;
        _ccDilate(inv,smoothR,pw);
        for(var ii=0;ii<pw*ph;ii++)dil[ii]=inv[ii]?0:1;
      }
      var tM=new Uint8Array(dil.length);for(var mi=0;mi<dil.length;mi++) tM[mi]=dil[mi];
      var allTraced=[];
      for(var cp=0;cp<30;cp++){
        var rw=mooreTrace(tM,pw,ph);
        if(!rw.length) break;
        if(rw.length>=4) allTraced.push(rw);
        var b0=rw[0][1]*pw+rw[0][0];
        if(b0>=0&&b0<pw*ph){var fq=[b0];tM[b0]=0;while(fq.length){var fi=fq.pop(),fx=fi%pw,fy=(fi-fx)/pw;for(var fdy=-1;fdy<=1;fdy++)for(var fdx=-1;fdx<=1;fdx++){var fnx=fx+fdx,fny=fy+fdy;if(fnx>=0&&fnx<pw&&fny>=0&&fny<ph){var fni=fny*pw+fnx;if(tM[fni]){tM[fni]=0;fq.push(fni);}}}}}
      }
      if(!allTraced.length) return null;
      /* RAW pixel-coordinate path — NO rdpR simplification, NO smoothing,
         NO Bezier curves. Just M followed by L commands at each pixel. This
         is cutcontour's pixel-perfect rendering expressed as a vector path. */
      var aS=[],aP=[];
      /* Quadratic midpoint Bezier — same points, no shape change.
         Collinear triples produce degenerate (straight) curves so flat edges
         stay flat. Angled triples produce smooth corner curves. */
      for(var pi=0;pi<allTraced.length;pi++){
        var lp=allTraced[pi].map(function(p){return[(p[0]-pad)*sX+b.left,(p[1]-pad)*sY+b.top];});
        if(lp.length<4) continue;
        if(lp.length>24){var _fl=rdpR(smoothPoints(lp,2),Math.max(0.05,0.5*Math.max(sX,sY)));if(_fl&&_fl.length>=8)lp=_fl;}
        var d=(window._sl2MidSvg)?window._sl2MidSvg(lp):null;
        if(!d){d='M '+lp[0][0]+' '+lp[0][1];for(var li=1;li<lp.length;li++)d+=' L '+lp[li][0]+' '+lp[li][1];d+=' Z';}
        aS.push(d);aP.push(lp);
      }
      if(!aS.length) return null;
      return {offsetSvg:aS.join(' '),offsetPts:aP[0],allOffsetPts:aP};
    }catch(e){return null;}
  }
  function smoothPoints(pts,passes){
    if(!pts||pts.length<4) return pts;
    let arr=pts.map(p=>[p[0],p[1]]);
    for(let p=0;p<passes;p++){
      const next=[],n=arr.length;
      for(let i=0;i<n;i++){
        const prev=arr[(i-1+n)%n],curr=arr[i],nxt=arr[(i+1)%n];
        next.push([prev[0]*0.3+curr[0]*0.4+nxt[0]*0.3,prev[1]*0.3+curr[1]*0.4+nxt[1]*0.3]);
      }
      arr=next;
    }
    return arr;
  }
  function ptsToSmoothSvg(pts){
    if(!pts||pts.length<3) return null;
    var n=pts.length,p='M '+pts[0][0]+' '+pts[0][1],t=5;
    for(var i=0;i<n;i++){var p0=pts[(i-1+n)%n],p1=pts[i],p2=pts[(i+1)%n],p3=pts[(i+2)%n];
    p+=' C '+(p1[0]+(p2[0]-p0[0])/t)+' '+(p1[1]+(p2[1]-p0[1])/t)+' '+(p2[0]-(p3[0]-p1[0])/t)+' '+(p2[1]-(p3[1]-p1[1])/t)+' '+p2[0]+' '+p2[1];}
    return p+' Z';
  }
  function getTextHaloContour(c,offsetPx,opts){return window._sl2GetTextHaloContour&&window._sl2GetTextHaloContour(c,offsetPx,{dilateMask:dilateMask,smoothMask:smoothMask,mooreTrace:mooreTrace,rdpR:rdpR,ptsToSmoothSvg:ptsToSmoothSvg},opts);}
  function _mkRRPts(l,t,w,h,cr2,an2){
    var r2=l+w,b2=t+h,cc=Math.min(cr2,w/2,h/2),rp=[],an=an2||6;
    for(var i=0;i<=an;i++){var a=-Math.PI/2+i*(Math.PI/2)/an;rp.push([r2-cc+Math.cos(a)*cc,t+cc+Math.sin(a)*cc]);}
    for(var i=1;i<=an;i++){var a=i*(Math.PI/2)/an;rp.push([r2-cc+Math.cos(a)*cc,b2-cc+Math.sin(a)*cc]);}
    for(var i=1;i<=an;i++){var a=Math.PI/2+i*(Math.PI/2)/an;rp.push([l+cc+Math.cos(a)*cc,b2-cc+Math.sin(a)*cc]);}
    for(var i=1;i<=an;i++){var a=Math.PI+i*(Math.PI/2)/an;rp.push([l+cc+Math.cos(a)*cc,t+cc+Math.sin(a)*cc]);}
    return rp;
  }
  function getVecContour(obj,offPx){
    var b=obj.getBoundingRect();if(b.width<2||b.height<2)return null;
    var cr=obj.type==='circle'?b.width/2:obj.type==='i-text'?Math.min(b.width,b.height)*.5:obj.rx>0?obj.rx*(obj.scaleX||1):Math.min(b.width,b.height)*.22;
    var pts=_mkRRPts(b.left,b.top,b.width,b.height,cr,32),K=5000;
    var cl=pts.map(function(p){return{X:p[0]*K+.5|0,Y:p[1]*K+.5|0};});
    var co=new ClipperLib.ClipperOffset();co.ArcTolerance=.05*K;
    co.AddPath(cl,ClipperLib.JoinType.jtRound,ClipperLib.EndType.etClosedPolygon);
    var sl=new ClipperLib.Paths();co.Execute(sl,offPx*K);
    if(!sl.length)return{offsetSvg:ptsToSmoothSvg(pts),offsetPts:pts};
    var op=sl[0].map(function(p){return[p.X/K,p.Y/K];});
    return{offsetSvg:ptsToSmoothSvg(op),offsetPts:op};
  }
  function dilateMask(mask,w,h,r){
    if(r<=0) return new Uint8Array(mask);
    const d=new Float32Array(w*h).fill(1e9);
    for(let i=0;i<w*h;i++) if(mask[i]) d[i]=0;
    for(let y=0;y<h;y++) for(let x=0;x<w;x++){const i=y*w+x;if(x>0)d[i]=Math.min(d[i],d[i-1]+1);if(y>0)d[i]=Math.min(d[i],d[(y-1)*w+x]+1);if(x>0&&y>0)d[i]=Math.min(d[i],d[(y-1)*w+x-1]+1.41);if(x<w-1&&y>0)d[i]=Math.min(d[i],d[(y-1)*w+x+1]+1.41);}
    for(let y=h-1;y>=0;y--) for(let x=w-1;x>=0;x--){const i=y*w+x;if(x<w-1)d[i]=Math.min(d[i],d[i+1]+1);if(y<h-1)d[i]=Math.min(d[i],d[(y+1)*w+x]+1);if(x<w-1&&y<h-1)d[i]=Math.min(d[i],d[(y+1)*w+x+1]+1.41);if(x>0&&y<h-1)d[i]=Math.min(d[i],d[(y+1)*w+x-1]+1.41);}
    const out=new Uint8Array(w*h); for(let i=0;i<w*h;i++) out[i]=d[i]<=r?1:0; return out;
  }
  function smoothMask(mask,w,h){const c=new Uint8Array(mask);for(let y=1;y<h-1;y++)for(let x=1;x<w-1;x++){let s=0;for(let dy=-1;dy<=1;dy++)for(let dx=-1;dx<=1;dx++)s+=c[(y+dy)*w+(x+dx)];mask[y*w+x]=s>=5?1:0;}}
  function mooreTrace(mask,w,h){
    const pw=w+2,ph=h+2,pad=new Uint8Array(pw*ph);
    for(let y=0;y<h;y++)for(let x=0;x<w;x++)pad[(y+1)*pw+(x+1)]=mask[y*w+x];
    let sx=-1,sy=-1;
    findS:for(let y=0;y<ph;y++)for(let x=0;x<pw;x++)if(pad[y*pw+x]){sx=x;sy=y;break findS;}
    if(sx<0) return [];
    const ndx=[1,1,0,-1,-1,-1,0,1],ndy=[0,1,1,1,0,-1,-1,-1];
    const cont=[];let cx=sx,cy=sy,bd=4;
    for(let step=0;step<pw*ph;step++){
      cont.push([cx-1,cy-1]);let ss=(bd+1)%8,found=false;
      for(let i=0;i<8;i++){const dir=(ss+i)%8,nx=cx+ndx[dir],ny=cy+ndy[dir];if(nx>=0&&nx<pw&&ny>=0&&ny<ph&&pad[ny*pw+nx]){bd=(dir+4)%8;cx=nx;cy=ny;found=true;break;}}
      if(!found)break;if(cx===sx&&cy===sy&&step>0)break;
    }
    return cont;
  }
  function rdpSimplify(pts,eps){
    if(pts.length<=2) return pts;
    let mx=0,mi=0;const a=pts[0],b=pts[pts.length-1];
    for(let i=1;i<pts.length-1;i++){const d=ptLD(pts[i],a,b);if(d>mx){mx=d;mi=i;}}
    if(mx>eps){const l=rdpSimplify(pts.slice(0,mi+1),eps),r=rdpSimplify(pts.slice(mi),eps);return l.slice(0,-1).concat(r);}
    return[a,b];
  }
  function ptLD(p,a,b){const dx=b[0]-a[0],dy=b[1]-a[1],l2=dx*dx+dy*dy;if(l2===0)return Math.hypot(p[0]-a[0],p[1]-a[1]);const t=Math.max(0,Math.min(1,((p[0]-a[0])*dx+(p[1]-a[1])*dy)/l2));return Math.hypot(p[0]-(a[0]+t*dx),p[1]-(a[1]+t*dy));}
  function rdpR(p,e){if(p.length<5)return p;var m=0,f=0;for(var i=1;i<p.length;i++){var d=(p[i][0]-p[0][0])**2+(p[i][1]-p[0][1])**2;if(d>m){m=d;f=i;}}var a=rdpSimplify(p.slice(0,f+1),e),b=rdpSimplify(p.slice(f).concat([p[0]]),e);return a.slice(0,-1).concat(b.slice(0,-1));}
  $$('.sms-tool-icon[data-bg]').forEach(opt=>{
    opt.addEventListener('click', async()=>{
      if(!state.originalImg) return;
      const mode=opt.dataset.bg; if(mode===state.bgMode) return;
      $$('.sms-tool-icon[data-bg]').forEach(o=>o.classList.remove('active'));
      opt.classList.add('active');
      if(mode==='none'){ state.bgMode='none'; state.processedImg=null; replaceCanvasImage(state.originalImg); D.bgs.textContent=''; return; }
      function _bgFail(e){console.error('[bg]',e);hideProgress();D.bgs.textContent='Error: '+(e&&e.message||'failed');$$('.sms-tool-icon[data-bg]').forEach(o=>o.classList.remove('active'));$('.sms-tool-icon[data-bg="none"]').classList.add('active');state.bgMode='none';}
      if(mode==='solid'){
        state.bgMode='solid';showProgress('Removing border...');
        try{var ni=await loadImgFromCanvas(removeSolidBg(state.originalImg));state.processedImg=ni;replaceCanvasImage(ni);hideProgress();D.bgs.textContent='Done.';}catch(e){_bgFail(e);}
        return;
      }
      if(mode==='ai'||mode==='pro'){
        state.bgMode=mode;
        showProgress(mode==='pro'?'Cloud removing background...':'Loading AI model...');
        try{
          var rb;
          if(mode==='ai'){
            rb=await window._sl2BgAi(state.originalImg,showProgress);
          }else{
            var blob=await window._sl2ProCBlob(state.originalImg);
            showProgress('Removing background...');
            rb=await window._sl2BgPro(blob);
          }
          showProgress('Cleaning edges...');
          /* For cloud bg removal, pass a hard alpha threshold (128) so semi-transparent
             halo pixels that retained the original bg color get nuked. */
          var ci=await cleanAlphaEdges(rb,true,mode==='pro'?128:null);
          state.processedImg=ci;replaceCanvasImage(ci);hideProgress();D.bgs.textContent='Done!';
        }catch(e){_bgFail(e);}
        return;
      }
    });
  });
  var removeSolidBg=window._sl2RemoveSolidBg,loadImgFromCanvas=window._sl2LIC,cleanAlphaEdges=window._sl2CleanAE;
  function replaceCanvasImage(imgEl){
    if(!state.canvas) return;
    const c=state.canvas; c.getObjects().slice().forEach(o=>c.remove(o));
    const off=getCutOffset();
    const s=Math.min((c.width*.8-off*2)/imgEl.width,(c.height*.8-off*2)/imgEl.height,1);
    const f=new fabric.Image(imgEl,{left:c.width/2,top:c.height/2,originX:'center',originY:'center',scaleX:s,scaleY:s});
    lockImage(f); c.add(f); c.setActiveObject(f); c.renderAll();
    if(state.shape==='die-cut'){ drawCutline(); }
    else { applyShape(); }
    saveState();
  }
  async function generatePrintPDF(){
    if(!state.canvas || !getMainContent()) return null;
    state.canvas.discardActiveObject();
    var _tb=D.ttb;if(_tb)_tb.style.display='none';
    state.canvas.renderAll();
    showProgress('Generating print file...');
    try{
      var DPI=600;
      var lipBnds=getLipBounds();
      if(!lipBnds){ hideProgress(); alert('No sticker to export.'); return; }
      var totalW,totalH;
      if(state.size==='custom' && state.shape==='die-cut' && lipBnds){
        var dcA=lipBnds.width/lipBnds.height;
        var dcMax=getCustomSizeInches()||Math.max(parseFloat($('#smsCustomW').value)||3,parseFloat($('#smsCustomH').value)||3);
        if(dcA>=1){totalW=dcMax;totalH=+(dcMax/dcA).toFixed(2);}
        else{totalH=dcMax;totalW=+(dcMax*dcA).toFixed(2);}
      } else if(state.size==='custom'){
        totalW=parseFloat($('#smsCustomW').value)||3;
        totalH=parseFloat($('#smsCustomH').value)||3;
      } else {
        var m=state.size.match(/(\d+)/), d=m?parseInt(m[1]):2;
        if(state.shape==='circle'||state.shape==='square'){
          totalW=d; totalH=d;
        } else if(state.shape==='rectangle'||state.shape==='oval'){
          totalW=d; totalH=+(d*0.667).toFixed(2);
          if(state.shapePortrait){var tmp=totalW;totalW=totalH;totalH=tmp;}
        } else {
          var lipAspect=lipBnds.width/lipBnds.height;
          if(lipAspect>=1){totalW=d; totalH=+(d/lipAspect).toFixed(2);}
          else {totalH=d; totalW=+(d*lipAspect).toFixed(2);}
        }
      }
      var _mainImg=getMainContent();
      if(_mainImg && _mainImg.type==='image' && _mainImg.getElement){
        var _e=_mainImg.getElement();
        var _natMax=Math.max(_e.naturalWidth||_e.width||0, _e.naturalHeight||_e.height||0);
        var _maxIn=Math.max(totalW||1,totalH||1);
        if(_natMax>0 && _maxIn>0){
          var _srcDPI=_natMax/_maxIn;
          DPI=Math.max(600,Math.min(1200,Math.round(_srcDPI)));
        }
      }
      var _smnIOS=/iP(hone|ad|od)/.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
      var _smnCap=Math.floor(Math.sqrt((_smnIOS?15e6:80e6)/((totalW+4/25.4)*(totalH+4/25.4))));
      if(DPI>_smnCap)DPI=Math.max(150,_smnCap);
      var bIn=2/25.4;
      var tPxW=Math.round(totalW*DPI),tPxH=Math.round(totalH*DPI);
      var bPx=Math.round(bIn*DPI);
      var pxW=tPxW+bPx*2,pxH=tPxH+bPx*2;
      var bPt=bIn*72,tPtW=totalW*72,tPtH=totalH*72;
      var ptW=tPtW+bPt*2,ptH=tPtH+bPt*2;
      var mainImg=getMainContent();
      var _isImg=mainImg&&mainImg.type==='image'&&!mainImg._isTemplateBg;
      var mapX=tPxW/lipBnds.width,mapY=tPxH/lipBnds.height;
      var el=null,imgCX=0,imgCY=0,dw=0,dh=0;
      if(_isImg){
        el=mainImg.getElement();
        var natW=el.naturalWidth||el.width,natH=el.naturalHeight||el.height;
        imgCX=mainImg.left;imgCY=mainImg.top;
        if(mainImg.originX==='left')imgCX+=natW*mainImg.scaleX/2;
        if(mainImg.originY==='top')imgCY+=natH*mainImg.scaleY/2;
        dw=natW*mainImg.scaleX*mapX;dh=natH*mainImg.scaleY*mapY;
      }
      var pc=document.createElement('canvas');
      pc.width=pxW; pc.height=pxH;
      var pctx=pc.getContext('2d');pctx.imageSmoothingQuality='high';
      var _printFilter='saturate(1.08) contrast(1.04)';
      if(state.finish==='glossy') _printFilter='saturate(1.13) contrast(1.06) brightness(1.01)';
      else if(state.finish==='holographic') _printFilter='saturate(1.14) contrast(1.07) brightness(1.02)';
      if(pctx.filter!==undefined) pctx.filter=_printFilter;
      function _dCut(c,e){
        c.beginPath();
        if(state.shape==='circle')c.arc(pxW/2,pxH/2,Math.min(tPxW,tPxH)/2+e,0,Math.PI*2);
        else if(state.shape==='oval')c.ellipse(pxW/2,pxH/2,tPxW/2+e,tPxH/2+e,0,0,Math.PI*2);
        else if(state.shape==='die-cut'&&state.cutContourPoints&&state.cutContourPoints.length>=3){
          var pts=state.cutContourPoints,ok=false;
          if(e>0&&window.ClipperLib)try{
            var CS=5000,sp=pts.map(function(p){return{X:Math.round(((p[0]-lipBnds.left)*mapX+bPx)*CS),Y:Math.round(((p[1]-lipBnds.top)*mapY+bPx)*CS)};});
            var co=new ClipperLib.ClipperOffset();co.ArcTolerance=.25*CS;
            co.AddPath(sp,ClipperLib.JoinType.jtRound,ClipperLib.EndType.etClosedPolygon);
            var sol=new ClipperLib.Paths();co.Execute(sol,e*CS);
            if(sol.length){sol.forEach(function(p){if(!p||p.length<3)return;c.moveTo(p[0].X/CS,p[0].Y/CS);for(var i=1;i<p.length;i++)c.lineTo(p[i].X/CS,p[i].Y/CS);c.closePath();});ok=true;}
          }catch(_e){}
          if(!ok){c.moveTo((pts[0][0]-lipBnds.left)*mapX+bPx,(pts[0][1]-lipBnds.top)*mapY+bPx);for(var i=1;i<pts.length;i++)c.lineTo((pts[i][0]-lipBnds.left)*mapX+bPx,(pts[i][1]-lipBnds.top)*mapY+bPx);c.closePath();}
        } else {
          var rr=state.shape==='square'?0:Math.min(tPxW,tPxH)*0.04;
          c.roundRect(bPx-e,bPx-e,tPxW+e*2,tPxH+e*2,rr+e);
        }
      }
      function _rcTo(ctx,hideFn){
        var fc=state.canvas,aO=fc.getObjects(),vA=aO.map(function(o){return o.visible!==false;});
        var oDPR=fabric.devicePixelRatio,_smnLim=(/iP(hone|ad|od)/.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1))?15e6:80e6,nDPR=Math.max(oDPR,Math.min(Math.ceil(Math.max(tPxW/lipBnds.width,tPxH/lipBnds.height))+1,Math.floor(Math.sqrt(_smnLim/(fc.getWidth()*fc.getHeight())))));
        fabric.devicePixelRatio=nDPR;fc.setDimensions({width:fc.getWidth(),height:fc.getHeight()});
        aO.forEach(function(o){if(hideFn(o))o.visible=false;});
        var oB=fc.backgroundColor;fc.backgroundColor='transparent';fc.renderAll();
        var sEl=fc.getElement(),dpr=sEl.width/fc.getWidth();
        ctx.drawImage(sEl,lipBnds.left*dpr,lipBnds.top*dpr,lipBnds.width*dpr,lipBnds.height*dpr,bPx,bPx,tPxW,tPxH);
        aO.forEach(function(o,i){o.visible=vA[i];});fc.backgroundColor=oB;
        fabric.devicePixelRatio=oDPR;fc.setDimensions({width:fc.getWidth(),height:fc.getHeight()});fc.renderAll();
      }
      pctx.fillStyle='#ffffff';
      pctx.fillRect(0,0,pxW,pxH);
      pctx.fillStyle=state.borderColor||'#ffffff';
      _dCut(pctx,bPx);
      pctx.fill();
      pctx.save();
      _dCut(pctx,bPx);
      pctx.clip();
      if(!_isImg||state.shape!=='die-cut'){
        _rcTo(pctx,function(o){return o._isCutline||(mainImg&&mainImg._isTemplateBg&&o._isMainImage);});
      } else {
        pctx.save();
        pctx.translate((imgCX-lipBnds.left)*mapX+bPx,(imgCY-lipBnds.top)*mapY+bPx);
        if(mainImg.angle)pctx.rotate(mainImg.angle*Math.PI/180);
        if(mainImg.flipX||mainImg.flipY)pctx.scale(mainImg.flipX?-1:1,mainImg.flipY?-1:1);
        pctx.drawImage(el,-dw/2,-dh/2,dw,dh);
        pctx.restore();
        if(state.canvas.getObjects().some(function(o){return !o._isCutline&&!o._isScissorIcon&&o!==mainImg&&o.visible!==false;})){
          _rcTo(pctx,function(o){return o._isCutline||o._isScissorIcon||o===mainImg||o._isMainImage;});
        }
      }
      pctx.restore();
      var _pb=await new Promise(function(r){pc.toBlob(r,'image/png');});
      var _smnJpg=false;
      if(!_pb||_pb.size>12e6){var _jb=await new Promise(function(r){pc.toBlob(r,'image/jpeg',0.95);});if(_jb){_pb=_jb;_smnJpg=true;}}
      var pngBytes=new Uint8Array(await _pb.arrayBuffer());
      var PDFDocument=PDFLib.PDFDocument, PDFName=PDFLib.PDFName;
      var PDFNumber=PDFLib.PDFNumber, PDFOperator=PDFLib.PDFOperator;
      var doc=await PDFDocument.create();
      var page=doc.addPage([ptW,ptH]);
      var context=doc.context;
      var pngImage=_smnJpg?await doc.embedJpg(pngBytes):await doc.embedPng(pngBytes);
      page.drawImage(pngImage,{x:0,y:0,width:ptW,height:ptH});
      var cutPts=getCutPathPts(tPtW,tPtH,lipBnds,tPtW/lipBnds.width,tPtH/lipBnds.height);
      window._smnPrintParts={blob:_pb,jpg:_smnJpg,ptW:ptW,ptH:ptH,bPt:bPt,cut:cutPts};
      if(cutPts&&cutPts.length>=3){
        var tintFn=context.obj({FunctionType:2,Domain:[0,1],C0:[0,0,0,0],C1:[0,1,0,0],N:1});
        var sepCS=context.obj([PDFName.of('Separation'),PDFName.of('CutContour'),PDFName.of('DeviceCMYK'),context.register(tintFn)]);
        var sepRef=context.register(sepCS);
        var pageNode=page.node;
        var resDict=pageNode.get(PDFName.of('Resources'));
        if(!resDict||resDict.constructor.name!=='PDFDict'){
          if(resDict) resDict=context.lookup(resDict);
          else { resDict=context.obj({}); pageNode.set(PDFName.of('Resources'),resDict); }
        }
        var csDict=context.obj({});
        csDict.set(PDFName.of('CS1'),sepRef);
        resDict.set(PDFName.of('ColorSpace'),csDict);
        var cutOps=[];
        cutOps.push(PDFOperator.of('q'));
        cutOps.push(PDFOperator.of('CS',[PDFName.of('CS1')]));
        cutOps.push(PDFOperator.of('SCN',[PDFNumber.of(1)]));
        cutOps.push(PDFOperator.of('w',[PDFNumber.of(0.5)]));
        var _bezOps=window._sl2EmitBezPDF&&window._sl2EmitBezPDF(state.cutContourPath,lipBnds,tPtW,tPtH,bPt,ptH,PDFOperator,PDFNumber);
        if(_bezOps&&_bezOps.length){cutOps.push.apply(cutOps,_bezOps);}
        else cutPts.forEach(function(p,i){var px=parseFloat((p[0]+bPt).toFixed(3));var py=parseFloat((ptH-p[1]-bPt).toFixed(3));cutOps.push(PDFOperator.of(i===0?'m':'l',[PDFNumber.of(px),PDFNumber.of(py)]));});
        cutOps.push(PDFOperator.of('h'));
        cutOps.push(PDFOperator.of('S'));
        cutOps.push(PDFOperator.of('Q'));
        page.pushOperators.apply(page,cutOps);
      }
      var pdfBytes=await doc.save();
      hideProgress();
      return {bytes:pdfBytes, filename:'sticker-'+totalW+'x'+totalH+'-CutContour.pdf'};
    }catch(err){
      hideProgress();
      console.error('PDF err:',err);
      return null;
    }
  }
  async function generatePrintFile(){
    var r=await generatePrintPDF();if(!r)return;
    var u=URL.createObjectURL(new Blob([r.bytes],{type:'application/pdf'}));
    var a=document.createElement('a');a.href=u;a.download=r.filename;
    document.body.appendChild(a);a.click();document.body.removeChild(a);
    setTimeout(function(){URL.revokeObjectURL(u);},5000);
  }
  async function uploadToR2(bytes,ct){
    /* 3 retries, backoff 500/1000/skipped — production-grade */
    var le;
    for(var i=0;i<3;i++){
      try{var r=await fetch(_shareWB+'/upload',{method:'POST',headers:{'Content-Type':ct,'X-API-Key':'sm_print_a7x9K2mP4qR8wL3nvx920123'},body:new Blob([bytes],{type:ct})});if(!r.ok)throw new Error('HTTP '+r.status);return (await r.json()).url;}
      catch(e){le=e;if(i<2)await new Promise(function(s){setTimeout(s,500<<i);});}
    }
    throw le;
  }
  async function capturePreview(){
    if(!state.canvas || !getMainContent()) return null;
    state.canvas.discardActiveObject();
    state.canvas.renderAll();
    var lipBnds=getLipBounds();
    if(!lipBnds) return null;
    var mainImg=getMainContent();
    var lipAspect=lipBnds.width/lipBnds.height;
    var pvW,pvH;
    if(lipAspect>=1){pvW=1000;pvH=Math.round(1000/lipAspect);}
    else{pvH=1000;pvW=Math.round(1000*lipAspect);}
    var mapX=pvW/lipBnds.width, mapY=pvH/lipBnds.height;
    var pc=document.createElement('canvas');
    pc.width=pvW; pc.height=pvH;
    var ctx=pc.getContext('2d');
    ctx.save();
    ctx.beginPath();
    if(state.shape==='circle'){
      ctx.arc(pvW/2,pvH/2,Math.min(pvW,pvH)/2,0,Math.PI*2);
    } else if(state.shape==='oval'){
      ctx.ellipse(pvW/2,pvH/2,pvW/2,pvH/2,0,0,Math.PI*2);
    } else if(state.shape==='die-cut' && state.cutContourPoints && state.cutContourPoints.length>=3){
      var pts=state.cutContourPoints;
      ctx.moveTo((pts[0][0]-lipBnds.left)*mapX,(pts[0][1]-lipBnds.top)*mapY);
      for(var i=1;i<pts.length;i++) ctx.lineTo((pts[i][0]-lipBnds.left)*mapX,(pts[i][1]-lipBnds.top)*mapY);
      ctx.closePath();
    } else {
      var rr=state.shape==='square'?0:Math.min(pvW,pvH)*0.04;
      ctx.roundRect(0,0,pvW,pvH,rr);
    }
    ctx.clip();
    ctx.fillStyle=state.borderColor||'#ffffff';
    ctx.fillRect(0,0,pvW,pvH);
    if(mainImg._isTemplateBg||mainImg.type!=='image'||state.canvas.getObjects().some(o=>!o._isCutline&&o!==mainImg&&o.visible!==false)){
      var fc=state.canvas,allO=fc.getObjects(),vArr=allO.map(function(o){return o.visible!==false;});
      var origDPR=fabric.devicePixelRatio;
      var needDPR=Math.max(origDPR,Math.ceil(Math.max(pvW,pvH)/Math.min(fc.getWidth(),fc.getHeight()))+1);
      fabric.devicePixelRatio=needDPR;
      fc.setDimensions({width:fc.getWidth(),height:fc.getHeight()});
      allO.forEach(function(o){if(o._isCutline||(o._isTemplateBg&&state.shape==='die-cut'))o.visible=false;});
      var oBg=fc.backgroundColor;fc.backgroundColor='transparent';fc.renderAll();
      var srcEl=fc.getElement(),dpr2=srcEl.width/fc.getWidth();
      ctx.drawImage(srcEl,lipBnds.left*dpr2,lipBnds.top*dpr2,lipBnds.width*dpr2,lipBnds.height*dpr2,0,0,pvW,pvH);
      allO.forEach(function(o,i){o.visible=vArr[i];});fc.backgroundColor=oBg;
      fabric.devicePixelRatio=origDPR;
      fc.setDimensions({width:fc.getWidth(),height:fc.getHeight()});
      fc.renderAll();
    } else {
      var el=mainImg.getElement();
      var natW=el.naturalWidth||el.width, natH=el.naturalHeight||el.height;
      var imgCX=mainImg.left, imgCY=mainImg.top;
      if(mainImg.originX==='left') imgCX+=natW*mainImg.scaleX/2;
      if(mainImg.originY==='top')  imgCY+=natH*mainImg.scaleY/2;
      var imgW=natW*mainImg.scaleX, imgH=natH*mainImg.scaleY;
      var dw=imgW*mapX, dh=imgH*mapY;
      var imgCenterPX=(imgCX-lipBnds.left)*mapX;
      var imgCenterPY=(imgCY-lipBnds.top)*mapY;
      ctx.translate(imgCenterPX,imgCenterPY);
      if(mainImg.angle) ctx.rotate(mainImg.angle*Math.PI/180);
      if(mainImg.flipX||mainImg.flipY) ctx.scale(mainImg.flipX?-1:1,mainImg.flipY?-1:1);
      ctx.drawImage(el,-dw/2,-dh/2,dw,dh);
    }
    ctx.restore();
    var blob=await new Promise(function(r){pc.toBlob(r,'image/png');});
    if(!blob)return null;
    return new Uint8Array(await blob.arrayBuffer());
  }
  function getCutPathPts(ptW, ptH, lipBnds, scaleX, scaleY){
    var pts=[];
    if(state.shape==='circle'){
      var r=Math.min(ptW,ptH)/2, cx=ptW/2, cy=ptH/2;
      for(var i=0;i<64;i++){var a=i/64*Math.PI*2; pts.push([cx+r*Math.cos(a), cy+r*Math.sin(a)]);}
    } else if(state.shape==='oval'){
      var rx=ptW/2, ry=ptH/2, cx=ptW/2, cy=ptH/2;
      for(var i=0;i<64;i++){var a=i/64*Math.PI*2; pts.push([cx+rx*Math.cos(a), cy+ry*Math.sin(a)]);}
    } else if(state.cutContourPoints && state.cutContourPoints.length>=3){
      var sX=ptW/lipBnds.width, sY=ptH/lipBnds.height;
      state.cutContourPoints.forEach(function(p){ pts.push([(p[0]-lipBnds.left)*sX, (p[1]-lipBnds.top)*sY]); });
    } else {
      var rr=Math.min(ptW,ptH)*0.04;
      var cp=8, l=0, t=0, r2=ptW, b2=ptH;
      for(var i=0;i<=cp;i++){var a=Math.PI+i/cp*Math.PI/2;pts.push([l+rr+rr*Math.cos(a),t+rr+rr*Math.sin(a)]);}
      for(var i=0;i<=cp;i++){var a=Math.PI*1.5+i/cp*Math.PI/2;pts.push([r2-rr+rr*Math.cos(a),t+rr+rr*Math.sin(a)]);}
      for(var i=0;i<=cp;i++){var a=i/cp*Math.PI/2;pts.push([r2-rr+rr*Math.cos(a),b2-rr+rr*Math.sin(a)]);}
      for(var i=0;i<=cp;i++){var a=Math.PI/2+i/cp*Math.PI/2;pts.push([l+rr+rr*Math.cos(a),b2-rr+rr*Math.sin(a)]);}
    }
    return pts.length>=3?pts:null;
  }
  var _smsFonts=['Impact','Inter','Poppins','Bebas Neue','Oswald','Lobster','Pacifico','Bangers','Permanent Marker','Caveat','Dancing Script','Playfair Display','Press Start 2P','Righteous','Russo One','Satisfy','Fredoka One','Anton','Bungee','Luckiest Guy','Black Ops One','Raleway','Montserrat','Quicksand'];
  (function(){
    var fl=document.createElement('link');fl.rel='stylesheet';
    fl.href='https://fonts.googleapis.com/css2?family=Anton&family=Bangers&family=Bebas+Neue&family=Black+Ops+One&family=Bungee&family=Caveat&family=Dancing+Script&family=Fredoka+One&family=Inter:wght@400;700&family=Lobster&family=Luckiest+Guy&family=Montserrat:wght@400;700&family=Oswald:wght@700&family=Pacifico&family=Permanent+Marker&family=Playfair+Display:wght@700&family=Poppins:wght@400;700&family=Press+Start+2P&family=Quicksand:wght@700&family=Raleway:wght@400;700&family=Righteous&family=Russo+One&family=Satisfy&display=swap';
    document.head.appendChild(fl);
  })();
  (function setupTextTool(){
    var textBtn = $('#btnAddText');
    if(!textBtn) return;
    var fonts = _smsFonts;
    textBtn.addEventListener('click', function(){
      if(!state.canvas) initBlankCanvas();
      var _swatchColors=['#000000','#ffffff','#ff3b30','#ff9500','#ffcc00','#34c759','#007aff','#5856d6','#af52de','#ff2d55','#8e8e93','#48484a'];
      var modal = createModalOverlay();
      modal.innerHTML = '<div style="background:#fff;border-radius:14px;padding:16px 18px;width:90%;max-width:340px;max-height:85vh;max-height:85dvh;overflow-y:auto;-webkit-overflow-scrolling:touch;box-shadow:0 24px 64px rgba(0,0,0,0.35);">'
        + '<h3 style="font-size:14px;font-weight:700;margin-bottom:10px;color:#222;display:flex;align-items:center;gap:6px;">'
        + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2893F2" stroke-width="2.2"><path d="M4 7V4h16v3"/><line x1="12" y1="4" x2="12" y2="20"/><path d="M8 20h8"/></svg>Add Text</h3>'
        + '<div id="smsTextPreview" style="background:#f8f8f8;border-radius:8px;padding:10px;margin-bottom:10px;text-align:center;min-height:36px;display:flex;align-items:center;justify-content:center;border:1.5px dashed #e0e0e0;overflow:hidden;">'
        + '<span style="color:#ccc;font-size:13px;">Preview</span></div>'
        + '<input type="text" id="smsTextInput" placeholder="Type your text..." style="width:100%;padding:8px 10px;border:1.5px solid #e0e0e0;border-radius:8px;font-size:14px;margin-bottom:10px;outline:none;transition:border-color .15s;" autofocus>'
        + '<div style="display:flex;gap:8px;margin-bottom:10px;">'
        + '<div style="flex:1;"><label style="font-size:10px;font-weight:700;color:#999;text-transform:uppercase;letter-spacing:0.8px;">Font</label>'
        + '<select id="smsFontSelect" style="width:100%;padding:6px 8px;border:1.5px solid #e0e0e0;border-radius:8px;font-size:13px;margin-top:3px;outline:none;cursor:pointer;">'
        + fonts.map(function(f){ return '<option value="'+f+'" style="font-family:\''+f+'\'">'+f+'</option>'; }).join('')
        + '</select></div>'
        + '<div><label style="font-size:10px;font-weight:700;color:#999;text-transform:uppercase;letter-spacing:0.8px;">Size <span id="smsSizeLabel" style="color:#555;">36</span></label>'
        + '<div style="display:flex;gap:3px;margin-top:3px;">'
        + '<input type="range" id="smsTextSize" min="12" max="120" value="36" style="flex:1;min-width:60px;accent-color:#2893F2;">'
        + '<button id="smsModalBold" style="width:28px;height:28px;border:1.5px solid #e0e0e0;background:#fff;border-radius:6px;cursor:pointer;font-size:12px;font-weight:900;color:#333;transition:all .15s;" title="Bold">B</button>'
        + '<button id="smsModalItalic" style="width:28px;height:28px;border:1.5px solid #e0e0e0;background:#fff;border-radius:6px;cursor:pointer;font-size:12px;font-style:italic;color:#333;transition:all .15s;" title="Italic">I</button>'
        + '</div></div></div>'
        + '<div style="margin-bottom:10px;">'
        + '<label style="font-size:10px;font-weight:700;color:#999;text-transform:uppercase;letter-spacing:0.8px;">Color</label>'
        + '<div style="display:flex;gap:4px;flex-wrap:wrap;margin-top:4px;align-items:center;">'
        + _swatchColors.map(function(c){
            return '<span class="sms-modal-swatch" data-c="'+c+'" style="width:22px;height:22px;border-radius:50%;background:'+c+';border:2px solid '+(c==='#ffffff'?'#ddd':'transparent')+';cursor:pointer;transition:transform .12s,border-color .12s;flex-shrink:0;'+(c==='#000000'?'transform:scale(1.15);border-color:#00c9a7;':'')+'"></span>';
          }).join('')
        + '<input type="color" id="smsTextColor" value="#000000" style="width:22px;height:22px;border:2px solid #ddd;border-radius:50%;cursor:pointer;padding:0;background:none;-webkit-appearance:none;overflow:hidden;flex-shrink:0;" title="Custom">'
        + '</div></div>'
        + '<div style="display:flex;gap:8px;">'
        + '<button id="smsTextCancel" style="flex:1;padding:9px;border:1.5px solid #e0e0e0;border-radius:8px;background:#fff;font-size:13px;font-weight:600;cursor:pointer;color:#666;transition:all .15s;">Cancel</button>'
        + '<button id="smsTextAdd" style="flex:1;padding:9px;border:none;border-radius:8px;background:#2893F2;color:#fff;font-size:13px;font-weight:700;cursor:pointer;transition:all .15s;box-shadow:0 4px 12px rgba(40,147,242,0.3);">Add Text</button>'
        + '</div></div>';
      document.body.appendChild(modal);
      var textInput = modal.querySelector('#smsTextInput');
      var fontSelect = modal.querySelector('#smsFontSelect');
      var colorInput = modal.querySelector('#smsTextColor');
      var sizeInput = modal.querySelector('#smsTextSize');
      var sizeLabel = modal.querySelector('#smsSizeLabel');
      var previewEl = modal.querySelector('#smsTextPreview');
      var modalBold = modal.querySelector('#smsModalBold');
      var modalItalic = modal.querySelector('#smsModalItalic');
      var _modalColor = '#000000';
      var _modalIsBold = false;
      var _modalIsItalic = false;
      function updatePreview(){
        var txt=textInput.value||'Preview';
        var sz=parseInt(sizeInput.value)||36;
        previewEl.innerHTML='<span style="font-family:\''+fontSelect.value+'\';font-size:'+sz+'px;color:'+_modalColor+';font-weight:'+(_modalIsBold?'bold':'normal')+';font-style:'+(_modalIsItalic?'italic':'normal')+';word-break:break-word;max-width:100%;line-height:1.2;display:inline-block;transform:scale('+Math.min(1, 280/Math.max(sz*txt.length*0.6,1))+');transform-origin:center;">'+txt.replace(/</g,'&lt;')+'</span>';
      }
      textInput.addEventListener('input', updatePreview);
      fontSelect.addEventListener('change', function(){ textInput.style.fontFamily=fontSelect.value; updatePreview(); });
      sizeInput.addEventListener('input', function(){ sizeLabel.textContent=sizeInput.value; updatePreview(); });
      colorInput.addEventListener('input', function(){ _modalColor=colorInput.value; highlightSwatch(null); updatePreview(); });
      function highlightSwatch(activeEl){
        modal.querySelectorAll('.sms-modal-swatch').forEach(function(s){
          var c=s.getAttribute('data-c');
          if(s===activeEl){s.style.transform='scale(1.15)';s.style.borderColor='#00c9a7';}
          else{s.style.transform='';s.style.borderColor=c==='#ffffff'?'#ddd':'transparent';}
        });
      }
      modal.querySelectorAll('.sms-modal-swatch').forEach(function(s){
        s.addEventListener('click',function(){
          _modalColor=s.getAttribute('data-c');
          colorInput.value=_modalColor;
          highlightSwatch(s);
          updatePreview();
        });
      });
      modalBold.addEventListener('click',function(){
        _modalIsBold=!_modalIsBold;
        modalBold.style.background=_modalIsBold?'#00c9a7':'#fff';
        modalBold.style.color=_modalIsBold?'#fff':'#333';
        modalBold.style.borderColor=_modalIsBold?'#00c9a7':'#e0e0e0';
        updatePreview();
      });
      modalItalic.addEventListener('click',function(){
        _modalIsItalic=!_modalIsItalic;
        modalItalic.style.background=_modalIsItalic?'#00c9a7':'#fff';
        modalItalic.style.color=_modalIsItalic?'#fff':'#333';
        modalItalic.style.borderColor=_modalIsItalic?'#00c9a7':'#e0e0e0';
        updatePreview();
      });
      textInput.addEventListener('focus',function(){this.style.borderColor='#00c9a7';});
      textInput.addEventListener('blur',function(){this.style.borderColor='#e0e0e0';});
      modal.querySelector('#smsTextCancel').addEventListener('click', function(){ removeModal(modal); });
      modal.addEventListener('click', function(e){ if(e.target === modal) removeModal(modal); });
      function doAddText(){
        var txt = textInput.value.trim();
        if(!txt) return;
        var rawSize = parseInt(sizeInput.value) || 36;
        var textObj = new fabric.IText(txt, {
          fontFamily: fontSelect.value,
          fontSize: rawSize,
          fill: _modalColor,
          fontWeight: _modalIsBold?'bold':'normal',
          fontStyle: _modalIsItalic?'italic':'normal',
          left: state.canvas.width / 2,
          top: state.canvas.height / 2,
          originX: 'center',
          originY: 'center',
          editable: true,
          hasControls: true,
          hasBorders: true,
          selectable: true,
          objectCaching: false
        });
        if(state.shape !== 'die-cut'){
          var _sd=getShapeDims(), _cx=state.canvas.getWidth()/2, _cy=state.canvas.getHeight()/2;
          var clip = createShapeClip(state.shape, _sd[0], _sd[1], _cx, _cy);
          if(clip) textObj.clipPath = clip;
        }
        var _existingContent = getMainImage() || getMainContent();
        state.canvas.add(textObj);
        textObj.setCoords();
        var _tw, _isBlank=false;
        if(state.shape === 'die-cut'){
          if(_existingContent){
            _tw = _existingContent.getScaledWidth() * 0.6;
          } else {
            _tw = state.canvas.getWidth() * 0.55;
            _isBlank = true;
          }
        } else {
          var _sd2=getShapeDims(); _tw = _sd2[0] * 0.85;
        }
        if(_isBlank){
          textObj.scaleToWidth(_tw);
        } else if(textObj.getScaledWidth() > _tw * 1.1 || textObj.getScaledWidth() < _tw * 0.5){
          textObj.scaleToWidth(_tw);
        }
        textObj.setCoords();
        if(state.shape==='die-cut'&&_existingContent&&!_isBlank){
          /* Studio Next fix: put new text under the existing art, not on top of it */
          var _cb=_existingContent.getBoundingRect(true,true),_th=textObj.getScaledHeight();
          var _ny=Math.min(_cb.top+_cb.height+_th/2+6,state.canvas.getHeight()-_th/2-4);
          textObj.set({left:_cb.left+_cb.width/2,top:_ny});textObj.setCoords();
        }
        state.canvas.setActiveObject(textObj);
        state.canvas.renderAll();
        _redrawAfterEdit(); positionOverlays(); updateDimLabel(); saveState();
        updateDeleteBtn(); updateStartOverBtn(); initShareSession();
        document.fonts.ready.then(function(){
          if(!state.canvas) return;
          state.canvas.renderAll();
          _redrawAfterEdit(); positionOverlays(); updateDimLabel();
        });
        removeModal(modal);
      }
      var addBtn = modal.querySelector('#smsTextAdd');
      addBtn.addEventListener('click', doAddText);
      addBtn.addEventListener('touchend', function(e){ e.preventDefault(); doAddText(); });
      textInput.addEventListener('keydown', function(e){ if(e.key==='Enter'){ e.preventDefault(); textInput.blur(); doAddText(); }});
      setTimeout(function(){ textInput.focus(); }, 300);
      updatePreview();
    });
  })();
  D.dl.addEventListener('click', generatePrintFile);
  var _mob=window.innerWidth<=768;
  var zoomLevel=_mob?1:0.85;
  var defaultZoom=_mob?1:0.73;
  function applyZoom(){
    var stage=D.stg;
    if(!stage) return;
    window._sl2ZoomLevel=zoomLevel;
    stage.style.transform='scale('+zoomLevel+') rotateX(0) rotateY(0)';
    stage.style.transformOrigin='center center';
    var lW=stage.offsetWidth,lH=stage.offsetHeight;
    var vW=lW*zoomLevel,vH=lH*zoomLevel;
    stage.style.marginLeft=(vW<lW)?(-((lW-vW)/2))+'px':'';
    stage.style.marginRight=(vW<lW)?(-((lW-vW)/2))+'px':'';
    stage.style.marginTop=(vH<lH)?(-((lH-vH)/2))+'px':'';
    stage.style.marginBottom=(vH<lH)?(-((lH-vH)/2))+'px':'';
    $('#btnZoomReset').textContent=Math.round((zoomLevel/defaultZoom)*100)+'%';
  }
  $('#btnZoomIn').addEventListener('click',function(){
    zoomLevel=Math.min(zoomLevel+0.25,3);
    applyZoom();
  });
  $('#btnZoomOut').addEventListener('click',function(){
    zoomLevel=Math.max(zoomLevel-0.25,0.25);
    applyZoom();
  });
  $('#btnZoomReset').addEventListener('click',function(){
    zoomLevel=defaultZoom;
    applyZoom();
  });
  (function(){
    var _afvTimer=0,_lastAW=0;
    var areaEl=document.querySelector('.sms-canvas-area');
    if(!areaEl) return;
    function _checkFit(){
      if(!state.canvas||!_vo().length) return;
      var nowW=areaEl.clientWidth;
      if(nowW===_lastAW) return;
      _lastAW=nowW;
      autoFitView();
    }
    if(typeof ResizeObserver!=='undefined'){
      new ResizeObserver(function(){clearTimeout(_afvTimer);_afvTimer=setTimeout(_checkFit,150);}).observe(areaEl);
    }
    window.addEventListener('resize',function(){clearTimeout(_afvTimer);_afvTimer=setTimeout(_checkFit,200);});
  })();
  $('.sms-preview').addEventListener('wheel',function(e){
    if(!state.canvas) return;
    e.preventDefault();
    if(e.deltaY<0) zoomLevel=Math.min(zoomLevel+0.1,3);
    else zoomLevel=Math.max(zoomLevel-0.1,0.25);
    applyZoom();
  },{passive:false});
  async function doAddToCart(btn){
    if(!studioVariants.length){alert('Product not configured. Go to Theme Editor > Sticker Studio section > select a product.');return;}
    if(window._smsMOR&&_smsMOR.invalid(state.sizeInches,state.qty)){alert(_smsMOR.msg(state.sizeInches));_mo('size');updatePresets();updatePrice();return;}
    if(!btn._apPr&&window._sl2Proof)return window._sl2Proof(function(){btn._apPr=1;doAddToCart(btn);});
    btn._apPr=0;
    btn.disabled=true; const orig=btn.innerHTML;
    try{
      var _s=state;
      var sizeKey=_s.size.replace('x','\u00d7');
      var variant=studioVariants.find(function(v){
        var t=(v.title||'').toLowerCase(), o=(v.option1||'').toLowerCase(), s=_s.size.toLowerCase();
        return t.includes(s) || o.includes(s) || t.includes(sizeKey.toLowerCase());
      });
      if(!variant) variant=studioVariants[0];
      var _sp=function(t){return '<span style="display:inline-flex;align-items:center;gap:8px"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="sms-spinner"><circle cx="12" cy="12" r="10" stroke-dasharray="31.4" stroke-dashoffset="10"/></svg>'+t+'</span>';};
      btn.innerHTML=_sp('Capturing preview...');
      var previewBytes=await capturePreview();
      var previewUrl='';
      if(previewBytes){
        if(window._sl2CachePreview)_sl2CachePreview(previewBytes,_shareSessionId);
        btn.innerHTML=_sp('Uploading preview...');
        try{previewUrl=await uploadToR2(previewBytes,'image/png');}catch(e){console.error('preview up:',e);}
      }
      if(!previewUrl&&state.originalImg&&state.originalImg.src&&state.originalImg.src.startsWith('data:')){
        try{previewUrl=await uploadImg(state.originalImg.src);}catch(e){}
      }
      var result=state.canvas?await generatePrintPDF():null;
      if(!result)throw new Error('Could not generate print file. Please try again.');
      btn.innerHTML=_sp('Uploading print file...');
      var printUrl=await uploadToR2(result.bytes,'application/pdf');
      var priceCalc=calculatePrice(_s.sizeInches,_s.finish,_s.qty);
      var totalCalc=priceCalc.total.toFixed(2);
      var discountedUnit=priceCalc.unit.toFixed(2);
      var cartQty=Math.round(priceCalc.total);
      btn.innerHTML=_sp('Adding to cart...');
      /* Compute actual W × H so custom sizes don't show as just "custom" in cart,
         and so fulfillment has explicit dimensions on the line item. */
      var _custW,_custH;
      if(_s.size==='custom'){
        _custW=parseFloat($('#smsCustomW').value)||_s.sizeInches;
        _custH=parseFloat($('#smsCustomH').value)||_s.sizeInches;
      } else {
        var _szParts=_s.size.split('x');
        _custW=parseFloat(_szParts[0])||_s.sizeInches;
        _custH=parseFloat(_szParts[1])||_s.sizeInches;
      }
      var _sizeLabel=_custW+'" × '+_custH+'"';
      var _pdm=(result&&result.filename||'').match(/sticker-([\d.]+)x([\d.]+)-/);
      if(_pdm){_custW=+_pdm[1];_custH=+_pdm[2];_sizeLabel=_custW+'" × '+_custH+'"';}
      var props={'Size':_sizeLabel,'Quantity':_s.qty+' stickers','Finish':_s.finish,'Border':({none:'Edge',tight:'Small',medium:'Medium',loose:'Large'})[state.cutStyle]||'Small'};
      props['_printFileUrl']=printUrl;
      props['_previewUrl']=previewUrl;
      if(previewUrl)props['_image']=previewUrl;
      props['_totalPrice']=totalCalc;
      props['_unitPrice']=discountedUnit;
      props['_stickerQty']=String(_s.qty);
      props['_TotalWidth']=_custW+'"';
      props['_TotalHeight']=_custH+'"';
      props['_sessionId']=_shareSessionId||'';
      props['_studioItem']='true';
      var r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:variant.id,quantity:cartQty,
          properties:props}]})
      });
      if(!r.ok){var err=await r.json().catch(function(){return{};}); throw new Error(err.description||'Cart error');}
      btn.innerHTML='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="vertical-align:-2px;"><polyline points="20 6 9 17 4 12"/></svg> Added to cart!';
      btn.classList.add('sms-atc-success');
      var cartBtns=document.getElementById('smsCartBtns');
      if(cartBtns) cartBtns.style.display='flex';
      if(window._sl2Co){window._sl2Co=0;location='/cart';}else openCartDrawer();
      setTimeout(()=>{btn.innerHTML=orig;btn.classList.remove('sms-atc-success');btn.style.background='';btn.style.color='';btn.disabled=false;},3000);
    }catch(err){
      hideProgress();
      console.error('ATC err:',err);
      btn.innerHTML='Error: '+(err.message||'Unknown');btn.style.background='#ef4444';btn.style.color='#fff';
      setTimeout(()=>{btn.innerHTML=orig;btn.style.background='';btn.style.color='';btn.disabled=false;},3500);
    }
  }
  var W=window;W._sl2IB=initBlankCanvas;W._doATC=doAddToCart;W._sl2Price=calculatePrice;W._sl2Hcc=_hasCanvasContent;W._sl2St=state;W._sl2Cap=capturePreview;W._sl2SS=saveState;
  W.openCartDrawer=function(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var old=document.getElementById('sms-cart-popup');
      if(old) old.remove();
      var itemsHtml='';
      var customTotal=0;
      cart.items.forEach(function(item){
        var isStudio=false, previewUrl='', totalP='', unitP='', stickerQty='', sizeProp='', finishProp='';
        var props=item.properties||{};
        if(props['_studioItem']==='true') isStudio=true;
        previewUrl=props['_previewUrl']||'';
        totalP=props['_totalPrice']||'';
        unitP=props['_unitPrice']||'';
        stickerQty=props['_stickerQty']||'';
        sizeProp=props['Size']||'';
        finishProp=props['Finish']||'';
        var borderProp=props['Border']||'';
        var imgSrc=previewUrl||(props['_studioItem']==='true'&&window._sl2LastPreview)||(item.image?item.image:'');
        var price=totalP?'$'+totalP:'$'+(item.price/100).toFixed(2);
        var unit=unitP?'$'+unitP+'/ea':'';
        var qty=stickerQty?stickerQty+' stickers':'Qty: '+item.quantity;
        if(totalP) customTotal+=parseFloat(totalP);
        else customTotal+=item.price/100*item.quantity;
        itemsHtml+='<div style="display:flex;gap:12px;padding:12px 0;border-bottom:1px solid #f0f0f0;position:relative;">'
          +'<div style="width:70px;height:70px;flex-shrink:0;border-radius:10px;overflow:hidden;background:#f5f5f5;display:flex;align-items:center;justify-content:center;">'
          +(imgSrc?'<img src="'+imgSrc+'" style="max-width:60px;max-height:60px;object-fit:contain;filter:drop-shadow(0 1px 2px rgba(0,0,0,.12));">':'')
          +'</div>'
          +'<div style="flex:1;min-width:0;">'
          +'<div style="display:flex;justify-content:space-between;align-items:flex-start;">'
          +'<div style="font-weight:600;font-size:13px;color:#222;">'+item.product_title+'</div>'
          +'<button class="sms-cart-remove-btn" data-key="'+item.key+'" style="background:none;border:none;cursor:pointer;padding:2px 4px;color:#bbb;font-size:14px;line-height:1;transition:color .2s;" onmouseover="this.style.color=\'#e53935\'" onmouseout="this.style.color=\'#bbb\'" title="Remove">'
          +'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
          +'</button>'
          +'</div>'
          +'<div style="font-size:11px;color:#888;margin-top:2px;">'
          +(sizeProp?'<span class="sl2-cd-pill">'+sizeProp+'</span>':'')
          +(finishProp?'<span class="sl2-cd-pill">'+finishProp+'</span>':'')
          +(borderProp?'<span class="sl2-cd-pill">'+borderProp+' border</span>':'')
          +'<span style="background:#e8f5e9;padding:1px 6px;border-radius:8px;color:#2e7d32;">'+qty+'</span>'
          +'</div>'
          +'<div style="margin-top:6px;display:flex;align-items:baseline;gap:6px;">'
          +'<span style="font-weight:700;font-size:15px;color:#222;">'+price+'</span>'
          +(unit?'<span style="font-size:11px;color:#999;">'+unit+'</span>':'')
          +'</div>'
          +'</div>'
          +'</div>';
      });
      if(!itemsHtml){
        itemsHtml='<div style="padding:30px;text-align:center;color:#999;">Cart is empty</div>';
        var cartBtns=document.getElementById('smsCartBtns');
        if(cartBtns) cartBtns.style.display='none';
      }
      var popup=document.createElement('div');
      popup.id='sms-cart-popup';
      popup.className='sms';
      popup.style.setProperty('display','flex','important');
      popup.style.setProperty('position','fixed','important');
      popup.style.setProperty('inset','0','important');
      popup.style.setProperty('z-index','9999999','important');
      popup.style.setProperty('background','rgba(0,0,0,0.5)','important');
      popup.style.setProperty('align-items','center','important');
      popup.style.setProperty('justify-content','center','important');
      popup.innerHTML='<div style="background:#fff;border-radius:16px;width:420px;max-width:90vw;max-height:80vh;display:flex;flex-direction:column;box-shadow:0 20px 60px rgba(0,0,0,0.3);animation:sms-slide-up .25s ease;">'
        +'<div style="padding:16px 20px;border-bottom:1px solid #f0f0f0;display:flex;justify-content:space-between;align-items:center;">'
        +'<h3 style="font-size:16px;font-weight:700;color:#222;margin:0;">Added to Cart \u2713</h3>'
        +'<button id="sms-cart-close" style="background:none;border:none;cursor:pointer;padding:4px;color:#aaa;font-size:20px;">\u2715</button>'
        +'</div>'
        +'<div style="padding:4px 20px;overflow-y:auto;flex:1;min-height:0;">'
        +itemsHtml
        +'</div>'
        +'<div style="padding:16px 20px;border-top:1px solid #f0f0f0;">'
        +'<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;">'
        +'<span style="font-size:14px;font-weight:600;color:#555;">Total</span>'
        +'<span style="font-size:20px;font-weight:800;color:#222;">$'+customTotal.toFixed(2)+'</span>'
        +'</div>'
        +'<a href="/cart" style="display:block;width:100%;padding:14px;background:#00c9a7;color:#fff;border:none;border-radius:10px;font-size:15px;font-weight:700;cursor:pointer;text-align:center;text-decoration:none;transition:background .15s;">VIEW CART</a>'
        +'<button id="sms-cart-continue" style="display:block;width:100%;padding:10px;background:none;border:none;color:#888;font-size:13px;font-weight:600;cursor:pointer;margin-top:6px;text-decoration:underline;">Continue designing</button>'
        +'</div>'
        +'</div>';
      document.body.appendChild(popup);
      popup.querySelector('#sms-cart-close').onclick=function(){ popup.remove(); };
      popup.querySelector('#sms-cart-continue').onclick=function(){ popup.remove(); };
      popup.addEventListener('click',function(e){ if(e.target===popup) popup.remove(); });
      popup.querySelectorAll('.sms-cart-remove-btn').forEach(function(btn){
        btn.addEventListener('click',function(){
          var key=btn.getAttribute('data-key');
          btn.innerHTML='<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="sms-spinner"><circle cx="12" cy="12" r="10" stroke-dasharray="31.4" stroke-dashoffset="10"/></svg>';
          btn.disabled=true;
          fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:0})})
          .then(function(r){return r.json();})
          .then(function(){openCartDrawer();})
          .catch(function(){btn.innerHTML='\u2715';btn.disabled=false;});
        });
      });
    }).catch(function(){});
  }
  D.atc.onclick=function(){doAddToCart(D.atc);};
  function showProgress(t){$('#progressOverlay').classList.remove('hidden');$('#progressText').textContent=t;}
  function hideProgress(){$('#progressOverlay').classList.add('hidden');}
  function showDpiToast(dpi){
    var old=document.getElementById('smsDpiToast');if(old)old.remove();
    var low=dpi<150;
    var bg=low?'#f8d7da':'#fff3cd',fg=low?'#721c24':'#856404',bd=low?'#f5c6cb':'#ffeeba';
    var msg=low?'Resolution is very low (<b>'+Math.round(dpi)+' DPI</b>). Print may appear blurry — try a larger image.':'Image resolution is slightly low (<b>'+Math.round(dpi)+' DPI</b>). Should still print fine — 300 DPI recommended.';
    var t=document.createElement('div');t.id='smsDpiToast';
    t.style.cssText='position:fixed;top:80px;left:50%;transform:translateX(-50%);z-index:9999;background:'+bg+';color:'+fg+';border:1px solid '+bd+';border-radius:10px;padding:12px 14px;font-size:13px;line-height:1.4;max-width:min(440px,calc(100vw - 24px));box-shadow:0 4px 16px rgba(0,0,0,0.12);display:flex;align-items:center;gap:10px;transition:opacity .35s;';
    t.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" style="flex-shrink:0"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg><span style="flex:1">'+msg+'</span><button aria-label="Dismiss" style="background:none;border:none;color:inherit;font-size:20px;line-height:1;cursor:pointer;padding:0 4px;">&times;</button>';
    t.querySelector('button').onclick=function(){t.remove();};
    document.body.appendChild(t);
    setTimeout(function(){if(t.parentNode){t.style.opacity='0';setTimeout(function(){if(t.parentNode)t.remove();},400);}},8000);
  }
  function checkImageDpi(){
    var img=state.originalImg;if(!img)return;
    var px=Math.max(img.naturalWidth||img.width||0,img.naturalHeight||img.height||0);
    var inch=state.sizeInches||0;
    if(!px||!inch)return;
    var dpi=px/inch;
    if(dpi<300)showDpiToast(dpi);
    else{var old=document.getElementById('smsDpiToast');if(old)old.remove();}
  }
  (function setup3DTilt(){
    const stage=D.stg;
    const gloss=$('#glossOverlay');
    const holo=$('#holoOverlay');
    const glossLayer=$('#glossLayer');
    const shadow=$('#stageShadow');
    const vinylTex=$('#vinylTexture');
    const vinylSpec=$('#vinylSpecular');
    const edgeRim=$('#edgeRim');
    const preview=D.prev;
    const maxTilt=15;
    function applyVinylDynamic(ndx,ndy){
      var isGlossy=state.finish==='glossy';
      if(vinylTex){
        var baseAngle=128, angleShift=ndx*18;
        var angle=baseAngle+angleShift;
        var bandCenter=38+ndx*12;
        var peak=isGlossy?0.58:0.13, mid=isGlossy?0.28:0.05, outer=isGlossy?0.12:0.03;
        var topLight=isGlossy?0.28:0.10;
        var band2Center=bandCenter+18;
        var peak2=isGlossy?0.18:0.06;
        vinylTex.style.background=
          'linear-gradient('+angle+'deg,transparent 0%,transparent '+(bandCenter-16)+'%,'+
          'rgba(255,255,255,'+outer+') '+(bandCenter-12)+'%,'+
          'rgba(255,255,255,'+mid+') '+(bandCenter-5)+'%,'+
          'rgba(255,255,255,'+peak+') '+bandCenter+'%,'+
          'rgba(255,255,255,'+mid+') '+(bandCenter+5)+'%,'+
          'rgba(255,255,255,'+outer+') '+(bandCenter+12)+'%,'+
          'transparent '+(bandCenter+16)+'%,transparent 100%),'+
          (isGlossy?'linear-gradient('+(angle+10)+'deg,transparent 0%,transparent '+(band2Center-6)+'%,rgba(255,255,255,'+peak2+') '+band2Center+'%,transparent '+(band2Center+6)+'%,transparent 100%),':'')+
          'linear-gradient(175deg,rgba(255,255,255,'+topLight+') 0%,rgba(255,255,255,'+(topLight*0.3).toFixed(2)+') 25%,transparent 45%,rgba(0,0,0,'+(isGlossy?0.06:0.03)+') 75%,rgba(0,0,0,'+(isGlossy?0.12:0.05)+') 100%)';
      }
      if(vinylSpec){
        var specX=28+ndx*38, specY=18+ndy*34;
        var baseI=isGlossy?0.65:0.20;
        var intensity=baseI+Math.abs(ndx)*0.18+Math.abs(ndy)*0.15;
        var coreI=isGlossy?Math.min(0.85,intensity+0.15):0;
        var spec2X=100-specX, spec2Y=100-specY;
        var sec2I=isGlossy?0.10+Math.abs(ndx)*0.06:0;
        var fresnelI=isGlossy?0.18+Math.max(Math.abs(ndx),Math.abs(ndy))*0.12:0;
        vinylSpec.style.background=
          'radial-gradient(ellipse 55% 40% at '+specX+'% '+specY+'%, rgba(255,255,255,'+intensity.toFixed(2)+') 0%, rgba(255,255,255,0.06) 30%, transparent 55%)'+
          (isGlossy?',radial-gradient(ellipse 16% 11% at '+(specX+2)+'% '+(specY-2)+'%, rgba(255,255,255,'+coreI.toFixed(2)+') 0%, transparent 45%)':'')+
          (isGlossy?',radial-gradient(ellipse 30% 22% at '+spec2X+'% '+spec2Y+'%, rgba(255,255,255,'+sec2I.toFixed(2)+') 0%, transparent 40%)':'')+
          (isGlossy?',radial-gradient(ellipse 90% 85% at 50% 50%, transparent 50%, rgba(255,255,255,'+(fresnelI*0.4).toFixed(2)+') 68%, rgba(255,255,255,'+fresnelI.toFixed(2)+') 88%, rgba(255,255,255,'+(fresnelI*1.2).toFixed(2)+') 100%)':'');
      }
      if(edgeRim){
        var gMul=isGlossy?1.5:1;
        var rimTop=(0.45+ndy*0.35)*gMul, rimBottom=(0.12-ndy*0.25)*gMul;
        var rimLeft=(0.18+ndx*0.25)*gMul, rimRight=(0.18-ndx*0.25)*gMul;
        var rimGlow=isGlossy?0.12+Math.max(Math.abs(ndx),Math.abs(ndy))*0.08:0;
        rimTop=Math.max(0,Math.min(0.90,rimTop));
        rimBottom=Math.max(0,Math.min(0.45,rimBottom));
        rimLeft=Math.max(0,Math.min(0.55,rimLeft));
        rimRight=Math.max(0,Math.min(0.55,rimRight));
        edgeRim.style.boxShadow='inset 0 2.5px 0 rgba(255,255,255,'+rimTop.toFixed(2)+'), inset 0 -1.5px 0 rgba(0,0,0,'+rimBottom.toFixed(2)+'), inset 2px 0 0 rgba(255,255,255,'+rimLeft.toFixed(2)+'), inset -2px 0 0 rgba(255,255,255,'+rimRight.toFixed(2)+')'+(isGlossy?', inset 0 0 '+(4+rimGlow*20).toFixed(0)+'px rgba(255,255,255,'+rimGlow.toFixed(2)+')':'');
      }
    }
    preview.addEventListener('mousemove', function(e){
      if(state.adjusting||('ontouchstart' in window)||navigator.maxTouchPoints>0) return;
      const rect=stage.getBoundingClientRect();
      const cx=rect.left+rect.width/2, cy=rect.top+rect.height/2;
      const dx=(e.clientX-cx)/(rect.width/2);
      const dy=(e.clientY-cy)/(rect.height/2);
      const ndx=Math.max(-1,Math.min(1,dx));
      const ndy=Math.max(-1,Math.min(1,dy));
      const rotY=ndx*maxTilt, rotX=-ndy*maxTilt;
      stage.style.transform='scale('+(typeof zoomLevel!=='undefined'?zoomLevel:defaultZoom)+') rotateX('+rotX+'deg) rotateY('+rotY+'deg)';
      applyVinylDynamic(ndx,ndy);
      if(blankEl && !blankEl.classList.contains('hidden') && state.finish==='glossy'){
        var bAngle=128+ndx*18, bCenter=37+ndx*12;
        blankEl.style.setProperty('--gloss-angle',bAngle+'deg');
        blankEl.style.setProperty('--gloss-center',bCenter+'%');
        blankEl.style.setProperty('--spec-x',(28+ndx*38)+'%');
        blankEl.style.setProperty('--spec-y',(18+ndy*34)+'%');
      }
      const gx=50+ndx*40, gy=50+ndy*40;
      if(state.finish==='glossy'){
        const shineX=50+ndx*30, shineY=50+ndy*20;
        glossLayer.style.backgroundPosition=shineX+'% '+shineY+'%';
        gloss.style.background='radial-gradient(circle at '+gx+'% '+gy+'%, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.08) 25%, rgba(255,255,255,0) 50%)';
        gloss.style.opacity='1';
      } else if(state.finish==='matte'){
        gloss.style.background='radial-gradient(circle at '+gx+'% '+gy+'%, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0) 55%)';
        gloss.style.opacity='1';
      } else {
        gloss.style.opacity='0';
      }
      if(state.finish==='holographic'){
        const texX=50+ndx*40, texY=50+ndy*30;
        holo.style.backgroundPosition=texX+'% '+texY+'%';
      }
      const sx=-ndx*8, sy=4+ndy*5;
      shadow.style.transform='translateX('+sx+'px) translateY('+sy+'px) scaleY('+(0.6+Math.abs(ndy)*0.3)+')';
      shadow.style.opacity=0.5+Math.abs(ndy)*0.3;
    });
    preview.addEventListener('mouseleave', function(){
      stage.style.transform='scale('+(typeof zoomLevel!=='undefined'?zoomLevel:defaultZoom)+') rotateX(0) rotateY(0)';
      gloss.style.background='';
      gloss.style.opacity='';
      holo.style.backgroundPosition='';
      shadow.style.transform='translateX(0) translateY(0) scaleY(0.6)';
      shadow.style.opacity='0.7';
      if(vinylTex) vinylTex.style.backgroundPosition='';
      if(vinylSpec) vinylSpec.style.background='';
      if(edgeRim) edgeRim.style.boxShadow='';
    });
    function applyTilt(ndx, ndy){
      var rotY=ndx*maxTilt, rotX=-ndy*maxTilt;
      stage.style.transform='scale('+(typeof zoomLevel!=='undefined'?zoomLevel:defaultZoom)+') rotateX('+rotX+'deg) rotateY('+rotY+'deg)';
      applyVinylDynamic(ndx,ndy);
      var gx=50+ndx*40, gy=50+ndy*40;
      if(state.finish==='glossy'){
        var shineX=50+ndx*30, shineY=50+ndy*20;
        glossLayer.style.backgroundPosition=shineX+'% '+shineY+'%';
        gloss.style.background='radial-gradient(circle at '+gx+'% '+gy+'%, rgba(255,255,255,0.25) 0%, rgba(255,255,255,0.08) 25%, rgba(255,255,255,0) 50%)';
        gloss.style.opacity='1';
      } else if(state.finish==='matte'){
        gloss.style.background='radial-gradient(circle at '+gx+'% '+gy+'%, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0) 55%)';
        gloss.style.opacity='1';
      } else { gloss.style.opacity='0'; }
      if(state.finish==='holographic'){
        var texX=50+ndx*40, texY=50+ndy*30;
        holo.style.backgroundPosition=texX+'% '+texY+'%';
      }
      var sx=-ndx*8, sy=4+ndy*5;
      shadow.style.transform='translateX('+sx+'px) translateY('+sy+'px) scaleY('+(0.6+Math.abs(ndy)*0.3)+')';
      shadow.style.opacity=0.5+Math.abs(ndy)*0.3;
    }
    var gyroActive=false, gBeta=0, gGamma=0, rawBeta=0, rawGamma=0;
    function gyroLoop(){
      if(!gyroActive || !window._sl2GyroActive) return;
      gBeta+=(rawBeta-gBeta)*0.12;
      gGamma+=(rawGamma-gGamma)*0.12;
      applyTilt(Math.max(-1,Math.min(1,gGamma/30)),Math.max(-1,Math.min(1,gBeta/30)));
      requestAnimationFrame(gyroLoop);
    }
    function handleGyro(e){
      if(e.beta==null && e.gamma==null) return;
      rawBeta=Math.max(-30,Math.min(30,(e.beta||0)-45));
      rawGamma=Math.max(-30,Math.min(30,e.gamma||0));
      if(!gyroActive){ gyroActive=true; requestAnimationFrame(gyroLoop); }
    }
    window._sl2HandleGyro=handleGyro;
    window._sl2RestartGyro=function(){ if(!gyroActive){ gyroActive=true; } requestAnimationFrame(gyroLoop); };
  })();
  (function setupBorderColor(){
    var colorBtns=$$('.sms-border-color-btn');
    var customInput=$('#smsBorderColorCustom');
    function _applyBC(){if(!state.canvas)return;if(state.shape==='die-cut')drawCutline();else applyShape();}
    function setBorderColor(color){
      state.borderColor=color;
      colorBtns.forEach(function(b){b.classList.toggle('active',b.dataset.bcolor===color);b.style.borderColor=b.dataset.bcolor===color?'#555':'transparent';});
      if(customInput)customInput.value=color;
      _applyBC();
    }
    colorBtns.forEach(function(btn){btn.addEventListener('click',function(){setBorderColor(btn.dataset.bcolor);});});
    if(customInput){
      customInput.addEventListener('input',function(){
        colorBtns.forEach(function(b){b.classList.remove('active');b.style.borderColor='transparent';});
        state.borderColor=customInput.value;
        _applyBC();
      });
    }
  })();
  function createModalOverlay(){
    var m=document.createElement('div');
    m.className='sms-modal-overlay';
    m._smsModal=true;
    function forceShow(){
      m.style.setProperty('display','flex','important');
      m.style.setProperty('position','fixed','important');
      m.style.setProperty('inset','0','important');
      m.style.setProperty('z-index','9999999','important');
      m.style.setProperty('background','rgba(0,0,0,0.5)','important');
      m.style.setProperty('align-items','center','important');
      m.style.setProperty('justify-content','center','important');
    }
    forceShow();
    var guard=false;
    var obs=new MutationObserver(function(muts){
      if(guard) return;
      muts.forEach(function(mut){
        if(mut.attributeName==='style' && m._smsModal && m.style.display!=='flex'){
          guard=true; forceShow(); guard=false;
        }
      });
    });
    obs.observe(m,{attributes:true,attributeFilter:['style']});
    m._smsObs=obs;
    return m;
  }
  function removeModal(m){
    if(m._smsObs) m._smsObs.disconnect();
    m._smsModal=false;
    if(m.parentNode) m.parentNode.removeChild(m);
  }
  (function setupQRCode(){
    var qrBtn=$('#btnQRCode');
    if(!qrBtn) return;
    qrBtn.addEventListener('click',function(){
      var modal=createModalOverlay();
      modal.innerHTML='<div class="sms-modal-box" style="max-width:400px;position:relative;">'
        +'<button class="sms-modal-close" id="smsQRClose">&times;</button>'
        +'<h3>Generate QR Code</h3>'
        +'<div style="margin-bottom:12px;">'
        +'<label style="font-size:12px;font-weight:600;color:#888;text-transform:uppercase;letter-spacing:0.5px;">URL or Text</label>'
        +'<input type="text" id="smsQRInput" placeholder="https://example.com" value="https://stickermint.com" style="width:100%;padding:12px;border:2px solid #e0e0e0;border-radius:8px;font-size:14px;margin-top:4px;outline:none;">'
        +'</div>'
        +'<div style="display:flex;gap:12px;margin-bottom:12px;">'
        +'<div style="flex:1;"><label style="font-size:12px;font-weight:600;color:#888;">Size</label>'
        +'<select id="smsQRSize" style="width:100%;padding:10px;border:2px solid #e0e0e0;border-radius:8px;font-size:13px;margin-top:4px;outline:none;">'
        +'<option value="6">Small</option><option value="8" selected>Medium</option><option value="12">Large</option></select></div>'
        +'<div style="flex:1;"><label style="font-size:12px;font-weight:600;color:#888;">Error Correction</label>'
        +'<select id="smsQRLevel" style="width:100%;padding:10px;border:2px solid #e0e0e0;border-radius:8px;font-size:13px;margin-top:4px;outline:none;">'
        +'<option value="L">Low (7%)</option><option value="M" selected>Medium (15%)</option><option value="Q">Quartile (25%)</option><option value="H">High (30%)</option></select></div>'
        +'</div>'
        +'<div style="text-align:center;margin-bottom:16px;"><canvas id="smsQRPreview" style="border:1px solid #eee;border-radius:8px;"></canvas></div>'
        +'<div style="display:flex;gap:8px;">'
        +'<button id="smsQRCancel" style="flex:1;padding:12px;border:2px solid #e0e0e0;border-radius:8px;background:#fff;font-size:14px;font-weight:600;cursor:pointer;">Cancel</button>'
        +'<button id="smsQRAdd" style="flex:1;padding:12px;border:none;border-radius:8px;background:#00c9a7;color:#fff;font-size:14px;font-weight:700;cursor:pointer;">Add to Canvas</button>'
        +'</div></div>';
      document.body.appendChild(modal);
      var qrInput=modal.querySelector('#smsQRInput');
      var qrSize=modal.querySelector('#smsQRSize');
      var qrLevel=modal.querySelector('#smsQRLevel');
      var qrPreview=modal.querySelector('#smsQRPreview');
      function renderQRPreview(){
        try{
          var typeNum=parseInt(qrSize.value);
          var ecl=qrLevel.value;
          var qr=qrcode(typeNum,ecl);
          qr.addData(qrInput.value||'https://stickermint.com');
          qr.make();
          var moduleCount=qr.getModuleCount();
          var cellSize=Math.max(4,Math.floor(200/moduleCount));
          var size=moduleCount*cellSize;
          qrPreview.width=size;qrPreview.height=size;
          var ctx=qrPreview.getContext('2d');
          ctx.fillStyle='#fff';ctx.fillRect(0,0,size,size);
          for(var r=0;r<moduleCount;r++){
            for(var cc=0;cc<moduleCount;cc++){
              if(qr.isDark(r,cc)){ctx.fillStyle='#000';ctx.fillRect(cc*cellSize,r*cellSize,cellSize,cellSize);}
            }
          }
        }catch(e){
          qrPreview.width=200;qrPreview.height=200;
          var ctx=qrPreview.getContext('2d');
          ctx.fillStyle='#fff';ctx.fillRect(0,0,200,200);
          ctx.fillStyle='#e53935';ctx.font='13px sans-serif';ctx.textAlign='center';
          ctx.fillText('Error: data too long for QR size',100,100);
        }
      }
      renderQRPreview();
      qrInput.addEventListener('input',renderQRPreview);
      qrSize.addEventListener('change',renderQRPreview);
      qrLevel.addEventListener('change',renderQRPreview);
      modal.querySelector('#smsQRCancel').addEventListener('click',function(){removeModal(modal);});
      modal.addEventListener('click',function(e){if(e.target===modal)removeModal(modal);});
      modal.querySelector('#smsQRAdd').addEventListener('click',function(){
        var imgData=qrPreview.toDataURL('image/png');
        var img=new Image();
        img.onload=function(){
          if(!state.canvas){
            state.originalImg=img;
            D.dz.style.display='none';
            hideBlankShape();
            D.prev.classList.add('visible');
            initCanvas(img);
            hideProgress();
            D.atc.disabled=false;
            D.dl.disabled=false;
            D.dl.style.display='';            $('#btnShareLink').disabled=false;
            $('#btnShareLink').style.display='';$('#btnStartFresh').style.display='';$('#btnStartFresh').disabled=false;
            $('#smsAutoSaveIndicator').style.display='';
            $('#smsZoomControls').style.display='flex';
            updateDeleteBtn();updateStartOverBtn();
            initShareSession();
          } else {
            var c=state.canvas;
            var maxDim=Math.min(c.getWidth(),c.getHeight())*0.4;
            var s=Math.min(maxDim/img.width,maxDim/img.height,1);
            var fImg=new fabric.Image(img,{left:c.getWidth()/2,top:c.getHeight()/2,originX:'center',originY:'center',scaleX:s,scaleY:s});
            unlockImage(fImg);
            c.add(fImg);c.setActiveObject(fImg);c.renderAll();
            if(state.shape==='die-cut') drawCutline();
            saveState();
          }
        };
        img.src=imgData;
        removeModal(modal);
      });
    });
  })();
  var _logoUrls={'sms-logo-instagram.svg':_smsAssetBase+'sms-logo-instagram.svg','sms-logo-tiktok.svg':_smsAssetBase+'sms-logo-tiktok.svg','sms-logo-youtube.svg':_smsAssetBase+'sms-logo-youtube.svg','sms-logo-x.svg':_smsAssetBase+'sms-logo-x.svg','sms-logo-facebook.svg':_smsAssetBase+'sms-logo-facebook.svg','sms-logo-snapchat.svg':_smsAssetBase+'sms-logo-snapchat.svg','sms-logo-linkedin.svg':_smsAssetBase+'sms-logo-linkedin.svg','sms-logo-pinterest.svg':_smsAssetBase+'sms-logo-pinterest.svg','sms-logo-whatsapp.svg':_smsAssetBase+'sms-logo-whatsapp.svg','sms-logo-poshmark.svg':_smsAssetBase+'sms-logo-poshmark.svg'};
  function _logoImg(f,r){return '<img src="'+_logoUrls[f]+'" style="width:100%;height:100%;object-fit:contain;border-radius:'+(r||4)+'px;">';}
  var _socNames=[['Instagram','sms-logo-instagram.svg'],['TikTok','sms-logo-tiktok.svg'],['YouTube','sms-logo-youtube.svg'],['X','sms-logo-x.svg'],['Facebook','sms-logo-facebook.svg'],['Snapchat','sms-logo-snapchat.svg'],['LinkedIn','sms-logo-linkedin.svg'],['Pinterest','sms-logo-pinterest.svg'],['WhatsApp','sms-logo-whatsapp.svg'],['Poshmark','sms-logo-poshmark.svg']];
  (function setupClipart(){
    var clipartBtn=$('#btnClipart');
    if(!clipartBtn) return;
    var CLIPART={
      social:_socNames.map(function(s){return {name:s[0],isImage:true,file:s[1],svg:_logoImg(s[1])};}),
      common:[
        {name:'Heart',path:'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z',color:'#e53935'},
        {name:'Star',path:'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z',color:'#fdd835'},
        {name:'Arrow',path:'M5 12h14M12 5l7 7-7 7',color:'#333333',isStroke:true},
        {name:'Lightning',path:'M13 2L3 14h9l-1 8 10-12h-9l1-8z',color:'#f59e0b'},
        {name:'Fire',path:'M12 23c-3.6 0-8-2.9-8-8.3C4 9.6 8 5.1 9.2 3.7c.2-.3.7-.2.8.1.5 1.7 1.7 3.3 3 4.3.1-.4.1-.8.1-1.3 0-.7-.1-1.5-.3-2.2-.1-.3.2-.6.5-.5C16.2 5.5 20 9.5 20 14.7 20 20.1 15.6 23 12 23z',color:'#ef4444'},
        {name:'Music',path:'M9 18V5l12-2v13M9 18c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zM21 16c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z',color:'#7c3aed',isStroke:true},
        {name:'Camera',path:'M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2zM12 17a4 4 0 100-8 4 4 0 000 8z',color:'#555555',isStroke:true},
        {name:'Crown',path:'M2 20h20L19 9l-4 5-3-7-3 7-4-5-3 11z',color:'#f59e0b'},
        {name:'Thumbs Up',path:'M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3H14zM7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3',color:'#3b82f6',isStroke:true},
        {name:'Check',path:'M22 11.08V12a10 10 0 11-5.93-9.14M22 4L12 14.01l-3-3',color:'#22c55e',isStroke:true},
        {name:'Shield',path:'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',color:'#6366f1',isStroke:true},
        {name:'Trophy',path:'M6 9H4.5a2.5 2.5 0 010-5H6M18 9h1.5a2.5 2.5 0 000-5H18M4 22h16M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 19.24 7 20v2M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 19.24 17 20v2M18 2H6v7a6 6 0 1012 0V2z',color:'#eab308',isStroke:true}
      ],
      nature:[
        {name:'Sun',path:'M12 17a5 5 0 100-10 5 5 0 000 10zM12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42',color:'#f59e0b',isStroke:true},
        {name:'Moon',path:'M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z',color:'#6366f1',isStroke:true},
        {name:'Cloud',path:'M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z',color:'#64748b',isStroke:true},
        {name:'Leaf',path:'M11 20A7 7 0 019.8 6.9C15.5 4.9 17 3.5 19 2c1 2 2 4.5 2 8 0 5.5-3.8 10-10 10zM2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12',color:'#22c55e',isStroke:true},
        {name:'Flower',path:'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z',color:'#ec4899'},
        {name:'Paw',path:'M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-3 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z',color:'#a855f7'},
        {name:'Rainbow',path:'M22 17a10 10 0 00-20 0M18 17a6 6 0 00-12 0M14 17a2 2 0 00-4 0',color:'#ec4899',isStroke:true},
        {name:'Snowflake',path:'M12 2v20M2 12h20M4.93 4.93l14.14 14.14M19.07 4.93L4.93 19.07',color:'#38bdf8',isStroke:true}
      ],
      food:[
        {name:'Coffee',path:'M18 8h1a4 4 0 010 8h-1M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8zM6 1v3M10 1v3M14 1v3',color:'#92400e',isStroke:true},
        {name:'Pizza',path:'M12 2L2 19.5c3 2.5 6.5 3.5 10 3.5s7-1 10-3.5L12 2zM12 2v20',color:'#f59e0b',isStroke:true},
        {name:'Cake',path:'M2 20h20v-4a2 2 0 00-2-2H4a2 2 0 00-2 2v4zM4 14V9a1 1 0 011-1h14a1 1 0 011 1v5M12 4v4M8 4v4M16 4v4M12 1a1 1 0 110 2 1 1 0 010-2zM8 1a1 1 0 110 2 1 1 0 010-2zM16 1a1 1 0 110 2 1 1 0 010-2z',color:'#f472b6',isStroke:true},
        {name:'Ice Cream',path:'M12 2a5 5 0 00-5 5c0 3 2 5 5 9 3-4 5-6 5-9a5 5 0 00-5-5zM7 14l5 8 5-8',color:'#c084fc',isStroke:true}
      ]
    };
    function addClipartToCanvas(item){
      if(!state.canvas) initBlankCanvas();
      var c=state.canvas;
      if(item.isImage){
        var url=_smsAssetBase+item.file;
        fabric.Image.fromURL(url,function(img){
          if(!img||!img.width) return;
          var targetSize=c.getWidth()*0.25;
          var s=targetSize/Math.max(img.width,img.height);
          img.set({scaleX:s,scaleY:s,left:c.getWidth()/2,top:c.getHeight()/2,originX:'center',originY:'center'});
          unlockImage(img);c.add(img);c.setActiveObject(img);c.renderAll();
          if(state.shape==='die-cut'){drawCutline();autoFitView();}
          else{var sd=getShapeDims();var cx=c.getWidth()/2,cy=c.getHeight()/2;img.clipPath=createShapeClip(state.shape,sd[0],sd[1],cx,cy);img.bringToFront();c.setActiveObject(img);c.renderAll();}
          positionOverlays();updateDimLabel();
          updateDeleteBtn();updateStartOverBtn();
          saveState();initShareSession();
        },{crossOrigin:'anonymous'});
        return;
      }
      var pathStr=item.path;
      if(item.isStroke){
        var pathObj=new fabric.Path(pathStr,{
          fill:'transparent',stroke:item.color,strokeWidth:2,strokeLineCap:'round',strokeLineJoin:'round',
          left:c.getWidth()/2,top:c.getHeight()/2,originX:'center',originY:'center'
        });
        var targetSize=c.getWidth()*0.25;
        var pathScale=targetSize/Math.max(pathObj.width,pathObj.height);
        pathObj.set({scaleX:pathScale,scaleY:pathScale});
        unlockImage(pathObj);
        c.add(pathObj);c.setActiveObject(pathObj);c.renderAll();
      } else {
        var pathObj=new fabric.Path(pathStr,{
          fill:item.color,stroke:'none',
          left:c.getWidth()/2,top:c.getHeight()/2,originX:'center',originY:'center'
        });
        var targetSize=c.getWidth()*0.25;
        var pathScale=targetSize/Math.max(pathObj.width,pathObj.height);
        pathObj.set({scaleX:pathScale,scaleY:pathScale});
        unlockImage(pathObj);
        c.add(pathObj);c.setActiveObject(pathObj);c.renderAll();
      }
      if(state.shape==='die-cut'){drawCutline();autoFitView();}
      else{var sd=getShapeDims();var cx=c.getWidth()/2,cy=c.getHeight()/2;pathObj.clipPath=createShapeClip(state.shape,sd[0],sd[1],cx,cy);pathObj.bringToFront();c.setActiveObject(pathObj);c.renderAll();}
      positionOverlays(); updateDimLabel();
      updateDeleteBtn();updateStartOverBtn();
      saveState();initShareSession();
    }
    clipartBtn.addEventListener('click',function(){
      var modal=createModalOverlay();
      var html='<div class="sms-modal-box" style="max-width:560px;position:relative;">'
        +'<button class="sms-modal-close" id="smsClipartClose">&times;</button>'
        +'<h3>Clipart Library</h3>'
        +'<div class="sms-modal-grid">';
      html+='<div class="sms-clipart-cat">Social Media</div>';
      CLIPART.social.forEach(function(item,i){
        html+='<div class="sms-modal-item" data-clipart-type="social" data-clipart-idx="'+i+'">'+item.svg+'<span>'+item.name+'</span></div>';
      });
      var extraCats=[
        {key:'common',label:'Common Icons'},
        {key:'nature',label:'Nature'},
        {key:'food',label:'Food & Drink'}
      ];
      extraCats.forEach(function(cat){
        if(!CLIPART[cat.key]) return;
        html+='<div class="sms-clipart-cat">'+cat.label+'</div>';
        CLIPART[cat.key].forEach(function(item,i){
          var svgStr;
          if(item.isStroke){
            svgStr='<svg viewBox="0 0 24 24" fill="none" stroke="'+item.color+'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="'+item.path+'"/></svg>';
          } else {
            svgStr='<svg viewBox="0 0 24 24"><path d="'+item.path+'" fill="'+item.color+'"/></svg>';
          }
          html+='<div class="sms-modal-item" data-clipart-type="'+cat.key+'" data-clipart-idx="'+i+'">'+svgStr+'<span>'+item.name+'</span></div>';
        });
      });
      html+='</div></div>';
      modal.innerHTML=html;
      document.body.appendChild(modal);
      modal.querySelector('#smsClipartClose').addEventListener('click',function(){removeModal(modal);});
      modal.addEventListener('click',function(e){if(e.target===modal)removeModal(modal);});
      modal.addEventListener('click',function(e){
        var el=e.target.closest('.sms-modal-item');
        if(!el) return;
        var type=el.dataset.clipartType;
        var idx=parseInt(el.dataset.clipartIdx);
        if(!CLIPART[type]||!CLIPART[type][idx]) return;
        var item=CLIPART[type][idx];
        addClipartToCanvas(item);
        removeModal(modal);
      });
    });
  })();
  (function setupTemplates(){
    var socialDefaults={shape:'die-cut',size:'custom',sizeInches:9,customW:9,customH:3,finish:'glossy'};
    var qrDefaults={shape:'square',size:'3x3',sizeInches:3,finish:'glossy'};
    var _socTpls=[['instagram','Instagram','Your Name'],['tiktok','TikTok','Your Name'],['facebook','Facebook','Your Page'],['youtube','YouTube','Your Channel'],['x','X','Your Handle'],['linkedin','LinkedIn','Your Name'],['snapchat','Snapchat','Your Snap'],['whatsapp','WhatsApp','Your Number'],['pinterest','Pinterest','Your Board'],['poshmark','Poshmark','Your Closet']];
    var TEMPLATES=_socTpls.map(function(s){var f='sms-logo-'+s[0]+'.svg';return {id:s[0]+'-handle',cat:'social-media',name:s[1],icon:_logoImg(f,6),defaults:socialDefaults,elements:[{type:'logo',file:f,scale:0.14,offsetX:-0.22,offsetY:-0.015},{type:'text',text:s[2],font:'Impact',scaleH:0.115,color:'#000000',offsetX:0.11}]};}).concat([
      {id:'qr-business',cat:'qr-code',name:'Business Card QR',
        icon:'<svg viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1.8"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><path d="M14 14h3v3M18 18h3v3"/></svg>',
        defaults:qrDefaults,
        elements:[
          {type:'qr',data:'https://stickermint.com',scale:0.5,offsetY:-0.08},
          {type:'text',text:'Your Business',font:'Inter',fontSize:22,color:'#222222',offsetY:0.28},
          {type:'text',text:'Scan to visit',font:'Inter',fontSize:14,color:'#888888',offsetY:0.36}
        ]},
      {id:'qr-wifi',cat:'qr-code',name:'WiFi QR',
        icon:'<svg viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="2"><path d="M5 12.55a11 11 0 0114 0"/><path d="M1.42 9a16 16 0 0121.16 0"/><path d="M8.53 16.11a6 6 0 016.95 0"/><circle cx="12" cy="20" r="1" fill="#333"/></svg>',
        defaults:qrDefaults,
        elements:[
          {type:'qr',data:'WIFI:T:WPA;S:YourNetwork;P:YourPassword;;',scale:0.5,offsetY:-0.08},
          {type:'text',text:'WiFi: YourNetwork',font:'Inter',fontSize:20,color:'#222222',offsetY:0.28},
          {type:'text',text:'Scan to connect',font:'Inter',fontSize:14,color:'#888888',offsetY:0.36}
        ]},
      {id:'qr-menu',cat:'qr-code',name:'Restaurant Menu QR',
        icon:'<svg viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1.8"><rect x="4" y="2" width="16" height="20" rx="2"/><path d="M8 6h8M8 10h8M8 14h5"/></svg>',
        defaults:qrDefaults,
        elements:[
          {type:'qr',data:'https://yourmenu.com',scale:0.5,offsetY:-0.08},
          {type:'text',text:'View Our Menu',font:'Inter',fontSize:22,color:'#222222',offsetY:0.28},
          {type:'text',text:'Scan the QR code',font:'Inter',fontSize:14,color:'#888888',offsetY:0.36}
        ]},
      {id:'business-logo',cat:'other',name:'Business Logo',
        icon:'<svg viewBox="0 0 24 24" fill="none" stroke="#333" stroke-width="1.8"><rect x="3" y="3" width="18" height="18" rx="3"/><path d="M7 12h10M12 7v10"/></svg>',
        defaults:{shape:'die-cut',size:'3x3',sizeInches:3,finish:'matte'},
        elements:[
          {type:'text',text:'YOUR LOGO',font:'Bebas Neue',fontSize:48,color:'#222222',offsetY:-0.05},
          {type:'text',text:'Company Name',font:'Inter',fontSize:20,color:'#888888',offsetY:0.15}
        ]},
      {id:'hello-name',cat:'other',name:'Hello Name Tag',
        icon:'<svg viewBox="0 0 24 24" fill="none"><rect x="1" y="4" width="22" height="16" rx="2" fill="#ef4444"/><rect x="2" y="10" width="20" height="9" fill="#fff"/></svg>',
        defaults:{shape:'rectangle',size:'4x4',sizeInches:4,finish:'glossy'},
        elements:[
          {type:'rect',width:0.95,height:0.35,color:'#ef4444',offsetY:-0.32},
          {type:'text',text:'HELLO',font:'Bebas Neue',fontSize:18,color:'#ffffff',offsetY:-0.37},
          {type:'text',text:'MY NAME IS',font:'Inter',fontSize:12,color:'#ffffff',offsetY:-0.27},
          {type:'rect',width:0.95,height:0.65,color:'#ffffff',offsetY:0.175},
          {type:'text',text:'Your Name',font:'Permanent Marker',fontSize:40,color:'#222222',offsetY:0.12}
        ]}
    ]);
    var CATEGORIES={
      'social-media':{name:'Social Media Stickers',desc:'Pick your platform',templates:TEMPLATES.filter(function(t){return t.cat==='social-media';})},
      'qr-code':{name:'QR Code Stickers',desc:'Pick your QR type',templates:TEMPLATES.filter(function(t){return t.cat==='qr-code';})}
    };
    function applyTemplateDefaults(tpl){
      if(tpl.defaults.shape){
        state.shape=tpl.defaults.shape;
        $$('.sms-shape-btn').forEach(function(b){b.classList.toggle('active',b.dataset.shape===tpl.defaults.shape);});
      }
      if(tpl.defaults.size){
        state.size=tpl.defaults.size;
        state.sizeInches=tpl.defaults.sizeInches||3;
        $$('.sms-size-radio[name="sms-size"]').forEach(function(r){r.checked=(r.value===tpl.defaults.size);});
        if(tpl.defaults.size==='custom'){
          customSizePanel.style.display='';
          if(tpl.defaults.customW) customW.value=tpl.defaults.customW;
          if(tpl.defaults.customH) customH.value=tpl.defaults.customH;
          state.sizeInches=Math.max(parseFloat(customW.value)||3,parseFloat(customH.value)||3);
        } else { customSizePanel.style.display='none'; }
      }
      if(tpl.defaults.finish){
        state.finish=tpl.defaults.finish;
        $$('.sms-finish-btn').forEach(function(b){b.classList.toggle('active',b.dataset.finish===tpl.defaults.finish);});
        applyFinish();
      }
      _mo('size');
      updatePrice();
    }
    function loadTemplate(tpl){
      D.dz.style.display='none';
      hideBlankShape();
      D.prev.classList.add('visible');
      $('#smsZoomControls').style.display='flex';
      applyTemplateDefaults(tpl);
      /* Enable ATC + Share + Start Over + generate unique share session ID
         for template designs (same as direct image uploads). */
      D.atc.disabled=false;
      D.dl.disabled=false;D.dl.style.display='';
      $('#btnShareLink').disabled=false;$('#btnShareLink').style.display='';
      $('#btnStartFresh').disabled=false;$('#btnStartFresh').style.display='';
      var _aut=$('#smsAutoSaveIndicator');if(_aut)_aut.style.display='';
      try{if(typeof initShareSession==='function')initShareSession();}catch(_e){}
      var tplW=600,tplH=600;
      if(tpl.defaults&&tpl.defaults.customW&&tpl.defaults.customH){
        var ar=tpl.defaults.customW/tpl.defaults.customH;
        if(ar>=1){tplW=600;tplH=Math.round(600/ar);}
        else{tplH=600;tplW=Math.round(600*ar);}
      }
      var blankCanvas=document.createElement('canvas');
      blankCanvas.width=tplW;blankCanvas.height=tplH;
      var bctx=blankCanvas.getContext('2d');
      bctx.fillStyle='#ffffff';
      bctx.fillRect(0,0,tplW,tplH);
      var blankImg=new Image();
      blankImg.onload=function(){
        state.originalImg=blankImg;
        initCanvas(blankImg);
        var c=state.canvas; if(!c) return;
        var mi=getMainImage(); if(mi) mi._isTemplateBg=true;
        var cw=c.getWidth(), ch=c.getHeight();
        tpl.elements.forEach(function(el){
          var cx=cw/2, cy=ch/2;
          var oy=el.offsetY?el.offsetY*ch:0;
          var ox=el.offsetX?el.offsetX*cw:0;
          if(el.type==='text'){
            var _fs=el.scaleH?Math.round(cw*el.scaleH):(el.fontSize||36);
            c.add(new fabric.IText(el.text,{
              fontFamily:el.font||'Inter',fontSize:_fs,fill:el.color||'#222222',
              left:cx+ox,top:cy+oy,originX:'center',originY:'center',
              editable:true,hasControls:true,hasBorders:true,selectable:true,
              objectCaching:false
            }));
          } else if(el.type==='logo'){
            (function(elDef,canvasRef,cxPos,cyPos,oxPos,oyPos,cwSize){
              var url=_smsAssetBase+elDef.file;
              function onLogoLoaded(img){
                if(!img||!img.width) return;
                var txts=canvasRef.getObjects('i-text');
                if(txts.length){
                  var tb=txts[0];tb.setCoords();
                  var tbr=tb.getBoundingRect();
                  var logoSize=tbr.height*0.95;
                  var s=logoSize/Math.max(img.width,img.height);
                  img.set({scaleX:s,scaleY:s,originX:'center',originY:'center'});
                  img.setCoords();
                  /* Narrower gap so cutline merges logo + text into one outline.
                     Was 0.15 (~15% of text height) — now 0.04 (~4%). */
                  var gap=tbr.height*0.04;
                  var logoW=img.width*s;
                  var totalW=logoW+gap+tbr.width;
                  var canvasCx=canvasRef.getWidth()/2;
                  var canvasCy=canvasRef.getHeight()/2;
                  var groupLeft=canvasCx-totalW/2;
                  img.set({left:groupLeft+logoW/2,top:canvasCy+oyPos});
                  tb.set({left:groupLeft+logoW+gap+tbr.width/2,top:canvasCy,originX:'center',originY:'center'});
                  tb.setCoords();
                } else {
                  var ts=cwSize*(elDef.scale||0.25);
                  var s=ts/Math.max(img.width,img.height);
                  img.set({left:cxPos+oxPos,top:cyPos+oyPos,originX:'center',originY:'center',scaleX:s,scaleY:s});
                }
                unlockImage(img);canvasRef.add(img);canvasRef.renderAll();
                if(state.shape==='die-cut') drawCutline();
                history.states=[];history.idx=-1;saveState();
              }
              fabric.Image.fromURL(url,onLogoLoaded,{crossOrigin:'anonymous'});
            })(el,c,cx,cy,ox,oy,cw);
          } else if(el.type==='clipart'){
            var pathObj=new fabric.Path(el.path,{fill:el.color||'#000',stroke:'none',left:cx+ox,top:cy+oy,originX:'center',originY:'center'});
            var ts=cw*(el.scale||0.25);
            pathObj.set({scaleX:ts/Math.max(pathObj.width||1,pathObj.height||1),scaleY:ts/Math.max(pathObj.width||1,pathObj.height||1)});
            unlockImage(pathObj); c.add(pathObj);
          } else if(el.type==='rect'){
            c.add(new fabric.Rect({width:cw*(el.width||0.5),height:ch*(el.height||0.2),fill:el.color||'#fff',left:cx+ox,top:cy+oy,originX:'center',originY:'center',selectable:true,hasControls:true,hasBorders:true}));
          } else if(el.type==='qr'){
            try{
              var qr=qrcode(8,'M');qr.addData(el.data||'https://stickermint.com');qr.make();
              var mc=qr.getModuleCount(),cs=Math.max(4,Math.floor(300/mc)),sz=mc*cs;
              var qC=document.createElement('canvas');qC.width=sz;qC.height=sz;
              var qx=qC.getContext('2d');qx.fillStyle='#fff';qx.fillRect(0,0,sz,sz);
              for(var r=0;r<mc;r++)for(var cc=0;cc<mc;cc++)if(qr.isDark(r,cc)){qx.fillStyle='#000';qx.fillRect(cc*cs,r*cs,cs,cs);}
              var qi=new Image();qi.onload=function(){
                var ts2=cw*(el.scale||0.4),s=ts2/Math.max(qi.width,qi.height);
                var fi=new fabric.Image(qi,{left:cx+ox,top:cy+oy,originX:'center',originY:'center',scaleX:s,scaleY:s});
                unlockImage(fi);c.add(fi);c.renderAll();if(state.shape==='die-cut')drawCutline();history.states=[];history.idx=-1;saveState();
              };qi.src=qC.toDataURL('image/png');
            }catch(e){console.error('QR error:',e);}
          }
        });
        c.renderAll();
        if(state.shape==='die-cut') drawCutline(); else applyShape();
        updateDimLabel();history.states=[];history.idx=-1;saveState();
        D.atc.disabled=false;D.dl.disabled=false;D.dl.style.display='';$('#btnEye').style.display='flex';$('#btnShareLink').disabled=false;$('#btnShareLink').style.display='';$('#btnStartFresh').style.display='';$('#btnStartFresh').disabled=false;$('#smsAutoSaveIndicator').style.display='';initShareSession();
        updateDeleteBtn();updateStartOverBtn();
      };
      blankImg.src=blankCanvas.toDataURL('image/png');
    }
    function showCategoryPicker(cat){
      var modal=createModalOverlay();
      var items=cat.templates;
      var html='<div class="sms-modal-box" style="max-width:520px;position:relative;">'
        +'<button class="sms-modal-close" id="smsCatClose">&times;</button>'
        +'<h3 style="margin-bottom:4px;">'+cat.name+'</h3>'
        +'<p style="color:#888;font-size:13px;margin-bottom:16px;">'+cat.desc+'</p>'
        +'<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:10px;">';
      items.forEach(function(tpl,i){
        html+='<div class="sms-template-card" data-tpl-id="'+tpl.id+'" style="cursor:pointer;">'
          +'<div class="sms-tpl-icon" style="width:48px;height:48px;margin:0 auto 6px;">'+tpl.icon+'</div>'
          +'<div class="sms-tpl-name" style="font-size:11px;">'+tpl.name+'</div>'
          +'</div>';
      });
      html+='</div></div>';
      modal.innerHTML=html;
      document.body.appendChild(modal);
      modal.querySelector('#smsCatClose').addEventListener('click',function(){removeModal(modal);});
      modal.addEventListener('click',function(e){if(e.target===modal)removeModal(modal);});
      modal.addEventListener('click',function(e){
        var card=e.target.closest('.sms-template-card');
        if(!card) return;
        var id=card.dataset.tplId;
        var tpl=TEMPLATES.find(function(t){return t.id===id;});
        if(tpl){removeModal(modal);loadTemplate(tpl);}
      });
    }
    var tplBtn=$('#btnTemplates');
    if(tplBtn){
      tplBtn.addEventListener('click',function(){
        var modal=createModalOverlay();
        var html='<div class="sms-modal-box" style="max-width:600px;position:relative;">'
          +'<button class="sms-modal-close" id="smsTplClose">&times;</button>'
          +'<h3>Choose a Template</h3>';
        var cats=[{key:'social-media',label:'Social Media Handles'},{key:'qr-code',label:'QR Code Stickers'},{key:'other',label:'Other Templates'}];
        cats.forEach(function(catDef){
          var items=TEMPLATES.filter(function(t){return t.cat===catDef.key;});
          if(!items.length) return;
          html+='<p style="font-size:11px;font-weight:700;color:#aaa;text-transform:uppercase;letter-spacing:1px;margin:16px 0 8px;">'+catDef.label+'</p>'
            +'<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:10px;">';
          items.forEach(function(tpl){
            html+='<div class="sms-template-card" data-tpl-id="'+tpl.id+'">'
              +'<div class="sms-tpl-icon" style="width:40px;height:40px;margin:0 auto 4px;">'+tpl.icon+'</div>'
              +'<div class="sms-tpl-name" style="font-size:10px;">'+tpl.name+'</div>'
              +'</div>';
          });
          html+='</div>';
        });
        html+='</div>';
        modal.innerHTML=html;
        document.body.appendChild(modal);
        modal.querySelector('#smsTplClose').addEventListener('click',function(){removeModal(modal);});
        modal.addEventListener('click',function(e){if(e.target===modal)removeModal(modal);});
          modal.addEventListener('click',function(e){
          var card=e.target.closest('.sms-template-card');
          if(!card) return;
          var id=card.dataset.tplId;
          var tpl=TEMPLATES.find(function(t){return t.id===id;});
          if(tpl){removeModal(modal);loadTemplate(tpl);}
        });
      });
    }
    try{
      var urlParams=new URLSearchParams(window.location.search);
      var tplId=urlParams.get('template');
      if(tplId){
        if(CATEGORIES[tplId]){
          setTimeout(function(){ showCategoryPicker(CATEGORIES[tplId]); },400);
        } else {
          var found=TEMPLATES.find(function(t){return t.id===tplId;});
          if(found) setTimeout(function(){ loadTemplate(found); },300);
        }
      }
    }catch(e){console.error('Tpl link:',e);}
  })();
  var _shareSessionId=null,_shareDebounce=null,_shareSaving=false,_shareLastPreview=null;
  var _shareWB='https://print-api.stickermint.workers.dev',_shareAK='sm_print_a7x9K2mP4qR8wL3nvx920123';
  function initShareSession(){
    if(window._smnNoAutosave)return;
    if(!_shareSessionId){_shareSessionId=Date.now().toString(36)+Math.random().toString(36).substring(2,8);var u=new URL(window.location.href);u.searchParams.set('s',_shareSessionId);window.history.replaceState(null,'',u.toString());}
    clearTimeout(_shareDebounce);_shareDebounce=setTimeout(doAutoSave,3000);
  }
  function dataURLtoBlob(d){var p=d.split(','),m=p[0].match(/:(.*?);/)[1],b=atob(p[1]),a=new Uint8Array(b.length);for(var i=0;i<b.length;i++)a[i]=b.charCodeAt(i);return new Blob([a],{type:m});}
  var _smnUpCache=new Map();
  async function uploadImg(src){
    if(!src||!src.startsWith('data:'))return src;
    if(_smnUpCache.has(src))return _smnUpCache.get(src);
    var _smnUrl=await _smnUploadImg(src);_smnUpCache.set(src,_smnUrl);return _smnUrl;
  }
  async function _smnUploadImg(src){
    var blob=dataURLtoBlob(src);
    var r=await fetch(_shareWB+'/upload',{method:'POST',headers:{'Content-Type':blob.type,'X-API-Key':_shareAK},body:blob});
    if(!r.ok)throw new Error('Upload failed: '+r.status);
    var j=await r.json();return j.url;
  }
  async function doAutoSave(){
    if(!state.canvas||!_shareSessionId||_shareSaving||window._smnNoAutosave)return;
    _shareSaving=true;var se=$('#smsAutoSaveStatus');if(se)se.textContent='Saving...';
    try{
      /* Studio Next: if a collaborator saved after the version we have, load theirs instead of overwriting it */
      try{var _rr=await fetch(_shareWB+'/share/'+_shareSessionId+'?t='+Date.now(),{cache:'no-store'});
        if(_rr.ok){var _rj=await _rr.json();if(_rj&&_rj._rev&&_rj._by&&_rj._by!==window._smnClientId&&_rj._rev>(window._smnLastRev||0)){_shareSaving=false;if(se)se.textContent='';if(window.SMN&&SMN.mergeRemote)SMN.mergeRemote(_rj);else if(window.SMN&&SMN.applyRemote)SMN.applyRemote(_rj,true);return;}}}catch(_e){}
      var cj=state.canvas.toJSON(['_isCutline','_isCutEdge','_isMainImage','_isTemplateBg','_uid']);
      for(var i=0;i<cj.objects.length;i++){
        var o=cj.objects[i];
        if(o.type==='image'&&o.src&&o.src.startsWith('data:')){
          o.src=await uploadImg(o.src);o.crossOrigin='anonymous';}
      }
      var imgD=_shareLastPreview||null;
      if(!imgD&&state.originalImg&&state.originalImg.src){
        if(state.originalImg.src.startsWith('data:'))imgD=await uploadImg(state.originalImg.src);
        else imgD=state.originalImg.src;
      }
      var r=await fetch(_shareWB+'/share',{method:'POST',headers:{'Content-Type':'application/json','X-API-Key':_shareAK},body:JSON.stringify({_rev:(window._smnLastRev=Date.now()),_by:window._smnClientId||'',id:_shareSessionId,canvas:cj,cw:state.canvas.width,ch:state.canvas.height,img:imgD,size:state.size,sizeInches:state.sizeInches,qty:state.qty,finish:state.finish,shape:state.shape,cutStyle:state.cutStyle,smoothLevel:state.smoothLevel,bgMode:state.bgMode,borderColor:state.borderColor,shapePortrait:state.shapePortrait,ts:Date.now()})});
      if(r.ok){document.dispatchEvent(new CustomEvent('smn:saved'));if(se)se.textContent='Saved';setTimeout(function(){if(se&&se.textContent==='Saved')se.textContent='';},2000);}else{if(se)se.textContent='Save failed';}
    }catch(e){if(se)se.textContent='';}
    _shareSaving=false;
  }
  var _origSaveState=saveState;
  saveState=function(){_origSaveState();if(_shareSessionId){clearTimeout(_shareDebounce);_shareDebounce=setTimeout(doAutoSave,3000);}};
  $('#btnShareLink').addEventListener('click',async function(){
    if(!_shareSessionId)return;
    var url=/[?&]view=studio-next/.test(location.search)?location.origin+location.pathname+'?view=studio-next&s='+_shareSessionId:'https://stickers.stickermint.com/'+_shareSessionId;
    window._smnShareUrl=url;
    try{var _prev=state.canvas.toDataURL({format:'png',multiplier:1});if(_prev)_shareLastPreview=await uploadImg(_prev);}catch(ex){}
    clearTimeout(_shareDebounce);doAutoSave();
    navigator.clipboard.writeText(url).then(function(){var t=$('#btnShareText');if(t){t.textContent='Copied!';setTimeout(function(){t.textContent='Share';},2000);}}).catch(function(){prompt('Copy this link:',url);});
  });
  function syncUIToState(){
    $$('.sms-size-radio[name="sms-size"]').forEach(function(r){r.checked=(r.value===state.size);});
    if(state.size==='custom'&&$('#smsCustomSize'))$('#smsCustomSize').style.display='';
    $$('.sms-shape-btn').forEach(function(b){b.classList.toggle('active',b.dataset.shape===state.shape);});
    $$('.sms-finish-btn').forEach(function(b){b.classList.toggle('active',b.dataset.finish===state.finish);});
    $$('.sms-tool-icon[data-cut]').forEach(function(b){b.classList.toggle('active',b.dataset.cut===state.cutStyle);});
    $$('.sms-border-color-btn').forEach(function(b){b.classList.toggle('active',b.dataset.bcolor===state.borderColor);b.style.borderColor='';});
    var qS=$('#qtySlider');if(qS)qS.value=state.qty;
    var qV=$('#qtyVal');if(qV)qV.value=state.qty;
    $$('.sms-qty-pre').forEach(function(b){b.classList.toggle('active',parseInt(b.dataset.qty)===state.qty);});
    $$('.sms-tool-icon[data-bg]').forEach(function(o){o.classList.remove('active');});
    var bg=$('.sms-tool-icon[data-bg="'+state.bgMode+'"]');if(bg)bg.classList.add('active');
    var stg=D.stg;
    if(stg){stg.classList.remove('finish-glossy','finish-holographic');if(state.finish==='glossy')stg.classList.add('finish-glossy');if(state.finish==='holographic')stg.classList.add('finish-holographic');}
    _mo();
  }
  function initCanvasFromJSON(json,cb){
    var area=$('.sms-canvas-area'),mob=window.innerWidth<=768;
    var aW=area.clientWidth,aH=area.clientHeight,cW,cH;
    if(mob){cW=Math.min(aW,700);cH=Math.round(cW*0.8);}else{cW=Math.round(aW*0.96);cH=Math.round(aH*0.96);}
    if(state.canvas)state.canvas.dispose();
    _tbSetupDone=false;
    var ce=$('#mainCanvas');ce.width=cW;ce.height=cH;
    fabric.devicePixelRatio=Math.max(window.devicePixelRatio||1,3);
    state.canvas=new fabric.Canvas('mainCanvas',{width:cW,height:cH,backgroundColor:'transparent',selection:false,uniformScaling:true,enableRetinaScaling:true});
    var _initStg=D.stg;if(_initStg){_initStg.style.width=cW+'px';_initStg.style.height=cH+'px';}
    if(mob)area.style.minHeight=cH+'px';
    history.recording=false;
    state.canvas.loadFromJSON(json,function(){
      state.canvas.setWidth(cW);state.canvas.setHeight(cH);
      state.canvas.setDimensions({width:cW,height:cH});
      var objs=state.canvas.getObjects();
      if(objs.length){
        var visObjs=objs.filter(function(o){return !o._isCutline&&!o._isTemplateBg;});
        var measureObjs=visObjs.length?visObjs:objs;
        var minL=Infinity,minT=Infinity,maxR=-Infinity,maxB=-Infinity;
        measureObjs.forEach(function(o){
          var br=o.getBoundingRect();
          if(br.left<minL)minL=br.left;if(br.top<minT)minT=br.top;
          if(br.left+br.width>maxR)maxR=br.left+br.width;
          if(br.top+br.height>maxB)maxB=br.top+br.height;
        });
        var gW=maxR-minL,gH=maxB-minT;
        var fillFactor=mob?0.85:0.90;
        var fs=Math.min(cW*fillFactor/gW,cH*fillFactor/gH);
        objs.forEach(function(o){o.set({left:(o.left-minL)*fs,top:(o.top-minT)*fs,scaleX:o.scaleX*fs,scaleY:o.scaleY*fs});o.setCoords();});
        minL=0;minT=0;gW*=fs;gH*=fs;
        var dx=(cW-gW)/2-minL,dy=(cH-gH)/2-minT;
        objs.forEach(function(o){o.set({left:o.left+dx,top:o.top+dy});o.setCoords();});
      }
      state.canvas.renderAll();
      state.canvas.getObjects().forEach(function(f){
        if(f._isCutline||f._isCutEdge||f._isScissorIcon) return;
        if(state.shape==='die-cut'&&f._isMainImage){lockImage(f);return;}
        f.set({selectable:true,evented:true,hasControls:true,hasBorders:true,lockMovementX:false,lockMovementY:false,lockScalingX:false,lockScalingY:false,lockRotation:false});
        f.setCoords();
      });
      history.recording=true;history.states=[];history.idx=-1;_origSaveState();
      state.canvas.on('object:modified',function(){if(state.shape==='die-cut'){drawCutline();}saveState();});
      setupTextToolbar();setupDblClickAdjust();setupMobileGestures();setupLockHandlers();
      if(state.shape==='die-cut')drawCutline();else applyShape();
      positionOverlays();updateDimLabel();
      $('#smsZoomControls').style.display='flex';D.atc.disabled=false;
      D.dl.disabled=false;D.dl.style.display='';      $('#btnShareLink').disabled=false;$('#btnShareLink').style.display='';$('#btnStartFresh').style.display='';$('#btnStartFresh').disabled=false;
      $('#smsAutoSaveIndicator').style.display='';
      updateDeleteBtn();updateStartOverBtn();
      if(cb)cb();
    });
  }
  (function(){
    try{
      var sid=new URLSearchParams(window.location.search).get('s');
      if(!sid||!/^[a-z0-9]{6,16}$/.test(sid))return;
      showProgress('Loading shared design...');
      fetch(_shareWB+'/share/'+sid).then(function(r){if(!r.ok)throw new Error(r.status);return r.json();}).then(function(s){
        if(!s||!s.canvas||!s.canvas.objects||!s.canvas.objects.length){hideProgress();return;}
        _shareSessionId=sid;window._smnLastRev=s._rev||s.ts||0;
        state.size=s.size||'2x2';state.sizeInches=s.sizeInches||2;state.qty=s.qty||50;
        state.finish=s.finish||'matte';state.shape=s.shape||'die-cut';
        state.cutStyle=s.cutStyle||'tight';state.smoothLevel=s.smoothLevel||'balanced';state.bgMode=s.bgMode||'none';
        state.borderColor=s.borderColor||'#ffffff';state.shapePortrait=!!s.shapePortrait;
        _mo('size');
        if(s.img){var oi=new Image();oi.crossOrigin='anonymous';oi.src=s.img;state.originalImg=oi;}
        else{var _imgObj=s.canvas.objects.find(function(o){return o.type==='image'&&!o._isCutline;});
          if(_imgObj&&_imgObj.src){var oi=new Image();oi.crossOrigin='anonymous';oi.src=_imgObj.src;state.originalImg=oi;}}
        syncUIToState();
        D.dz.style.display='none';hideBlankShape();D.prev.classList.add('visible');
        var _sp=document.getElementById('sl2Specs');if(_sp)_sp.style.display='none';
        var _spP=document.getElementById('sl2SpecsPill');if(_spP)_spP.style.display='flex';
        if($('#btnChangeImg'))$('#btnChangeImg').style.display='';
        initCanvasFromJSON(s.canvas,function(){
          hideProgress();updatePrice();
          if(window.innerWidth<=768){
            lockAllObjects();state.adjusting=false;
            D.aBar.classList.remove('visible');D.aHint.classList.remove('visible');
            var _qb=D.qb;if(_qb)_qb.style.display='none';
            var _ttb=D.ttb;if(_ttb)_ttb.style.display='none';
          } else {
            _allLocked=false;state.adjusting=true;D.aBar.classList.add('visible');
          }
          var u=new URL(window.location.href);u.searchParams.set('s',sid);
          window.history.replaceState(null,'',u.toString());
        });
      }).catch(function(e){console.error('Share restore:',e);hideProgress();});
    }catch(e){console.error('Share init:',e);hideProgress();}
  })();
  updatePrice();
  document.documentElement.classList.add('sms-page-active');
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    var cartBtns=document.getElementById('smsCartBtns');
    if(cart.item_count>0 && cartBtns){
      cartBtns.style.display='flex';
    }
  }).catch(function(){});
  function killBadges(){
    document.querySelectorAll('[id*="TrustedSite"],[id*="trustedsite"],[class*="trustedsite"],[class*="TrustedSite"],[id*="gsr"],[class*="gsr"]').forEach(function(el){el.style.display='none';});
    document.querySelectorAll('iframe,div').forEach(function(el){
      var s=getComputedStyle(el);
      if((s.position==='fixed'||s.position==='absolute')&&parseInt(s.bottom||999)<80&&parseInt(s.right||999)<80&&!el.closest('.sms')){
        el.style.display='none';
      }
    });
  }
  killBadges();
  setTimeout(killBadges,1000);
  setTimeout(killBadges,3000);
  setTimeout(killBadges,6000);
  var _origUpdateSO=updateStartOverBtn;
  updateStartOverBtn=function(){_origUpdateSO();var hc=_hasCanvasContent();var sf=document.getElementById('btnStartFresh');if(sf)sf.disabled=!hc;var tc=$('#sl2TbCart');if(tc)tc.disabled=!hc;};
  document.getElementById('btnStartFresh').addEventListener('click',function(){
    var url=window.location.pathname;window.location.href=url;
  });
  /* Studio Next: one shared hook for the add-on files (studio-next-addons.js etc.) */
  window.SMN = {
    state: state, vo: _vo, isSys: _isSys,
    unlock: _unlockObj, lockAll: lockAllObjects, save: saveState, drawCutline: drawCutline,
    redraw: _redrawAfterEdit, del: doDeleteSelected, positionOverlays: positionOverlays, updateDimLabel: updateDimLabel,
    refreshBtns: function(){ updateDeleteBtn(); updateStartOverBtn(); },
    lip: getLipBounds, price: calculatePrice, updatePrice: updatePrice, loadImage: loadImage, addImage: addImageToCanvas,
    getZoom: function(){ return zoomLevel; }, setZoom: function(z){ zoomLevel = z; applyZoom(); }, defaultZoom: defaultZoom,
    capture: capturePreview, printPDF: generatePrintPDF, customInches: getCustomSizeInches,
    shareId: function(){ return typeof _shareSessionId!=='undefined'?_shareSessionId:null; },
    setShareId: function(id){ _shareSessionId=id||null; var u=new URL(window.location.href); if(id)u.searchParams.set('s',id); else u.searchParams.delete('s'); window.history.replaceState(null,'',u.toString()); },
    /* co-editing: replace the design with a collaborator's saved version */
    applyRemote: function(s,conflict){
      if(!s||!s.canvas||!s.canvas.objects)return;
      D.dz.style.display='none';hideBlankShape();D.prev.classList.add('visible');
      window._smnLastRev=s._rev||s.ts||Date.now();
      state.size=s.size||state.size;state.sizeInches=s.sizeInches||state.sizeInches;state.qty=s.qty||state.qty;
      state.finish=s.finish||state.finish;state.shape=s.shape||state.shape;state.cutStyle=s.cutStyle||state.cutStyle;
      state.smoothLevel=s.smoothLevel||state.smoothLevel;state.bgMode=s.bgMode||state.bgMode;
      state.borderColor=s.borderColor||state.borderColor;state.shapePortrait=!!s.shapePortrait;
      syncUIToState();
      initCanvasFromJSON(s.canvas,function(){updatePrice();document.dispatchEvent(new CustomEvent('smn:remote',{detail:{conflict:!!conflict,by:s._by}}));});
    }
  };
  try{window._smnClientId=window._smnClientId||sessionStorage.getItem('smn_client')||(Date.now().toString(36)+Math.random().toString(36).slice(2,8));sessionStorage.setItem('smn_client',window._smnClientId);}catch(_e){window._smnClientId=window._smnClientId||Math.random().toString(36).slice(2);}
  document.dispatchEvent(new CustomEvent('smn:ready'));
})();
(function(){
  var specsScreen = document.getElementById('sl2Specs');
  var specsPill = document.getElementById('sl2SpecsPill');
  var startBtn = document.getElementById('sl2StartDesigning');
  var pillText = document.getElementById('sl2PillText');
  var pillPrice = document.getElementById('sl2PillPrice');
  var specsPrice = document.getElementById('sl2SpecsPrice');
  var specsUnit = document.getElementById('sl2SpecsUnit');
  if(!specsScreen || !startBtn) return;
  var specState = window._specS = {shape:'die-cut', size:'2x2', sizeInches:2, finish:'matte', qty:50};
  var pricingConfig;
  try{
    var _raw = window.SMN_CONFIG.pricingJson;
    pricingConfig = (typeof _raw === 'string') ? JSON.parse(_raw) : _raw;
  }catch(e){ pricingConfig = null; }
  if(!pricingConfig || !pricingConfig.material_rates) pricingConfig = {material_rates:{matte:0.115,glossy:0.115,holographic:0.155},qty_multipliers:[[2,12],[4,9],[10,4.5],[50,1.5],[100,1],[200,0.95],[300,0.92],[500,0.89],[1000,0.88],[2000,0.85],[5000,0.82]]};
  function calcPrice(inches,finish,qty){
    var rate=pricingConfig.material_rates[finish]||0.115;
    var mult=pricingConfig.qty_multipliers;
    var m=mult[mult.length-1][1];
    for(var i=0;i<mult.length;i++){if(qty<=mult[i][0]){m=mult[i][1];break;}}
    var raw=inches*rate*qty*m;
    return Math.floor(raw);
  }
  function updateSpecsPrice(){
    var total = calcPrice(specState.sizeInches, specState.finish, specState.qty);
    var unit = (total / specState.qty).toFixed(2);
    specsPrice.textContent = '$' + total + '.00';
    specsUnit.textContent = '$' + unit + ' each';
  }
  function updatePillText(){
    var shapeLabels = {'die-cut':'Die-Cut','circle':'Circle','square':'Square','rectangle':'Rectangle','oval':'Oval','rounded-square':'Rounded'};
    var finishLabels = {'matte':'Matte','glossy':'Glossy','holographic':'Holo'};
    var total = calcPrice(specState.sizeInches, specState.finish, specState.qty);
    pillText.textContent = specState.sizeInches + '" ' + (shapeLabels[specState.shape]||specState.shape) + ' \u2022 ' + (finishLabels[specState.finish]||specState.finish) + ' \u2022 ' + specState.qty + 'qty';
    pillPrice.textContent = '$' + total + '.00';
  }
  function wireGroup(containerId, stateKey, valueFn){
    var container = document.getElementById(containerId);
    if(!container) return;
    container.addEventListener('click', function(e){
      var pill = e.target.closest('.sl2-pill') || e.target.closest('.sl2-shape-card');
      if(!pill) return;
      if(pill.classList.contains('sms-locked')) return;
      container.querySelectorAll('.sl2-pill,.sl2-shape-card').forEach(function(p){p.classList.remove('active');});
      pill.classList.add('active');
      var val = pill.dataset[stateKey] || pill.dataset.shape || pill.dataset.size || pill.dataset.finish || pill.dataset.qty;
      if(valueFn) valueFn(val);
      /* Sibling IIFE: main `state` isn't in scope here, so check the rule
         against specState and repaint via the utils module directly. */
      if((stateKey==='size'||stateKey==='qty')&&window._smsMOR){
        _smsMOR.bump(specState,stateKey,null);
        _smsMOR.refresh(specState.sizeInches,specState.qty);
      }
      updateSpecsPrice();
    });
  }
  wireGroup('sl2ShapePills', 'shape', function(v){ specState.shape = v; });
  wireGroup('sl2SizePills', 'size', function(v){
    specState.size = v;
    var match = v.match(/(\d+)/);
    specState.sizeInches = match ? parseInt(match[1]) : 2;
  });
  wireGroup('sl2FinishPills', 'finish', function(v){ specState.finish = v; });
  wireGroup('sl2QtyPills', 'qty', function(v){ specState.qty = parseInt(v); });
  startBtn.addEventListener('click', function(){
    var shapeBtn = document.querySelector('.sms-shape-btn[data-shape="'+specState.shape+'"]');
    if(shapeBtn && !shapeBtn.classList.contains('active')) shapeBtn.click();
    var sizeRadio = document.getElementById('sz-'+specState.size);
    if(sizeRadio && !sizeRadio.checked){ sizeRadio.checked = true; sizeRadio.dispatchEvent(new Event('change')); }
    var finishBtn = document.querySelector('.sms-finish-btn[data-finish="'+specState.finish+'"]');
    if(finishBtn && !finishBtn.classList.contains('active')) finishBtn.click();
    var qtyPreset = document.querySelector('.sms-qty-pre[data-qty="'+specState.qty+'"]');
    if(qtyPreset) qtyPreset.click();
    specsScreen.style.display = 'none';
    specsPill.style.display = 'flex';
    updatePillText();
  });
  specsPill.addEventListener('click', function(){
    specsPill.style.display = 'none';
    specsScreen.style.display = 'flex';
    updateSpecsPrice();
  });
  updateSpecsPrice();
  if(window.innerWidth > 768){
    specsScreen.style.display = 'none';
  }
  function clickV1(id){ var el=document.getElementById(id); if(el)el.click(); }
  var sl2Toolbar = document.getElementById('sl2Toolbar');
  if(sl2Toolbar) sl2Toolbar.addEventListener('click', function(e){
    var btn = e.target.closest('.sl2-tb-btn');
    if(!btn) return;
    var id = btn.id;
    if(id === 'sl2TbUpload') clickV1('btnAddImage');
    else if(id === 'sl2TbText') clickV1('btnAddText');
    else if(id === 'sl2TbClipart') clickV1('btnClipart');
    else if(id==='sl2TbCart') window._sl2Cart&&window._sl2Cart();
    else if(id==='sl2Tb3D'){window._sl2Toggle3D&&window._sl2Toggle3D();}
  });
  if(window.innerWidth<=768){
    var zc=document.getElementById('smsZoomControls');
    var shareBtn=document.getElementById('btnShareLink');
    var editorEl=document.querySelector('.sms-editor');
    if(zc && editorEl) editorEl.appendChild(zc);
    if(shareBtn && editorEl) editorEl.appendChild(shareBtn);
  }
  var ctxBar = document.createElement('div');
  ctxBar.className = 'sl2-ctx-bar';
  ctxBar.id = 'sl2CtxBar';
  var ctxParent = (window.innerWidth > 768) ? document.querySelector('.sms-canvas-area') : document.querySelector('.sms-editor');
  (ctxParent || document.querySelector('.sms-editor')).appendChild(ctxBar);
  function buildCtxBar(obj){
    ctxBar.innerHTML = '';
    var isText = obj && obj.type === 'i-text';
    var isMainImg = obj && obj._isMainImage;
    var btns = [];
    if(isText){
      btns.push({label:'Edit Text',icon:'<svg viewBox="0 0 24 24"><path d="M4 7V4h16v3"/><line x1="12" y1="4" x2="12" y2="20"/><path d="M8 20h8"/></svg>',action:'editText',special:true});
    }
    btns.push(
      {label:'Rotate',icon:'<svg viewBox="0 0 24 24"><path d="M1 4v6h6"/><path d="M3.51 15a9 9 0 105.13-9.36L1 10"/></svg>',action:'btnRotate'},
      {label:'Flip',icon:'<svg viewBox="0 0 24 24"><path d="M8 3H5a2 2 0 00-2 2v14c0 1.1.9 2 2 2h3M16 3h3a2 2 0 012 2v14a2 2 0 01-2 2h-3M12 20V4"/></svg>',action:'btnFlip'},
      {label:'Front',icon:'<svg viewBox="0 0 24 24"><rect x="8" y="2" width="13" height="13" rx="2"/><rect x="3" y="9" width="13" height="13" rx="2" fill="none" stroke-dasharray="3 2"/></svg>',action:'smsQbFront'},
      {label:'Undo',icon:'<svg viewBox="0 0 24 24"><path d="M3 10h10a5 5 0 015 5v2M3 10l5-5M3 10l5 5"/></svg>',action:'btnUndo'},
      {label:'Delete',icon:'<svg viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6M10 11v6M14 11v6M8 6V4a1 1 0 011-1h6a1 1 0 011 1v2"/></svg>',action:'btnDelete'}
    );
    btns.forEach(function(b){
      var btn = document.createElement('button');
      btn.className = 'sl2-ctx-btn' + (b.special ? ' sl2-ctx-text' : '');
      btn.innerHTML = b.icon + '<span>' + b.label + '</span>';
      btn.addEventListener('click', function(e){
        e.stopPropagation();
        if(b.action === 'editText'){
          if(window._sl2EditText) window._sl2EditText();
        } else {
          clickV1(b.action);
        }
      });
      ctxBar.appendChild(btn);
    });
  }
  window._sl2ShowCtx = function(obj){
    if(!obj || obj._isCutline || obj._isScissorIcon) return;
    buildCtxBar(obj);
    ctxBar.classList.add('visible');
  };
  window._sl2HideCtx = function(){
    ctxBar.classList.remove('visible');
  };
  var _lastTapTime = 0;
  function attachDoubleTap(){
    var uc = document.querySelector('.upper-canvas');
    if(!uc){ setTimeout(attachDoubleTap, 500); return; }
    function handleDblTap(){
      var now = Date.now();
      if(now - _lastTapTime < 350){
        if(window._sl2EditText) window._sl2EditText();
        _lastTapTime = 0;
      } else {
        _lastTapTime = now;
      }
    }
    uc.addEventListener('touchend', handleDblTap);
    uc.addEventListener('mouseup', handleDblTap);
  }
  attachDoubleTap();
  var tbCutline = document.getElementById('sl2TbCutline');
  if(tbCutline) tbCutline.addEventListener('click', function(){
    var _other = document.getElementById('sl2BgSheet'); if(_other) _other.style.display='none';
    var existing = document.getElementById('sl2CutSheet');
    if(existing){ existing.style.display = existing.style.display==='none'?'flex':'none'; return; }
    var sheet = document.createElement('div');
    sheet.id = 'sl2CutSheet';
    sheet.style.cssText = 'position:fixed;bottom:72px;left:8px;right:8px;display:flex;gap:6px;padding:12px;background:#fff;border-radius:14px;box-shadow:0 4px 20px rgba(0,0,0,0.12);border:1px solid #e5e7eb;z-index:115;justify-content:center;flex-wrap:wrap;';
    var cuts = [
      {label:'Edge',val:'none'},{label:'Small',val:'tight'},{label:'Medium',val:'medium'},{label:'Large',val:'loose'}
    ];
    cuts.forEach(function(c){
      var btn = document.createElement('button');
      btn.textContent = c.label;
      btn.style.cssText = 'flex:1;padding:10px 4px;border:1.5px solid #e5e7eb;background:#fff;color:#444;border-radius:10px;cursor:pointer;font-size:12px;font-weight:700;';
      btn.addEventListener('click', function(){
        var v1btn = document.querySelector('.sms-tool-icon[data-cut="'+c.val+'"]');
        if(v1btn) v1btn.click();
        sheet.style.display='none';
      });
      sheet.appendChild(btn);
    });
    document.querySelector('.sms-editor').appendChild(sheet);
  });
  var tbBg = document.getElementById('sl2TbBg');
  if(tbBg) tbBg.addEventListener('click', function(){
    var _other = document.getElementById('sl2CutSheet'); if(_other) _other.style.display='none';
    var existing = document.getElementById('sl2BgSheet');
    if(existing){ existing.style.display = existing.style.display==='none'?'flex':'none'; return; }
    var sheet = document.createElement('div');
    sheet.id = 'sl2BgSheet';
    sheet.style.cssText = 'position:fixed;bottom:72px;left:8px;right:8px;display:flex;gap:6px;padding:12px;background:#fff;border-radius:14px;box-shadow:0 4px 20px rgba(0,0,0,0.12);border:1px solid #e5e7eb;z-index:115;justify-content:center;';
    var bgs = [
      {label:'None',val:'none'},{label:'Basic',val:'solid'},{label:'Deep',val:'ai'},{label:'AI',val:'pro'}
    ];
    bgs.forEach(function(b){
      var btn = document.createElement('button');
      btn.textContent = b.label;
      btn.style.cssText = 'flex:1;padding:10px 4px;border:1.5px solid #e5e7eb;background:#fff;color:#444;border-radius:10px;cursor:pointer;font-size:12px;font-weight:700;';
      btn.addEventListener('click', function(){
        var v1btn = document.querySelector('.sms-tool-icon[data-bg="'+b.val+'"]');
        if(v1btn) v1btn.click();
        sheet.style.display='none';
      });
      sheet.appendChild(btn);
    });
    document.querySelector('.sms-editor').appendChild(sheet);
  });
})();
(function(){
  function toggle3D(){
    var tb3D = document.getElementById('sl2Tb3D');
    if(!tb3D) return;
    var svg = tb3D.querySelector('svg');
    if(window._sl2GyroActive){
      window._sl2GyroActive = false;
      tb3D.style.color = '';
      if(svg) svg.style.stroke = '';
      var stage = document.getElementById('stickerStage');
      if(stage){
        var zl=window._sl2ZoomLevel||0.85;
        stage.style.transform = 'scale('+zl+') rotateX(0) rotateY(0)';
      }
    } else {
      window._sl2GyroActive = true;
      tb3D.style.color = '#2893F2';
      if(svg) svg.style.stroke = '#2893F2';
      if(typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission === 'function'){
        DeviceOrientationEvent.requestPermission().then(function(p){
          if(p === 'granted'){
            window.addEventListener('deviceorientation', window._sl2HandleGyro, true);
            if(window._sl2RestartGyro) window._sl2RestartGyro();
          } else {
            window._sl2GyroActive = false;
            tb3D.style.color = '';
            if(svg) svg.style.stroke = '';
          }
        }).catch(function(){
          window._sl2GyroActive = false;
          tb3D.style.color = '';
          if(svg) svg.style.stroke = '';
        });
      } else {
        window.addEventListener('deviceorientation', window._sl2HandleGyro, true);
        if(window._sl2RestartGyro) window._sl2RestartGyro();
      }
    }
  }
  window._sl2Toggle3D = toggle3D;
})();
